import { TranslationKey } from './fr';

const translationAr: Record<TranslationKey, string> = {
    'metadata.description': 'لوحة الإدارة الخلفية Innovorder',
    'cookies.banner.message':
        'يستخدم موقعنا الإلكتروني ملفات تعريف الارتباط لتحسين تجربتك. بمواصلة التصفح، فإنك توافق على استخدام هذه الملفات. لمعرفة المزيد عن سياسة الخصوصية وإدارة تفضيلاتك، يرجى الاطلاع على صفحتنا المخصصة لذلك.',
    'cookies.banner.accept': 'قبول',
    'cookies.banner.decline': 'رفض',
    'legend.DELIVERY': 'توصيل',
    'legend.DRIVE': 'Drive',
    'legend.SIT_IN': 'تناول في المكان',
    'legend.TAKE_AWAY': 'طلب خارجي',
    'legend.KIOSK': 'كشك',
    'legend.WEB': 'طلب عبر الإنترنت',
    'legend.RECEPTION': 'الاستقبال',
    'legend.POS': 'نقطة البيع',
    'legend.LOYALTY': 'الولاء',
    'legend.EWALLET_KIOSK': 'كشك المحفظة الإلكترونية',
    'legend.VENDING_MACHINE': 'آلات البيع التلقائي',
    'analyticsPage.needBrandSelection': 'بما أنك مسؤول، يجب عليك تحديد علامة تجارية واحدة على الأقل.',
    'analyticsPage.notAuthorizedToSeeBrand': 'غير مصرح لك بعرض هذه العلامة التجارية.',
    'analyticsPage.cannotMixEducationAndNonEducationBrands':
        'لا يمكنك تحديد علامات تجارية للمطاعم الجماعية والتجارية في آنٍ واحد.',
    'analyticsPage.reload': 'تحديث البيانات',
    'beta_banner.message': '👋 هذه نسخة <b>تجريبية</b>، وستصل العديد من التحسينات والإصلاحات قريبًا.',
    'analytics.metabaseError': 'حدث خطأ، يرجى المحاولة مرة أخرى لاحقًا..',
    'analytics.noAdmin': 'للأسف، IO Analytics غير متاح بعد في وضع الإدارة... لا تقلق، سيكون متاحًا قريبًا!',
    'analytics.realTime': 'الوقت الفعلي',
    'analytics.ranking': 'الترتيب',
    'analytics.products': 'المنتجات',
    'analytics.sales': 'المبيعات',
    'analytics.salesSummary': 'الملخص المالي',
    'analytics.demoStaging': 'عرض توضيحي (مرحلة الاختبار)',
    'analytics.attendance': 'الحضور',
    'analytics.billing': 'الفوترة',
    'analytics.dashboard': 'لوحة تحكم Metabase',
    'analytics.filter.restaurant': 'تصفية حسب المطعم',
    'analytics.filter.group': 'تصفية حسب المجموعة',
    'analytics.filter.consumption': 'نمط الاستهلاك',
    'analytics.filter.channel': 'القنوات',
    'analytics.filter.HT': 'بدون ضريبة',
    'analytics.filter.TTC': 'شامل الضريبة',
    'analytics.filter.takeAway': 'طلب خارجي',
    'analytics.filter.sitIn': 'تناول في المكان',
    'analytics.filter.delivery': 'توصيل',
    'analytics.filter.drive': 'Drive',
    'analytics.filter.kiosk': 'كشك',
    'analytics.filter.web': 'طلب عبر الإنترنت',
    'analytics.filter.pos': 'نقطة البيع',
    'analytics.filter.ubereats': 'Ubereats',
    'analytics.filter.deliveroo': 'Deliveroo',
    'analytics.filter.justeat': 'Justeat',
    'analytics.filter.vendingmachine': 'توزيع تلقائي',
    'leaderboard.title': 'ترتيب المطاعم',
    'leaderboard.ranking': 'الترتيب',
    'leaderboard.restaurantName': 'المطاعم',
    'leaderboard.revenue': 'رقم الأعمال',
    'leaderboard.averageBasket': 'متوسط السلة',
    'leaderboard.ordersCount': 'الطلبات',
    'leaderboard.RestaurantSearchPlaceholder': 'البحث عن مطعم',
    'tile.genericErrorMessage': 'حدث خطأ!',
    'tile.errorHint': 'يرجى تحديث البيانات',
    'random.or': 'أو',
    'tooltip.example.label': 'مثال:',
    'iopay.configuration.title': 'إعدادات Adyen',
    'iopay.commissions.online.title': 'العمولات عبر الإنترنت',
    'iopay.commissions.proximity.title': 'عمولات القرب',
    'iopay.form.name': 'التسمية',
    'iopay.form.placeholder.name': 'التسمية',
    'iopay.form.accountHolder': 'معرّف صاحب الحساب',
    'iopay.form.placeholder.accountHolder': 'AH111222AAABBB',
    'iopay.form.balanceAccount': 'معرّف الحساب المالي',
    'iopay.form.placeholder.balanceAccount': 'BA111222AAABBB',
    'iopay.form.storeId': 'معرّف البائع',
    'iopay.form.placeholder.storeId': 'معرّف البائع',
    'iopay.form.transferInstrumentId': 'معرّف أداة التحويل',
    'iopay.form.placeholder.transferInstrumentId': 'SE111222AAABBB',
    'iopay.form.fixOnlineCommissionAmount': 'مبلغ العمولات الثابتة (بالسنتيم)',
    'iopay.form.fixProximityCommissionAmount': 'مبلغ العمولات الثابتة (بالسنتيم)',
    'iopay.form.placeholder.fixOnlineCommissionAmount': 'مبلغ العمولات الثابتة (بالسنتيم)',
    'iopay.form.placeholder.fixProximityCommissionAmount': 'مبلغ العمولات الثابتة (بالسنتيم)',
    'iopay.form.variableOnlineCommissionPercent': 'نسبة العمولات المتغيرة',
    'iopay.form.variableProximityCommissionPercent': 'نسبة العمولات المتغيرة',
    'iopay.form.placeholder.variableOnlineCommissionPercent': 'نسبة العمولات المتغيرة',
    'iopay.form.placeholder.variableProximityCommissionPercent': 'نسبة العمولات المتغيرة',
    'edenred.configuration.title': 'إعداد وحدة Edenred',
    'edenred.form.description':
        'قم بتكوين تكامل Edenred بإدخال المعلومات المطلوبة. بمجرد الحفظ، سيتم استرداد معرّف التاجر للمطعم تلقائيًا.',
    'edenred.form.warning.toSend': 'المعلومات محفوظة وقابلة للتعديل قبل الإرسال إلى Edenred.',
    'edenred.form.warning.sent': 'جاري المعالجة من قِبل Edenred.',
    'edenred.form.mid': 'معرّف التاجر',
    'edenred.form.name': 'اسم المطعم',
    'edenred.form.placeholder.name': 'اسم مطعمي',
    'edenred.form.siret': 'رقم SIRET',
    'edenred.form.placeholder.siret': '12345678900012',
    'edenred.form.address': 'العنوان',
    'edenred.form.placeholder.address': '5 avenue Anatole France',
    'edenred.form.zipCode': 'الرمز البريدي',
    'edenred.form.placeholder.zipCode': '75007',
    'edenred.form.city': 'المدينة',
    'edenred.form.placeholder.city': 'Paris',
    'paygreen.configuration.title': 'إعداد وحدة قسائم المطاعم',
    'paygreen.form.description':
        'بعد إنشاء حسابك عبر النموذج المتاح أعلاه، ستُرسل إليك المفاتيح العامة والخاصة لإعداد الوحدة.',
    'paygreen.form.ongoing_v3_migration':
        'جاري التحضير لترحيل إصدار Paygreen، ولا يلزمك اتخاذ أي إجراء في لوحة الإدارة',
    'paygreen.form.enablePaygreenV3': 'تفعيل Paygreen V3',
    'paygreen.form.label': 'اسم التكامل',
    'paygreen.form.publicKey': 'V2 المفتاح العام (shopId)',
    'paygreen.form.privateKey': 'V2 المفتاح الخاص (token)',
    'paygreen.form.secretKey': 'V3 المفتاح السري',
    'paygreen.form.shopId': 'V3 معرّف المتجر',
    'paygreen.form.subShopId': 'V3 معرّف المتجر الفرعي (يُملأ فقط في وضع السوق)',
    'paygreen.form.supportsLuncheon': 'الدفع بـ Pass Restaurant (Sodexo) أو Chèque Déjeuner (Up)',
    'paygreen.form.supportsSwile': 'الدفع بـ Swile (سابقًا Lunchr)',
    'paygreen.form.supportsRestoflash': 'الدفع بـ Resto Flash',
    'paygreen.form.placeholder.enablePaygreenV3': 'تفعيل Paygreen V3',
    'paygreen.form.placeholder.label': 'اسم التكامل',
    'paygreen.form.placeholder.publicKey': 'V2 المفتاح العام (shopId)',
    'paygreen.form.placeholder.privateKey': 'V2 المفتاح الخاص (token)',
    'paygreen.form.placeholder.secretKey': 'V3 المفتاح السري',
    'paygreen.form.placeholder.shopId': 'V3 معرّف المتجر',
    'paygreen.form.placeholder.subShopId': 'V3 معرّف المتجر الفرعي (يُملأ فقط في وضع السوق)',
    'paygreen.form.placeholder.supportsLuncheon': 'الدفع بـ Pass Restaurant (Sodexo) أو Chèque Déjeuner (Up)',
    'paygreen.form.placeholder.supportsSwile': 'الدفع بـ Swile (سابقًا Lunchr)',
    'paygreen.form.placeholder.supportsRestoflash': 'الدفع بـ Resto Flash',
    'ubereats.title': 'إعدادات UberEats',
    'ubereats.description.firstpart':
        'قم بتكوين تكامل Ubereats بتحديد مرجع UUID المتاح من واجهة Ubereats الخاصة بمطعمك. إن لم تعرف أين تجد هذه المعلومات:',
    'ubereats.description.secondpart': 'كيف أجد معرّف المتجر لمطعمي؟',
    'ubereats.description.thirdpart': 'بعد الإعداد، ستتلقى نقطة البيع تلقائيًا طلبات Ubereats في قسم التوصيل.',
    'ubereats.storid': 'معرّف المتجر',
    'ubereats.activestorids': 'معرّفات المتاجر النشطة',
    'deliverect.title': 'إعداد وحدة Deliverect',
    'deliverect.subtitle': 'كيف أقوم بإعداد تكاملي مع Deliverect؟',
    'deliverect.description.firstpart': 'يجب عليك أولًا التواصل مع مدير حساب لتتمكن من إنشاء حساب في بيئة Deliverect.',
    'deliverect.description.secondpart':
        'بعد تفعيل هذا الحساب، ستتاح لك إمكانية تفعيل إرسال الطلبات على القنوات التي تختارها مباشرةً من هذه الواجهة.',
    'deliverect.description.thirdpart': 'يمكنك أيضًا مزامنة منتجاتك من الواجهة.',
    'deliverect.contact': 'تواصل مع مدير حساب',
    'deliveroo.title': 'إعداد وحدة Deliveroo',
    'deliveroo.subtitle': 'كيف أقوم بإعداد تكاملي مع Deliveroo؟',
    'deliveroo.description.firstpart': 'يجب عليك أولًا التواصل مع مدير حساب لتتمكن من إنشاء حساب في بيئة Deliveroo.',
    'deliveroo.description.secondpart':
        'بعد تكوين هذا الحساب، ستتلقى نقطة البيع تلقائيًا طلبات Deliveroo في قسم التوصيل.',
    'deliveroo.description.thirdpart': 'يمكنك أيضًا مزامنة منتجاتك من واجهة Deliveroo.',
    'deliveroo.contact': 'تواصل مع مدير حساب',
    'crous.title': 'إعداد وحدة مزامنة الكتالوج CROUS',
    'crous.description':
        'اختر المطعم الذي تريد استيراد كتالوجه وأدخل رقم نقطة البيع الخاص بـ CROUS المُبلَّغ من قِبل العميل (pos_id)',
    'crous.listcrousrestaurants.label': 'مطاعم Crous',
    'crous.listcrousrestaurants.placeholder': 'اختر مطعمًا',
    'crous.numerocaisse.label': 'رقم نقطة البيع لـ Crous',
    'crous.numerocaisse.placeholder': 'يرجى إدخال رقم نقطة البيع لـ Crous',
    'crous.apikey.label': 'مفتاح API لـ Crous',
    'crous.apikey.placeholder': 'يرجى إدخال مفتاح API لـ Crous',
    'marketplace.vatdefault.placeholder': 'ضريبة القيمة المضافة الافتراضية (%)',
    'marketplace.vatdefault.message': 'ضريبة القيمة المضافة الافتراضية',
    'marketplace.storid.label': 'معرّف مواقعك:',
    'marketplace.storid.placeholder': 'أدخل معرّف موقع / معرّفات مواقع',
    'marketplace.storid.unknown': 'معرّف المتجر غير معروف',
    'marketplace.storid.alreadyused': 'هذا UUID موجود بالفعل ({name})',
    'marketplace.activestorids.label': 'العلامات الافتراضية النشطة:',
    'marketplace.activestorids.emptystate': 'لا توجد لديك أي علامة افتراضية نشطة',
    'marketplace.location.title': 'العلامة {counter}',
    'marketplace.location.delete': 'حذف',
    'status.status': 'الحالة',
    'status.active': 'نشط',
    'status.inactive': 'غير نشط',
    'status.disabled': 'غير متاح',
    'status.loading': 'جارٍ التحميل',
    'status.unknown': 'غير معروف',
    'status.new': 'جديد',
    'status.file_uploaded': 'تم رفع الملف',
    'status.processing': 'جارٍ المعالجة',
    'status.done': 'مكتمل',
    'status.error': 'خطأ',
    'date.created': 'تاريخ الإنشاء',
    'date.updated': 'تاريخ التحديث',
    'external_pos.pos_ref.label': 'معرّف POS Deliverect:',
    'external_pos.pos_ref.placeholder': 'أدخل معرّف POS Deliverect الخاص بك',
    'external_pos.title': 'إعداد POS الخارجي Deliverect',
    'external_pos.subtitle': 'كيف أقوم بإعداد POS الخارجي Deliverect؟',
    'external_pos.description.firstpart':
        'يجب عليك أولًا التواصل مع مدير حساب لتتمكن من إنشاء حساب في بيئة Deliverect.',
    'external_pos.description.secondpart':
        'بعد إعداد POS الخارجي Deliverect، سيتلقى الطلبات المُقدَّمة عبر قنوات Innovorder المُفعَّلة.',
    'external_pos.description.thirdpart': 'مع هذا التكامل، نوصيك بإدارة قوائمك ومزامنتها من Deliverect.',
    'external_pos.contact': 'تواصل مع مدير حساب',
    'external_pos.channels.title': 'تكامل POS الخارجي Deliverect:',
    'external_pos.channels.subtitle': 'القنوات النشطة:',
    'webhook_url.label': 'رابط Webhook',
    'webhook_url.placeholder': 'رابط Webhook',
    'webhook_secret.label': 'المفتاح السري لـ Webhook',
    'webhook_secret.placeholder': 'أدخل المفتاح السري لـ Webhook',
    'webhook.headers.label': 'رؤوس HTTP إضافية',
    'webhook.headers.name.placeholder': 'اسم الرأس',
    'webhook.headers.value.placeholder': 'قيمة الرأس',
    'webhook.channels.title': 'قنوات تشغيل Webhook',
    'webhook.channels.subtitle': 'القنوات المتاحة:',
    'webhook.title': 'إعداد Webhook',
    'webhook.firstpart.subtitle': 'دور هذا Webhook',
    'webhook.firstpart.description':
        'دور هذا Webhook هو إعلامك بأن طلبًا قد قُدِّم من قِبل أحد ضيوفك على Innovorder.\nإذا أُجريت عملية بيع لضيف محدد ببطاقة، يُجرى استدعاء على هذا Webhook لإرسال المعلومات اللازمة بشأن هذا الطلب.',
    'webhook.secondpart.subtitle': 'كيف أقوم بإعداد Webhook؟',
    'webhook.secondpart.description':
        'يجب إدخال رابط Webhook.\nيتم توليد المفتاح السري لـ Webhook تلقائيًا.\nما عليك سوى النقر على القنوات التي تريد تفعيلها لهذا Webhook.\nبعد الإعداد، يجب أن تُعيد الخدمة رمز استجابة HTTP 200 مع جسم استجابة فارغ للتأكيد على استلام حدث Webhook.',
    'webhook.documentationLink': 'الاطلاع على توثيق هذا Webhook',
    'webhook.modal.warning': 'تحذير',
    'webhook.modal.confirmDelete': 'هل أنت متأكد من الحذف؟',
    'webhook.channels.kiosk': 'كشك',
    'webhook.channels.web': 'CEL',
    'webhook.channels.pos': 'POS',
    'webhook.channels.trayScan': 'مسح الصينية',
    'webhook.channels.vendingMachine': 'توزيع\nتلقائي',
    'webhook.eventTypes.title': 'أنواع الأحداث',
    'webhook.eventTypes.subtitle': 'أنواع الأحداث المتاحة:',
    'webhook.brand.title': 'إعداد Webhooks',
    'webhook.brand.firstpart.subtitle': 'دور هذا Webhook',
    'webhook.brand.firstpart.description':
        'تتيح لك Webhooks تلقّي إشعارات في الوقت الفعلي عند وقوع أحداث معينة في نظام Innovorder. يمكنك إعداد Webhooks لتُشغَّل بأحداث مختلفة كتحديثات بيانات العملاء وأحداث المعاملات وإشعارات الطلبات. عند وقوع حدث، سيُرسل Innovorder طلب HTTP POST إلى نقطة النهاية المحددة مع البيانات ذات الصلة',
    'webhook.brand.secondpart.subtitle': 'كيف أقوم بإعداد Webhook؟',
    'webhook.brand.secondpart.description':
        '1. أدخل رابط Webhook الذي تريد تلقّي الإشعارات عليه.\n2. حدد أنواع الأحداث التي تريد مراقبتها من بين الخيارات المتاحة.\n3. اختر القنوات التي يجب أن تُشغّل Webhook عند وقوع هذه الأحداث.\n4. أضف رؤوس HTTP إضافية إذا اقتضت نقطة النهاية ذلك.\n5. يتم توليد المفتاح السري لـ Webhook تلقائيًا لأغراض الأمان.\n\nيجب أن تُعيد نقطة النهاية رمز حالة HTTP 200 لتأكيد استلام حدث Webhook.',
    'webhook.system.badge': 'النظام',
    'webhook.system.readonly': 'يُدار هذا Webhook من قِبل النظام ولا يمكن تعديله.',
    'login.panelTitle': 'مرحبًا بك في لوحة الإدارة الخاصة بك',
    'login.login': 'تسجيل الدخول',
    'login.password': 'كلمة المرور',
    'login.ssoChecking': 'جارٍ التحقق من SSO…',
    'login.ssoEnabled': 'تم تفعيل SSO لهذا البريد الإلكتروني.',
    'login.ssoLogin': 'تسجيل الدخول بـ SSO',
    'login.ssoFailed': 'فشل تسجيل الدخول بـ SSO. يرجى المحاولة مرة أخرى.',
    'login.ssoLoginRequired': 'يتطلب هذا الحساب تسجيل الدخول بـ SSO. جارٍ إعادة التوجيه…',
    'login.noBrandsConfigured': 'لم يتم تكوين أي علامة تجارية لهذا المستخدم.',
    'login.guestBrandLoginFailed': 'فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.',
    'login.rememberMe': 'تذكّرني',
    'login.forgotPassword': 'نسيت كلمة المرور؟',
    'login.accountLocked': 'تم تأمين الحساب مؤقتًا. حاول مرة أخرى خلال {minutes} دقيقة.',
    'login.captchaRequired': 'التحقق الأمني مطلوب.',
    'login.ipNotAllowed': 'تسجيل الدخول غير مسموح به من عنوان IP هذا.',
    'login.accountDisabled': 'تم تعطيل هذا الحساب بسبب عدم النشاط.',
    'extendAccount.title': 'تمديد حسابك',
    'extendAccount.loadingBody': 'جارٍ التحقق من الرابط…',
    'extendAccount.successTitle': 'تم تمديد الحساب',
    'extendAccount.successBody': 'تم تمديد حسابك. يمكنك تسجيل الدخول مجددًا الآن.',
    'extendAccount.invalidTitle': 'رابط غير صالح',
    'extendAccount.invalidBody': 'رابط التمديد هذا غير صالح أو انتهت صلاحيته.',
    'extendAccount.expiredHint': 'لاستعادة الوصول إلى حسابك، يُرجى التواصل مع المسؤول.',
    'extendAccount.missingTokenBody': 'الرابط غير مكتمل. يُرجى فتح الرابط مجددًا من بريدك الإلكتروني.',
    'extendAccount.backToLogin': 'العودة إلى تسجيل الدخول',
    'forgotPassword.title': 'نسيت كلمة المرور',
    'forgotPassword.subtitle': 'أدخل بريدك الإلكتروني لاستلام رابط إعادة التعيين.',
    'forgotPassword.submit': 'إرسال الرابط',
    'forgotPassword.backToLogin': 'العودة إلى تسجيل الدخول',
    'forgotPassword.successTitle': 'تم إرسال البريد الإلكتروني',
    'forgotPassword.successMessage':
        'إذا كان حساب موجود لهذا البريد الإلكتروني، فقد تم إرسال رابط إعادة التعيين للتو. تحقق من صندوق الوارد.',
    'forgotPassword.recaptchaLoading': 'جارٍ تحميل reCAPTCHA…',
    'forgotPassword.recaptchaFailed': 'فشل التحقق من reCAPTCHA. يرجى المحاولة مرة أخرى.',
    'forgotPassword.recaptchaUnavailable': 'reCAPTCHA غير متاح. أعد تحميل الصفحة وحاول مرة أخرى.',
    'forgotPassword.recaptchaNotConfigured': 'إعداد مفقود (REACT_APP_RECAPTCHA_SITE_KEY). تواصل مع المسؤول.',
    'resetPassword.title': 'كلمة مرور جديدة',
    'resetPassword.subtitle': 'اختر كلمة مرور جديدة لحسابك.',
    'resetPassword.submit': 'إعادة التعيين',
    'resetPassword.backToLogin': 'العودة إلى تسجيل الدخول',
    'resetPassword.successTitle': 'تم تحديث كلمة المرور',
    'resetPassword.successMessage': 'تم تحديث كلمة مرورك بنجاح. يمكنك الآن تسجيل الدخول.',
    'resetPassword.invalidLinkTitle': 'رابط غير صالح',
    'resetPassword.invalidLink':
        'رابط إعادة التعيين هذا غير صالح أو انتهت صلاحيته. اطلب رابطًا جديدًا من صفحة تسجيل الدخول.',
    'resetPassword.passwordTooShort': 'يجب أن تحتوي كلمة المرور على {min} حروف على الأقل.',
    'resetPassword.passwordsMismatch': 'كلمتا المرور غير متطابقتين.',
    'mfa.verify.title': 'التحقق بخطوتين',
    'mfa.verify.subtitle': 'أدخل الرمز المكوّن من 6 أرقام الذي ولّدته تطبيق المصادقة الخاص بك.',
    'mfa.verify.backupTitle': 'رمز الاسترداد',
    'mfa.verify.backupSubtitle': 'أدخل أحد رموز الاسترداد الخاصة بك للاستخدام لمرة واحدة.',
    'mfa.verify.submit': 'تحقق',
    'mfa.verify.useBackupInstead': 'استخدام رمز استرداد بدلًا من ذلك',
    'mfa.verify.useTotpInstead': 'استخدام تطبيق المصادقة',
    'mfa.verify.useDifferentMethod': 'استخدام طريقة أخرى',
    'mfa.verify.chooser.title': 'اختر طريقة',
    'mfa.verify.chooser.subtitle': 'ما الطريقة التي تريد استخدامها للتحقق من هويتك؟',
    'mfa.verify.chooser.webauthnHint': 'استخدم مفتاح الأمان أو المقاييس الحيوية.',
    'mfa.verify.chooser.totpHint': 'أدخل الرمز من تطبيق المصادقة الخاص بك.',
    'mfa.verify.failed': 'رمز غير صالح. يرجى المحاولة مرة أخرى.',
    'mfa.verify.tokenExpired': 'انتهت صلاحية جلسة MFA. يرجى تسجيل الدخول مجددًا.',
    'mfa.verify.tabs.totp': 'تطبيق المصادقة',
    'mfa.verify.tabs.webauthn': 'مفتاح الأمان / المقاييس الحيوية',
    'mfa.verify.webauthn.title': 'التحقق باستخدام مفتاح الأمان',
    'mfa.verify.webauthn.subtitle': 'المس مفتاح الأمان، أو استخدم Touch ID أو مصادقًا آخر للنظام.',
    'mfa.verify.webauthn.authenticate': 'مصادقة',
    'mfa.verify.webauthn.failed': 'فشلت المصادقة. يُرجى تجربة طريقة أخرى.',
    'mfa.verify.webauthn.noCredentials': 'لا يوجد مفتاح أمان مُسجَّل لهذا الحساب.',
    'mfa.verify.webauthn.ceremonyFailed': 'تم إلغاء المصادقة أو رفضها المتصفح. يُرجى المحاولة مرة أخرى.',
    'mfa.setup.title': 'إعداد المصادقة الثنائية',
    'mfa.setup.subtitle':
        'امسح رمز QR هذا بتطبيق المصادقة الخاص بك (Google Authenticator، 1Password، إلخ.) ثم أدخل الرمز الذي تم توليده.',
    'mfa.setup.loadingQr': 'جارٍ تحميل رمز QR...',
    'mfa.setup.copySecret': 'نسخ المفتاح السري',
    'mfa.setup.copied': 'تم النسخ!',
    'mfa.setup.confirm': 'تأكيد',
    'mfa.setup.invalidCode': 'رمز غير صالح. تحقق من تزامن تطبيقك.',
    'mfa.setup.backupTitle': 'احفظ رموز الاسترداد الخاصة بك',
    'mfa.setup.backupSubtitle':
        'احتفظ بهذه الرموز في مكان آمن. ستتيح لك تسجيل الدخول إذا فقدت الوصول إلى تطبيق المصادقة. يمكن استخدام كل رمز مرة واحدة فقط.',
    'mfa.setup.backupAcknowledge': 'لقد حفظت رموزي، المتابعة',
    'mfa.setup.tabs.totp': 'تطبيق المصادقة',
    'mfa.setup.tabs.webauthn': 'مفتاح الأمان / المقاييس الحيوية',
    'mfa.setup.webauthn.title': 'تسجيل مفتاح أمان',
    'mfa.setup.webauthn.subtitle':
        'استخدم مفتاحًا ماديًا (YubiKey) أو Touch ID أو Windows Hello أو مصادقًا آخر. يمكنك تسمية هذا الجهاز لتمييزه لاحقًا.',
    'mfa.setup.webauthn.deviceNamePlaceholder': "اسم الجهاز (مثل: 'حاسوبي المحمول')",
    'mfa.setup.webauthn.register': 'تسجيل',
    'mfa.setup.webauthn.ceremonyFailed': 'تم إلغاء التسجيل أو رفضه المتصفح. يُرجى المحاولة مرة أخرى.',
    'mfa.setup.webauthn.finalizing': 'جارٍ إكمال إعداد مفتاح الأمان…',
    'activateAccount.title': 'تفعيل الحساب',
    'activateAccount.submit': 'تفعيل حسابي',
    'activateAccount.submitting': 'جارٍ التفعيل...',
    'activateAccount.loading': 'جارٍ التحقق من الرمز...',
    'activateAccount.resend': 'إعادة إرسال بريد التفعيل',
    'activateAccount.resending': 'جارٍ إعادة الإرسال...',
    'activateAccount.renewSuccess': 'تم إرسال بريد تفعيل جديد. يرجى التحقق من صندوق الوارد.',
    'activateAccount.error.missingToken': 'الرمز مفقود',
    'activateAccount.error.invalidToken': 'انتهت صلاحية الرمز',
    'activateAccount.error.password.minLength': 'يجب أن تحتوي كلمة المرور على {min} حروف على الأقل',
    'activateAccount.error.password.maxLength': 'يجب ألا تتجاوز كلمة المرور {max} حرفًا',
    'activateAccount.error.password.requireUppercase': 'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل',
    'activateAccount.error.password.requireLowercase': 'يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل',
    'activateAccount.error.password.requireNumbers': 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل',
    'activateAccount.error.password.requireSpecialCharacters': 'يجب أن تحتوي كلمة المرور على رمز خاص واحد على الأقل',
    'activateAccount.password.placeholder': 'كلمة المرور',
    'activateAccount.confirmPassword.placeholder': 'تأكيد كلمة المرور',
    'sidebar.overview': 'نظرة عامة',
    'sidebar.orders': 'الطلبات',
    'sidebar.customers': 'العملاء',
    'sidebar.brand': 'العلامة التجارية',
    'sidebar.brands': 'العلامات التجارية',
    'sidebar.restaurants': 'المطاعم',
    'sidebar.loyalty': 'الولاء',
    'sidebar.coupons': 'رموز الخصم',
    'sidebar.paymentMeans': 'وسائل الدفع',
    'sidebar.integrations': 'التكاملات',
    'sidebar.reports': 'التقارير',
    'sidebar.reportsSales': 'المبيعات',
    'sidebar.reportsEwallets': 'أرصدة البطاقات',
    'sidebar.monthly_sales_report': 'تقرير المبيعات الشهري',
    'sidebar.exports': 'التصدير',
    'sidebar.exportsAccounting': 'المحاسبة',
    'sidebar.exportsEwallets': 'المحفظة الإلكترونية',
    'sidebar.exportsSales': 'الملخص المالي',
    'sidebar.salesSummary': 'الملخص المالي',
    'sidebar.exportsPreInvoicing': 'ما قبل الفوترة',
    'sidebar.exportsBadge': 'حركات البطاقات',
    'sidebar.reportGenerationsHistory': 'سجل الإنشاءات',
    'sidebar.help': 'هل تحتاج مساعدة؟',
    'sidebar.languages': 'اللغات',
    'sidebar.account': 'حسابي',
    'sidebar.media': 'الوسائط',
    'sidebar.marketplaces': 'الأسواق',
    'sidebar.urssaf': 'الحد الأدنى Urssaf',
    'sidebar.vatRatesMatrix': 'مرجع ضريبة القيمة المضافة',
    'sidebar.autoBilling': 'الفوترة التلقائية',
    'sidebar.logout': 'تسجيل الخروج',
    'sidebar.password': 'كلمة مروري',
    'sidebar.security': 'الأمان',
    'security.title': 'الأمان',
    'security.loading': 'جارٍ التحميل…',
    'security.actions.remove': 'حذف',
    'security.actions.cancel': 'إلغاء',
    'security.totp.title': 'تطبيق المصادقة',
    'security.totp.subtitle': 'رموز ذات استخدام واحد يولّدها تطبيق مثل Google Authenticator أو 1Password.',
    'security.totp.label': 'تطبيق المصادقة',
    'security.totp.added': 'أُضيف في {date}',
    'security.totp.empty': 'لا يوجد تطبيق مصادقة مُعدّ.',
    'security.totp.add': 'إضافة تطبيق مصادقة',
    'security.totp.modalTitle': 'إعداد تطبيق مصادقة',
    'security.totp.confirmRemove': 'هل أنت متأكد من رغبتك في إزالة تطبيق المصادقة الخاص بك؟',
    'security.passkeys.title': 'مفاتيح الأمان وPasskeys',
    'security.passkeys.subtitle': 'مفاتيح مادية وTouch ID وWindows Hello ومصادقون آخرون مسجَّلون في هذا الحساب.',
    'security.passkeys.empty': 'لا توجد مفاتيح أمان مسجَّلة.',
    'security.passkeys.unnamedDevice': 'جهاز بدون اسم',
    'security.passkeys.lastUsed': 'آخر استخدام: {date}',
    'security.passkeys.added': 'أُضيف في {date}',
    'security.passkeys.add': 'إضافة مفتاح أمان',
    'security.passkeys.confirmRemove':
        'هل أنت متأكد من رغبتك في إزالة هذا المفتاح؟ لن تتمكن بعدها من تسجيل الدخول بهذا الجهاز.',
    'security.passkeys.ceremonyFailed': 'تم إلغاء التسجيل أو رفضه المتصفح. يُرجى المحاولة مرة أخرى.',
    'security.passkeys.requestFailed': 'حدث خطأ. يُرجى المحاولة مرة أخرى.',
    'security.allowedIps.title': 'عناوين IP المسموح بها',
    'security.allowedIps.subtitle':
        'قم بتقييد تسجيل الدخول الخاص بك بقائمة من عناوين IP أو نطاقات CIDR. تتجاوز عناوين IP المسموح بها أيضًا CAPTCHA وعدادات الحظر.',
    'security.allowedIps.empty': 'لا توجد قيود. يمكنك تسجيل الدخول من أي عنوان IP.',
    'security.allowedIps.add': 'إضافة',
    'security.allowedIps.placeholder': '192.168.1.1 أو 10.0.0.0/24',
    'security.allowedIps.invalid': 'عنوان IP أو نطاق CIDR غير صالح.',
    'security.allowedIps.confirmRemoveTitle': 'إزالة عنوان IP هذا؟',
    'security.allowedIps.confirmRemove': 'لن يُسمح لهذا العنوان بعد الآن بتسجيل الدخول إلى حسابك.',
    'security.allowedIps.cancel': 'إلغاء',
    'security.allowedIps.warning':
        'تحذير: ما دامت القائمة تحتوي على إدخال واحد على الأقل، لن تتمكن من تسجيل الدخول من أي عنوان IP آخر.',
    'sidebar.billing': 'مساحة الفوترة الخاصة بي',
    'sidebar.ioPay': 'المدفوعات',
    'sidebar.news': 'المستجدات',
    'sidebar.analytics': 'التحليلات',
    'message.message': 'رسالة',
    'name.name': 'الاسم',
    'name.firstName': 'الاسم الأول',
    'name.lastName': 'اسم العائلة',
    'notFound.message': 'عذرًا، الصفحة التي تبحث عنها غير موجودة.',
    'notFound.backToHome': 'العودة إلى الصفحة الرئيسية',
    'permissionDenied.title': 'الوصول مرفوض',
    'permissionDenied.message': 'نأسف، لكنك لا تملك إذن الوصول إلى هذه الصفحة.',
    'permissionDenied.backToHome': 'العودة إلى الصفحة الرئيسية',
    'errorPage.message': 'نأسف، نواجه صعوبة تقنية. نعمل على حل هذه المشكلة!',
    'errorPage.support': 'تواصل مع الدعم الفني',
    'file.noFile': 'لا يوجد ملف',
    'file.cannotProcessJson': 'لا يمكن معالجة ملف JSON. تحقق من تنسيقه.',
    'file.fileNotAllowed': 'نوع الملف هذا غير مسموح به. الامتدادات المسموح بها: {allowedExtensionsString}',
    'file.fileTemplate': 'نموذج الملف',
    'file.metabaseLink': 'رابط Metabase',
    'fileInput.placeholder.title': 'أدرج ملفاتك!',
    'fileInput.placeholder.drop': 'أفلت ملفاتك هنا!',
    'fileInput.placeholder': 'اسحب وأفلت ملفًا أو ملفات في النافذة',
    'fileInput.browse': 'استيراد من جهاز الكمبيوتر',
    'imageInput.section.modal.title': 'إضافة صورة',
    'imageInput.section.modal.resize.label': 'وضع صورة الخلفية',
    'imageInput.section.modal.resize.details':
        'استخدم هذا الخيار عند إرسال صور ستُستخدم كخلفية للأكشاك أو الطلب عبر الإنترنت.',
    'imageInput.section.library.title': 'من المعرض',
    'imageInput.section.upload.title': 'من جهاز الكمبيوتر',
    'languages.fr_FR': 'الفرنسية',
    'languages.en_EN': 'الإنجليزية',
    'languages.it_IT': 'الإيطالية',
    'languages.sodexo_SODEXO': 'Sodexo',
    'languages.es_ES': 'الإسبانية',
    'languages.zh-CN_ZH-CN': 'الصينية (المبسطة)',
    'languages.zh-TW_ZH-TW': 'الصينية (التقليدية)',
    'languages.ar_AR': 'العربية',
    'languages.de_DE': 'الألمانية',
    'button.add': 'إضافة',
    'button.delete': 'حذف',
    'button.edit': 'تعديل',
    'button.configure': 'تكوين',
    'button.cancel': 'إلغاء',
    'button.close': 'إغلاق',
    'button.generate': 'توليد',
    'button.save': 'حفظ',
    'button.import': 'استيراد',
    'button.publish': 'نشر',
    'button.saveAndPublish': 'حفظ ونشر',
    'button.uploadFile': 'رفع ملف',
    'button.previous': 'السابق',
    'button.next': 'التالي',
    'button.ok': 'موافق',
    'button.validate': 'تأكيد',
    'button.refresh': 'تحديث',
    'button.confirm': 'تأكيد',
    'button.yes': 'نعم',
    'button.understand': 'فهمت',
    'button.convertToCrossSell': 'تحويل إلى بيع مكمّل',
    'button.convertToCustomization': 'تحويل إلى تخصيص',
    'button.skipStep': 'تخطي هذه الخطوة',
    'button.block': 'حجب',
    'button.unblock': 'إلغاء الحجب',
    'select.selectAll': 'تحديد الكل',
    'switch.activate': 'تفعيل',
    'form.preventLeave': 'لديك تعديلات غير محفوظة، هل أنت متأكد من مغادرة هذه الصفحة؟',
    'field.required': 'هذا الحقل مطلوب',
    'field.optional': '(اختياري)',
    'field.greaterThanZero': 'يجب أن يكون هذا الحقل أكبر من 0',
    'field.invalidEmail': 'هذا البريد الإلكتروني غير صالح',
    'field.invalidURL': 'هذا الرابط غير صالح',
    'field.atLeastOneEventType': 'يجب تحديد نوع حدث واحد على الأقل',
    'field.unmatchedPassword': 'يجب أن تتطابق كلمتا المرور',
    'field.invalidPassword': 'يجب أن تحتوي كلمة مرورك على 8 أحرف على الأقل',
    'field.invalidPhoneNumber': 'رقم الهاتف غير صالح',
    'field.duplicate_email': 'هذا البريد الإلكتروني موجود بالفعل',
    'field.duplicate_student_number': 'رقم هذا الضيف موجود بالفعل',
    'field.duplicate_badge_number': 'رقم هذه البطاقة موجود بالفعل',
    'field.minTwo': 'يجب أن يحتوي هذا الحقل على حرفين على الأقل',
    'field.ewallet_is_not_null_to_postpayment': 'لتحويل الضيف إلى نوع حساب ما بعد الدفع، يجب أن يكون رصيده 0€ بالضرورة',
    'select.enabled': 'مُفعَّل',
    'select.customised': 'مخصَّص',
    'select.disabled': 'معطَّل',
    'table.search': 'بحث',
    'table.searchColumn': 'البحث في {name}',
    'table.searchColumn.placeholder': 'البحث عن قيمة',
    'table.searchColumn.placeholder.from': 'الحد الأدنى',
    'table.searchColumn.placeholder.to': 'الحد الأقصى',
    'table.searchColumn.clearFilter': 'إزالة الفلاتر',
    'table.clearAllFilters': 'إزالة جميع الفلاتر',
    'table.rowsPerPage': 'صفوف لكل صفحة',
    'table.firstPage': 'الأولى',
    'table.lastPage': 'الأخيرة',
    'table.noRowsAfterFilter': 'لا توجد نتائج تطابق بحثك',
    'table.noRowsAfterFilter.dateRangeHint': 'هل حاولت تغيير نطاق التاريخ؟',
    'table.noRowsAfterFilter.dateRangePresetHint': 'لا توجد نتائج خلال الـ {days} أيام الماضية.',
    'table.noRowsAfterFilter.dateRangeCustomHint': 'لا توجد نتائج للفترة المحددة.',
    'table.noRowsAfterFilter.dateRangeAction': 'عدّل نطاق التواريخ لعرض الطلبات.',
    'table.sort': 'الترتيب حسب {name}',
    'table.columnSelection.button': 'إدارة الأعمدة',
    'table.columnSelection.buttonFiltered': 'إدارة الأعمدة ({count})',
    'table.columnSelection.header': 'تصفية الأعمدة',
    'table.columnSelection.placeholder': 'البحث عن عمود',
    'table.columnSelection.allEntries': 'جميع الأعمدة',
    'table.selection.count':
        '{count, plural, =1 {صف واحد محدد} two {صفان محددان} few {# صفوف محددة} other {# صفًا محددًا}}',
    'table.empty': 'لا توجد بيانات متاحة',
    'pagination.previous': 'السابق',
    'pagination.next': 'التالي',
    'navigation.back': 'رجوع',
    'navigation.next': 'التالي',
    'navigation.disabled': 'رجوع',
    'navigation.backToV1': 'العودة إلى الإصدار القديم',
    'savingBar.changesDone': '{changesCount, plural, =0 {} one {# تعديل تم} other {# تعديلات تمت}}',
    'ticketLabel.name.mismatch.confirmation':
        'تحذير: تم تغيير اسم المنتج، لكن تسمية الإنتاج ظلت كما هي. هل تؤكد هذا التغيير؟',
    'form.validation.integer': 'يجب أن يكون هذا الحقل عددًا صحيحًا',
    'form.validation.positive': 'يجب أن يكون هذا الحقل موجبًا',
    'form.validation.positiveOrZero': 'يجب أن يكون هذا الحقل موجبًا أو يساوي صفرًا',
    'form.validation.length': 'يجب أن يحتوي هذا الحقل على {length} حرفًا',
    'form.validation.maxLength': 'تجاوز هذا الحقل الحجم المسموح به',
    'form.validation.email': 'يجب أن يكون هذا الحقل بريدًا إلكترونيًا صالحًا',
    'form.validation.mustMatchValue': 'يجب أن يكون هذا الحقل {value1} أو {value2 }',
    'form.validation.siret.length': 'يجب أن يتكوّن رقم SIRET من 14 حرفًا (بدون مسافات)',
    'form.validation.siret.invalid': 'رقم SIRET غير صالح',
    'integrations.section.title': 'حلول الدفع',
    'integrations.section.subtitle':
        'تتيح لك حلول الدفع تقديم ميزات كالدفع عبر الإنترنت ببطاقة مصرفية أو على الطرفية في نقاط البيع.',
    'integrations.stripe': 'Stripe',
    'integrations.stripeDescription':
        'ادمج Stripe في موقعك وامنح عملاءك إمكانية ربط حساباتهم بسهولة لتجربة طلب مثالية عبر الإنترنت.',
    'integrations.configured': 'مُكوَّن',
    'integrations.notConfigured': 'غير مُكوَّن',
    'integrations.webhooks.title': 'Webhooks',
    'integrations.webhooks.description':
        'جميع تكاملات Webhook المختلفة مُدرجة هنا. يمكن إنشاء Webhook جديد بالنقر على زر "+" أو تعديل Webhook موجود بالنقر عليه. تتيح حالة ما تصوّر وضع الإعداد.',
    'pricingRule.emptyMessage': 'لا توجد أنظمة تعريفية مرتبطة بهذه العلامة التجارية.',
    'pricingRule.tableCard.title': 'الأنظمة التعريفية',
    'pricingRule.tableCard.subtitle':
        'الأنظمة التعريفية هي مجموعات من إذن دخول واحد أو أكثر وإعانات ومكوّنات خارج رقم الأعمال.',
    'pricingRule.tableCard.description':
        'إذا كان النظام التعريفي يحتوي على إعانة بنسبة مئوية وإعانة بالأورو، فضع الإعانة التي يجب خصمها من إجمالي مبلغ الطلب في المرتبة الأولى. ستنطبق الإعانات التالية على المبلغ المتبقي للدفع بعد خصم الإعانات السابقة.',
    'pricingRule.tableCard.action': '+ إنشاء نظام تعريفي جديد',
    'pricingRule.code': 'الرمز',
    'pricingRule.applyScope': 'الاستراتيجية',
    'pricingRule.strategy': 'الاستراتيجية',
    'pricingRule.labelTicket': 'تسمية التذكرة',
    'pricingRule.grants_fees.amount': 'المبلغ',
    'pricingRule.grants_fees.dailyLimit': 'الحد اليومي',
    'pricingRule.grants': 'الإعانات',
    'pricingRule.entranceFees': 'رسوم الدخول',
    'pricingRule.excludedTurnover': 'خارج رقم الأعمال',
    'pricingRule.associatedPricingRules': 'الأنظمة التعريفية المرتبطة',
    'pricingRule.action': 'إجراء',
    'pricingRule.product': 'الحصة الغذائية',
    'pricingRule.fee': 'الرسوم بما فيها حق الدخول',
    'pricingRule.modal.warning': 'تحذير',
    'pricingRule.modal.required': 'حقل «النظام التعريفي» إلزامي',
    'pricingRule.modal.confirmDelete': 'هل أنت متأكد من الحذف؟',
    'pricingRule.modal.delete.error.detail': 'هذا النظام التعريفي مرتبط بضيف واحد أو أكثر',
    'pricingRule.modal.unassociatedUser': 'لن يكون للضيف نظام تعريفي بعد الآن',
    'pricingRule.modal.unassociatedUsers': 'لن يكون للضيوف نظام تعريفي بعد الآن',
    'pricingRule.form.title': 'النظام التعريفي',
    'pricingRule.form.description': 'قم بتكوين النظام التعريفي بتجميع الإعانات الموجودة التي تختارها.',
    'pricingRule.form.creation': 'إنشاء نظام تعريفي',
    'pricingRule.form.update': 'تعديل نظام تعريفي',
    'pricingRule.form.pricingRuleCode': 'رمز النظام التعريفي',
    'pricingRule.form.applyScope': 'الاستراتيجية',
    'pricingRule.form.authorizedChannels': 'القنوات المسموح بها',
    'pricingRule.form.isUrssafEnabled': 'تطبيق الحد الأدنى URSSAF على هذا النظام التعريفي؟',
    'pricingRule.form.composition': 'حدد تركيبة هذا النظام التعريفي',
    'pricingRule.form.compositionDescription':
        'الأنظمة التعريفية هي مجموعات من إذن دخول واحد أو أكثر وإعانات ومكوّنات خارج رقم الأعمال.',
    'pricingRule.emptyGrant': 'لا توجد إعانة مرتبطة بهذا النظام التعريفي.',
    'pricingRule.emptyEntranceFee': 'لا يوجد رسم دخول مرتبط بهذا النظام التعريفي.',
    'pricingRule.emptyTurnoverExcluded': 'لا يوجد مكوّن خارج رقم الأعمال مرتبط بهذا النظام التعريفي.',
    'pricingRule.emptyAssociatedPricingRule': 'لا يوجد نظام تعريفي مرتبط بهذا النظام التعريفي.',
    'pricingRule.noResult': 'لا توجد نتائج',
    'pricingRule.addGrant': 'إضافة إعانة',
    'pricingRule.addEntranceFee': 'إضافة رسم دخول',
    'pricingRule.addComponentWithoutTurnover': 'إضافة مكوّن خارج رقم الأعمال',
    'pricingRule.addAssociatedPricingRule': 'إضافة نظام تعريفي مرتبط',
    'pricingRule.search': 'البحث عن نظام تعريفي',
    'pricingRule.channels.kiosk': 'كشك',
    'pricingRule.channels.pos': 'نقطة البيع',
    'pricingRule.channels.web': 'طلب عبر الإنترنت',
    'pricingRule.channels.ewalletKiosk': 'كشك الشحن',
    'pricingRule.channels.vendingMachine': 'توزيع تلقائي',
    'pricingRule.action.import': 'استيراد',
    'pricingRule.action.export': 'تصدير',
    'pricingRule.modal.import.title': 'استيراد رسوم الدخول والإعانات والأنظمة التعريفية',
    'pricingRule.modal.import.firstPart': 'تنزيل {fileTemplate} على جهاز الكمبيوتر',
    'pricingRule.modal.import.secondPart':
        'ملء نموذج الملف بمعلومات رسوم الدخول والإعانات والأنظمة التعريفية المراد إضافتها أو تعديلها',
    'pricingRule.modal.import.thirdPart': 'استيراد ملفك الجديد بالنقر على الزر أدناه',
    'pricingRule.modal.import.warning': 'يتم حذف رسم الدخول أو الإعانة أو النظام التعريفي من لوحة إدارة Innovorder فقط',
    'pricingRule.modal.import.secondWarning':
        '⚠️\nاستيراد رسوم الدخول أو الإعانات يحذف القيم المخصصة نهائيًا. \n(القيم المخصصة حسب المطعم أو الخدمة)\n',
    'pricingRule.modal.import.report.title': 'تقرير الاستيراد',
    'pricingRule.modal.import.report.result': 'نتيجة الاستيراد',
    'pricingRule.modal.import.report.success': 'نجاح',
    'pricingRule.modal.import.report.error': 'فشل',
    'pricingRule.modal.import.report.warning': 'تنبيه',
    'pricingRule.modal.import.report.entranceFees': 'رسوم الدخول',
    'pricingRule.modal.import.report.grants': 'الإعانات',
    'pricingRule.modal.import.report.pricingRules': 'الأنظمة التعريفية',
    'pricingRule.modal.import.report.successMessage': '• إنشاء: {created}\n • تعديل: {updated}',
    'pricingRule.modal.import.report.errorMessage': '• السطر {line} - {field}: {message}',
    'pricingRule.export.report.entranceFee.entranceFeeId': 'معرّف رسم الدخول',
    'pricingRule.export.report.entranceFee.code': 'رمز رسم الدخول',
    'pricingRule.export.report.entranceFee.labelTicket': 'تسمية التذكرة',
    'pricingRule.export.report.entranceFee.amount': 'المبلغ (باليورو)',
    'pricingRule.export.report.entranceFee.dailyLimit': 'الحد اليومي',
    'pricingRule.export.report.entranceFee.strategy': 'الاستراتيجية (1 دائمًا / 2 للحد اليومي + المنتج المخصص)',
    'pricingRule.export.report.entranceFee.vat': 'ضريبة القيمة المضافة',
    'pricingRule.export.report.entranceFee.type': 'رقم الأعمال (مشمول/مستبعد)',
    'pricingRule.export.report.entranceFee.type.admissionfee': 'مشمول',
    'pricingRule.export.report.entranceFee.type.royaltyfee': 'مستبعد',
    'pricingRule.export.report.entranceFee.active': 'نشط على جميع المطاعم افتراضيًا (نعم / لا) (يخص الإنشاء فقط)',
    'pricingRule.export.report.grant.grantId': 'معرّف الإعانة',
    'pricingRule.export.report.grant.code': 'رمز الإعانة',
    'pricingRule.export.report.grant.labelTicket': 'تسمية التذكرة',
    'pricingRule.export.report.grant.threshold': 'عتبة التشغيل باليورو (فارغة إذا لم تكن موجودة)',
    'pricingRule.export.report.grant.type': 'نوع المبلغ (مطلق / نسبة مئوية)',
    'pricingRule.export.report.grant.type.absolute': 'مطلق',
    'pricingRule.export.report.grant.type.rate': 'نسبة مئوية',
    'pricingRule.export.report.grant.ceiling': 'سقف الإعانة باليورو (إلزامي إذا كان النوع = نسبة مئوية)',
    'pricingRule.export.report.grant.amount': 'المبلغ (باليورو)',
    'pricingRule.export.report.grant.dailyLimit': 'الحد اليومي',
    'pricingRule.export.report.grant.strategy':
        'الاستراتيجية (1 للحد اليومي + المبلغ / 2 للحد اليومي + المبلغ + المنتجات المخصصة)',
    'pricingRule.export.report.grant.tag': 'الوسوم (فارغة إذا لم تكن هناك تطبيقات على وسم)',
    'pricingRule.export.report.grant.active': 'نشط على جميع المطاعم افتراضيًا (نعم / لا)',
    'pricingRule.export.report.pricingRule.pricingRuleId': 'معرّف النظام التعريفي',
    'pricingRule.export.report.pricingRule.code': 'رمز النظام التعريفي',
    'pricingRule.export.report.pricingRule.canals':
        'القنوات (نقطة البيع، كشك الشحن، التوزيع التلقائي، الكشك و/أو الطلب عبر الإنترنت)',
    'pricingRule.export.report.pricingRule.isUrssafEnabled':
        'تطبيق الحد الأدنى URSSAF (لواجهة برمجة سلة التسوق فقط)؟ (نعم/لا)',
    'pricingRule.export.report.pricingRule.entranceFees':
        'رسوم الدخول المشمولة (أدخل الرمز وإن كانت متعددة افصلها بفاصلة + مسافة)',
    'pricingRule.export.report.pricingRule.grants':
        'الإعانات المشمولة (أدخل الرمز وإن كانت متعددة افصلها بفاصلة + مسافة)',
    'pricingRule.export.report.pricingRule.includeCA': 'خارج رقم الأعمال المشمولة',
    'pricingRule.export.report.pricingRule.applyScope': 'الاستراتيجية (الرسوم بما فيها حق الدخول و/أو الحصة الغذائية)',
    'pricingRule.export.report.pricingRule.applyScope.product': 'الحصة الغذائية',
    'pricingRule.export.report.pricingRule.applyScope.fee': 'الرسوم بما فيها حق الدخول',
    'entranceFee.create': 'إنشاء رسم دخول',
    'entranceFee.title': 'رسم الدخول',
    'entranceFee.description': 'أدخل الاسم والمبلغ وقواعد رسم الدخول لجميع مؤسساتك.',
    'entranceFee.customUse': 'تطبيقات خاصة لرسم الدخول',
    'entranceFee.descCustomUse': 'التفعيل والتخصيص حسب المطعم لرسم الدخول',
    'entranceFee.warningForm': 'تأكد من إكمال جميع حقول رسم الدخول قبل تفعيله على مطاعمك.',
    'entranceFee.default': 'افتراضي',
    'entranceFee.code': 'رمز رسم الدخول',
    'entranceFee.codeAlreadyUsed': 'رمز رسم الدخول مستخدم بالفعل',
    'entranceFee.labelTicket': 'تسمية التذكرة',
    'entranceFee.amount': 'المبلغ',
    'entranceFee.vat': 'ضريبة القيمة المضافة',
    'entranceFee.strategy': 'الاستراتيجية',
    'entranceFee.dailyLimit': 'الحد اليومي',
    'entranceFee.type': 'رقم الأعمال',
    'entranceFee.select.always': 'الحد اليومي',
    'entranceFee.select.daily': 'الحد اليومي + المنتج المخصص',
    'entranceFee.select.salesExcluded': 'مستبعد',
    'entranceFee.select.salesIncluded': 'مشمول',
    'entranceFee.emptyMessage': 'لا توجد رسوم دخول مرتبطة بهذه العلامة التجارية.',
    'entranceFee.table.state': 'حالة التفعيل',
    'entranceFee.table.services': 'الخدمات المفعَّلة',
    'entranceFee.table.state.enabled': 'مُفعَّل',
    'entranceFee.table.state.customised': 'مُفعَّل بقيم مخصصة',
    'entranceFee.table.state.disabled': 'معطَّل',
    'entranceFee.tableCard.title': 'رسوم الدخول',
    'entranceFee.tableCard.subtitle': 'أنشئ وأدِر رسوم الدخول المختلفة المستخدمة في مطاعمك',
    'entranceFee.tableCard.action': '+ إنشاء رسم دخول جديد',
    'entranceFee.restaurants': 'المطاعم',
    'entranceFee.restaurant': 'المطعم',
    'entranceFee.action': 'إجراء',
    'entranceFee.modal.warning': 'تحذير',
    'entranceFee.modal.confirmDelete': 'هل أنت متأكد من الحذف؟',
    'entranceFee.search': 'البحث عن رسم دخول',
    'entranceFee.configuration.title': 'تطبيق خاص لرسم الدخول - {name}',
    'entranceFee.configuration.header.title': 'إدارة خدمات هذا المطعم',
    'entranceFee.configuration.search': 'البحث عن خدمة',
    'entranceFee.configuration.table.activation': 'التفعيل',
    'entranceFee.configuration.table.name': 'اسم الخدمة',
    'entranceFee.configuration.table.time': 'المواعيد',
    'entranceFee.configuration.table.days': 'الفترة',
    'entranceFee.configuration.table.amount': 'المبلغ',
    'entranceFee.configuration.table.vat': 'ضريبة القيمة المضافة',
    'entranceFee.configuration.table.defaultShift': 'الخدمة الافتراضية',
    'entranceFee.warningShifts.title': 'تأكيد التعديل',
    'entranceFee.warningShifts.shift': 'الخدمة: {time} - المبلغ: {amount} - الفرق: {variation}',
    'entranceFee.warningShifts.shift.amount': '\nمبلغ رسم الدخول: {amount}',
    'entranceFee.warningShifts.confirm': 'هل أنت متأكد من المتابعة؟',
    'grant.create': 'إنشاء إعانة',
    'grant.title': 'الإعانة',
    'grant.description': 'أدخل المبلغ وقواعد تطبيق الإعانة لجميع مؤسساتك.',
    'grant.description.title1': 'الاستراتيجية 1: الحد اليومي + المبلغ',
    'grant.customUse': 'تطبيقات خاصة للإعانة',
    'grant.descCustomUse': 'التفعيل والتخصيص حسب المطعم للإعانة',
    'grant.warningLimit': '⚠️ لا يمكن أن يتجاوز الحد اليومي المخصص الحد المحدد افتراضيًا.',
    'grant.warningForm': 'تأكد من إكمال جميع حقول الإعانة قبل تفعيلها على مطاعمك.',
    'grant.desc1':
        'تُطبَّق الإعانة على جميع منتجات السلة وفق القواعد التالية:\n        إذا كان هناك عتبة، يتأثر فقط مبلغ السلة الأعلى من العتبة.\n        إذا كان هناك سقف، لا يمكن أن يتجاوز مبلغ الإعانة هذا السقف.\n        إذا كان هناك وسم، تتأثر بالإعانة المنتجات الحاملة لهذا الوسم فقط.\n        ',
    'grant.description.title2': 'الاستراتيجية 2: الحد اليومي + المبلغ + المنتجات المخصصة',
    'grant.desc2':
        'تُطبَّق الإعانة وفق نفس القواعد المذكورة أعلاه، وبالإضافة إلى ذلك:\n    إذا كانت الإعانة بنسبة مئوية، تتأثر فقط المنتجات المحددة كقابلة للإعانة.\n    إذا كانت الإعانة بالأورو، تُشغَّل فقط إذا احتوت السلة على منتج واحد على الأقل محدد كقابل للإعانة.',
    'grant.amount': 'المبلغ',
    'grant.default': 'افتراضي',
    'grant.code': 'رمز الإعانة',
    'grant.codeAlreadyUsed': 'رمز الإعانة مستخدم بالفعل',
    'grant.strategy': 'الاستراتيجية',
    'grant.dailyLimit': 'الحد اليومي',
    'grant.type': 'نوع المبلغ',
    'grant.tags': 'تطبيق على المنتجات التي تحمل الوسم التالي فقط:',
    'grant.tags.placeholder': 'SUB1, SUB2',
    'grant.labelTicket': 'تسمية التذكرة',
    'grant.select.rate': 'نسبة مئوية',
    'grant.select.absolute': 'قيمة مطلقة',
    'grant.select.minimum': 'الحد اليومي + المبلغ',
    'grant.select.minimumAndProduct': 'الحد اليومي + الحد الأدنى للمبلغ + المنتجات المعنية',
    'grant.threshold': 'عتبة التفعيل',
    'grant.ceiling': 'سقف الدعم',
    'grant.restaurants': 'المطاعم',
    'grant.action': 'الإجراء',
    'grant.emptyMessage': 'لا توجد إعانة مرتبطة بهذه العلامة التجارية.',
    'grant.tableCard.title': 'الإعانات',
    'grant.tableCard.subtitle': 'أنشئ وأدر الإعانات المختلفة المستخدمة في مطاعمك',
    'grant.tableCard.action': '+ إضافة إعانة جديدة',
    'grant.settings.button': 'إعدادات',
    'grant.settings.modal.title': 'إعدادات الإعانات',
    'grant.settings.modal.subtitle': 'قم بتكوين القواعد المطبقة على إعانات علامتك التجارية.',
    'grant.settings.modal.toggle.label': 'حظر الدفع بقسائم الطعام عند تطبيق إعانة',
    'grant.settings.modal.toggle.description':
        'في حال التفعيل، لن تتوفر وسائل الدفع بقسائم الطعام (Edenred وPaygreen) للضيوف الذين تحتوي سلتهم على إعانة، عند الطلب عبر الإنترنت (CELV2).',
    'grant.settings.modal.cancel': 'إلغاء',
    'grant.settings.modal.save': 'حفظ',
    'grant.table.enabled': 'تفعيل',
    'grant.table.state': 'حالة التفعيل',
    'grant.table.services': 'الخدمات المفعّلة',
    'grant.table.state.enabled': 'مفعّل',
    'grant.table.state.customised': 'مفعّل بقيم مخصصة',
    'grant.table.state.disabled': 'معطّل',
    'grant.table.restaurant': 'المطعم',
    'grant.table.threshold': 'عتبة التفعيل',
    'grant.table.ceiling': 'السقف',
    'grant.table.dailyLimit': 'الحد اليومي',
    'grant.table.strategy': 'الاستراتيجية',
    'grant.table.action': 'الإجراء',
    'grant.modal.warning': 'تحذير',
    'grant.modal.confirmDelete': 'هل أنت متأكد من الرغبة في الحذف؟',
    'grant.search': 'البحث عن إعانة',
    'grant.configuration.title': 'تطبيق خاص للإعانة - {name}',
    'grant.configuration.header.title': 'إدارة خدمات هذا المطعم',
    'grant.configuration.search': 'البحث عن خدمة',
    'grant.configuration.table.activation': 'التفعيل',
    'grant.configuration.table.name': 'اسم الخدمة',
    'grant.configuration.table.time': 'التوقيت',
    'grant.configuration.table.days': 'الفترة',
    'grant.configuration.table.amount': 'المبلغ',
    'grant.configuration.table.threshold': 'عتبة التفعيل',
    'grant.configuration.table.ceiling': 'السقف',
    'grant.configuration.table.defaultShift': 'الخدمة الافتراضية',
    'grant.warningShifts.title': 'تأكيد التعديل',
    'grant.warningShifts.shift': '{time} - المبلغ: {amount} - الفارق: {variation}',
    'grant.warningShifts.shift.amount': '\nمبلغ الإعانة: {amount}',
    'grant.warningShifts.confirm': 'هل أنت متأكد من الرغبة في المتابعة؟',
    'group.tableCard.title': 'المجموعات',
    'group.tableCard.action': '+ إنشاء مجموعة جديدة',
    'group.tableCard.subtitle': 'حدد إمكانيات تجميع ضيوفك حسب المجموعة وربطها بأنظمة التسعير المختلفة.',
    'group.tableCard.subtitle2': 'حدد هنا الإمكانيات المختلفة لتنظيم ضيوفك.',
    'group.emptyMessage': 'لا توجد مجموعة مرتبطة بهذه العلامة التجارية.',
    'group.name': 'المجموعة',
    'group.action': 'الإجراء',
    'group.pricingRules': 'أنظمة التسعير',
    'group.guestsCount': 'عدد الضيف(ضيوف)',
    'group.guestsCountLabel': 'ضيف(ضيوف)',
    'group.modal.warning': 'تحذير',
    'group.modal.confirmDelete': 'هل أنت متأكد من الرغبة في الحذف؟',
    'group.modal.deleteError': 'لا يمكنك حذف هذه المجموعة.',
    'group.modal.deleteErrorReason': 'يرجى إلغاء تعيين الضيف(الضيوف) المرتبط(المرتبطين) لإتمام عملية الحذف.',
    'group.warning.group_name_already_exist.message': 'اسم المجموعة موجود مسبقاً.',
    'group.warning.group_name_already_exist.description':
        'يرجى اقتراح اسم مجموعة جديد أو ربط نظام(أنظمة) التسعير المحدد(المحددة) بالمجموعة الموجودة مسبقاً.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.message':
        'نظام تسعير واحد أو أكثر مما تريد فصله عن المجموعة الحالية مخصص لضيوف موجودين.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.description':
        'يرجى إلغاء تعيين هذا النظام أو هذه الأنظمة من الضيوف الموجودين قبل التمكن من حذفها من قائمة أنظمة التسعير المتاحة للمجموعة',
    'group.modal.import.title': 'استيراد المجموعات والأقسام والأقسام الفرعية وأنظمة التسعير',
    'group.modal.import.firstPart': 'تنزيل {fileTemplate} على جهاز الكمبيوتر الخاص بك',
    'group.modal.import.secondPart':
        'ملء نموذج الملف بمعلومات مجموعاتك وأقسامك وأقسامك الفرعية وأنظمة التسعير المراد إضافتها أو تعديلها',
    'group.modal.import.thirdPart': 'استيراد ملفك الجديد بالنقر على الزر أدناه',
    'group.modal.import.warning':
        'يتم حذف المجموعات والأقسام والأقسام الفرعية وأنظمة التسعير من خلال واجهة الإدارة الخلفية Innovorder فقط',
    'group.modal.import.report.title': 'تقرير الاستيراد',
    'group.export.group': 'المجموعة',
    'group.export.section': 'القسم',
    'group.export.subsection': 'القسم الفرعي',
    'group.export.pricingRule': 'أنظمة التسعير المرتبطة',
    'group.modal.conflict.error.message': 'لا يمكنك تعديل هذه المجموعة',
    'group.modal.conflict.error.description': 'يرجى إعادة تعيين الضيف(الضيوف) قبل تعديل هذه المجموعة',
    'group.modal.conflict.export.button': 'تصدير الضيوف',
    'group.modal.import.report.groups': 'المجموعات',
    'group.modal.import.report.sections': 'الأقسام',
    'group.modal.import.report.subsections': 'الأقسام الفرعية',
    'group.modal.import.report.successMessage': '• إنشاء: {created}\n • تعديل: {updated}',
    'group.modal.import.report.errorMessage': '• السطر {line} - العمود {field}: {message}',
    'group.delete.modal.conflict.error.message': 'لا يمكنك حذف هذه المجموعة',
    'group.delete.modal.conflict.error.description': 'يرجى إعادة تعيين الضيف(الضيوف) قبل حذف هذه المجموعة',
    'group.delete.modal.conflict.export.button': 'تصدير الضيوف',
    'groups.export.student.customerId': 'معرّف العميل',
    'groups.export.student.email': 'البريد الإلكتروني',
    'groups.export.student.password': 'كلمة المرور',
    'groups.export.student.firstName': 'الاسم الأول',
    'groups.export.student.lastName': 'اسم العائلة',
    'groups.export.student.phone': 'الهاتف',
    'groups.export.student.piCode': 'رمز PIN',
    'groups.export.student.badgeNumber': 'رقم الشارة',
    'groups.export.student.studentNumber': 'رقم الضيف',
    'groups.export.student.group': 'المجموعة',
    'groups.export.student.section': 'القسم',
    'groups.export.student.subSection': 'القسم الفرعي',
    'groups.export.student.accountType': 'نوع الحساب',
    'groups.export.student.tariffCode': 'رمز التعرفة',
    'groups.export.student.grantCode': 'رمز الإعانة',
    'groups.export.student.entranceFeeCode': 'رمز رسوم الدخول',
    'groups.export.student.pricingRuleCode': 'نظام التسعير',
    'groups.export.student.ewalletOverdraftAmount': 'مبلغ السحب على المكشوف المخصص',
    'groups.export.student.exitDate': 'تاريخ الأرشفة',
    'groups.export.student.accessFrom': 'تاريخ الوصول',
    'groups.export.student.accessUntil': 'تاريخ المغادرة',
    'groups.export.student.inactive': 'غير نشط',
    'groups.export.student.active': 'نشط',
    'groups.export.student.yes': 'نعم',
    'groups.export.student.no': 'لا',
    'section.tableCard.title': 'الأقسام',
    'section.tableCard.subtitle': 'حدد إمكانيات تجميع ضيوفك حسب القسم وربطها بأنظمة التسعير المختلفة.',
    'section.tableCard.action': '+ إنشاء قسم جديد',
    'section.name': 'القسم',
    'group.warning.section_name_already_exist.message': 'اسم القسم موجود مسبقاً.',
    'group.warning.section_name_already_exist.description':
        'يرجى اقتراح اسم قسم جديد أو ربط نظام(أنظمة) التسعير المحدد(المحددة) بالقسم الموجود مسبقاً.',
    'section.modal.conflict.error.message': 'لا يمكنك تعديل هذا القسم',
    'section.modal.conflict.error.description': 'يرجى إعادة تعيين الضيف(الضيوف) قبل تعديل هذا القسم',
    'section.delete.modal.conflict.error.message': 'لا يمكنك حذف هذا القسم',
    'section.delete.modal.conflict.error.description': 'يرجى إعادة تعيين الضيف(الضيوف) قبل حذف هذا القسم',
    'subsection.tableCard.title': 'الأقسام الفرعية',
    'subsection.tableCard.subtitle': 'حدد إمكانيات تجميع ضيوفك حسب القسم الفرعي وربطها بأنظمة التسعير المختلفة.',
    'subsection.tableCard.action': '+ إنشاء قسم فرعي جديد',
    'subsection.name': 'القسم الفرعي',
    'group.warning.sub_section_name_already_exist.message': 'اسم القسم الفرعي موجود مسبقاً.',
    'group.warning.sub_section_name_already_exist.description':
        'يرجى اقتراح اسم قسم فرعي جديد أو ربط نظام(أنظمة) التسعير المحدد(المحددة) بالقسم الفرعي الموجود مسبقاً.',
    'subsection.modal.conflict.error.message': 'لا يمكنك تعديل هذا القسم الفرعي',
    'subsection.modal.conflict.error.description': 'يرجى إعادة تعيين الضيف(الضيوف) قبل تعديل هذا القسم الفرعي',
    'subsection.delete.modal.conflict.error.message': 'لا يمكنك حذف هذا القسم الفرعي',
    'subsection.delete.modal.conflict.error.description': 'يرجى إعادة تعيين الضيف(الضيوف) قبل حذف هذا القسم الفرعي',
    'options.main': 'عام',
    'options.educationMode': 'خدمات الطعام الجماعية',
    'options.birthdate': 'تاريخ الميلاد',
    'options.tripAdvisorUsername': 'اسم المستخدم في TripAdvisor',
    'options.advancedSecurityRules': 'تفعيل كلمة مرور من 12 حرفاً',
    'options.optIn': 'الموافقة على الاشتراك',
    'options.productionDeclaration': 'إعلان الإنتاج',
    'options.grantsAndEntranceFee': 'الإعانات ورسوم الدخول',
    'options.pinCodeDoubleAuth': 'استخدام رمز PIN لتأمين المصادقة على الجهاز',
    'options.charlemagneExport': 'تصدير البيانات لـ Charlemagne',
    'options.handleBadgeForChar': 'إدارة آخر 4 أحرف فقط في عمليات البحث عن الشارة',
    'options.autoBilling': 'تفعيل وحدة "الفوترة التلقائية"',
    'options.linkProductImageBySku': 'ربط الصور تلقائياً عند استيراد المنتجات بناءً على SKU',
    'options.externalIdsMapping': 'تفعيل ترجمة المعرّفات',
    'options.ewalletAutoReload': 'تفعيل إعادة التحميل التلقائي للمحفظة الإلكترونية (عبر Stripe)',
    'options.foodCourt': 'CEL v2 - Food Court',
    'options.foodCourtMode': 'تفعيل وضع Food Court',
    'options.shuffleRestaurants': 'جعل ترتيب عرض المطاعم عشوائياً',
    'options.enableSodexoDictionary': 'تفعيل قاموس Sodexo',
    'options.enableOrderDetailV2': 'تفعيل تفاصيل الطلب V2',
    'options.usePickupPoints': 'تفعيل نقاط الاستلام',
    'options.linkProductSkuToExternalMapping': 'ربط SKU المنتجات تلقائياً بترجمة المعرّفات',
    'options.linkStudentNumberToExternalMapping': 'ربط رقم الضيف تلقائياً بترجمة المعرّفات',
    'options.multiRestaurant': 'الجهاز - متعدد المطاعم',
    'options.multiRestaurantMode': 'تفعيل وضع متعدد المطاعم',
    'options.multiRestaurantModeMainRestaurant': 'المطعم الرئيسي',
    'options.multiRestaurantModeMainUser': 'مستخدم الجهاز',
    'options.multiRestaurantModeAssignedRestaurants': 'المطاعم المعيّنة',
    'options.enableLinkingMenuToPosAndWeb': 'السماح بربط القائمة بنقطة البيع والإنترنت',
    'options.configureSodexoConsumerTransaction': 'تفعيل webhooks Sodexo للمعاملات الاستهلاكية',
    'options.families': 'العائلات',
    'options.families.empty': 'لا توجد عائلة',
    'options.families.new': 'عائلة جديدة',
    'options.families.namePlaceholder': 'الاسم',
    'options.families.add': 'إضافة',
    'options.families.delete': 'حذف',
    'options.families.deleteTitle': 'تأكيد حذف العائلة {name}',
    'options.families.deleteConfirmation': 'هل أنت متأكد من الرغبة في حذف العائلة "{name}"؟',
    'brandInfo.title': 'المعلومات',
    'brandInfo.ewalletOverdraft.title': 'السحب على المكشوف للمحفظة الإلكترونية',
    'brandInfo.ewalletOverdraft.description':
        'السماح للعملاء بامتلاك رصيد سلبي في محفظتهم الإلكترونية حتى المبلغ المحدد.',
    'brandInfo.ewalletOverdraft.enable': 'تفعيل السحب على المكشوف للمحفظة الإلكترونية',
    'brandInfo.ewalletOverdraft.amount': 'الحد الأقصى للسحب على المكشوف',
    'brandInfo.ewalletOverdraft.amountPlaceholder': '0,00',
    'brandInfo.ewalletOverdraft.cannotDisable':
        'تعذّر تعطيل السحب على المكشوف: {count} عميل(عملاء) لديهم الدفع الآجل مفعّلاً حالياً.',
    'restaurant.search': 'البحث عن مطعم',
    'restaurant.name': 'اسم المطعم',
    'restaurant.options.main': 'عام',
    'restaurant.options.includeDepositsInTurnover': 'احتساب الودائع ضمن رقم الأعمال',
    'adminBanner.message': 'أنت متصل بصفتك',
    'adminBanner.backToAdmin': 'العودة إلى حساب المسؤول',
    'auto.billing.buttons.referential': 'المرجع',
    'auto.billing.buttons.billing': 'طلب الفوترة',
    'auto.billing.request.card.title': 'طلب الفوترة',
    'auto.billing.request.card.subtitle':
        'تتيح وحدة الفوترة التلقائية تجميع جميع استهلاكات الضيوف المخصصة لطرف ثالث لاحتساب رقم الأعمال والمبالغ المحصّلة لكل طرف (وفق القواعد المعيّنة).',
    'auto.billing.request.wizard.validate': 'إنهاء',
    'auto.billing.request.wizard.title': 'تقديم طلب فوترة',
    'auto.billing.request.card.action': 'تقديم طلب فوترة',
    'auto.billing.request.popup.confirm.title': 'أنت على وشك طلب فوترة تلقائية',
    'auto.billing.request.popup.confirm.text': 'هل يمكنك تأكيد هذا الإجراء؟',
    'auto.billing.request.popup.success.title': 'تم التحقق من طلب الفوترة الخاص بك',
    'auto.billing.request.popup.fail.title': 'خطأ',
    'auto.billing.request.popup.pending.title': 'جارٍ المعالجة...',
    'auto.billing.request.popup.success.cancel': 'إغلاق',
    'auto.billing.request.popup.success.text': 'لقد أرسلت طلب الفوترة الخاص بك بنجاح',
    'auto.billing.request.popup.fail.text': 'حدث خطأ، يرجى المحاولة مرة أخرى لاحقاً',
    'auto.billing.request.preview.emptyMessage': 'لا توجد مبيعات خلال الفترة المحددة',
    'auto.billing.request.preview.errorUndefinedReferential': 'لم يُحدد أي مرجع للعلامة التجارية',
    'auto.billing.request.preview.error': 'حدث خطأ، يرجى المحاولة مرة أخرى لاحقاً',
    'auto.billing.request.preview.code': 'الرمز',
    'auto.billing.request.preview.label': 'التسمية',
    'auto.billing.request.preview.quantity': 'الكمية',
    'auto.billing.request.preview.unitPriceWithTaxExcluded': 'سعر الوحدة (باستثناء الضريبة)',
    'auto.billing.request.preview.totalPriceWithTaxExcluded': 'المبلغ (باستثناء الضريبة)',
    'auto.billing.request.preview.totalTax': 'مبلغ ضريبة القيمة المضافة',
    'auto.billing.request.preview.totalPriceWithTaxIncluded': 'المبلغ الإجمالي (شاملاً الضريبة)',
    'auto.billing.request.preview.cdpf': 'CDPF المصدر',
    'auto.billing.request.preview.clientCode': 'رمز العميل',
    'auto.billing.request.preview.clientLabel': 'تسمية العميل',
    'auto.billing.request.preview.billingPeriod': 'فترة الفوترة',
    'auto.billing.request.preview.billingPeriod.from': 'من',
    'auto.billing.request.preview.billingPeriod.to': 'إلى',
    'auto.billing.request.preview.invoiceSelector.GROUP': 'المجموعة',
    'auto.billing.request.preview.invoiceSelector.ACCOUNT_PAYMENT_TYPE': 'نوع الحساب',
    'auto.billing.request.preview.invoiceSelector.PRICING_RULE': 'نظام التسعير',
    'auto.billing.request.preview.total.amountWithTaxIncluded': 'الإجمالي شاملاً الضريبة',
    'auto.billing.request.preview.total.amountWithTaxExcluded': 'الإجمالي (باستثناء الضريبة)',
    'auto.billing.request.preview.total.tax': 'إجمالي ضريبة القيمة المضافة',
    'auto.billing.request.filter.title': 'المرشّحات',
    'auto.billing.request.filter.entities.title': 'اختيار كيانات الفوترة',
    'auto.billing.request.filter.entities.all': 'جميع الكيانات',
    'auto.billing.request.filter.restaurants.title': 'اختيار المطاعم',
    'auto.billing.request.filter.dropDown.errorMessage': 'يجب اختيار خيار واحد على الأقل',
    'auto.billing.request.filter.restaurants.all': 'جميع المطاعم',
    'auto.billing.request.filter.pricingRules.title': 'ملف التسعير',
    'auto.billing.request.filter.pricingRules.all': 'جميع أنظمة التسعير',
    'auto.billing.request.filter.pricingRules.noPricingRules': 'لا يوجد نظام تسعير',
    'auto.billing.request.accountPaymentTypes.title': 'أسلوب الإدارة',
    'auto.billing.request.filter.accountPaymentTypes.all': 'جميع أساليب الإدارة',
    'auto.billing.request.accountPaymentTypes.CASH': 'نقداً',
    'auto.billing.request.accountPaymentTypes.PREPAYMENT': 'الدفع المسبق',
    'auto.billing.request.accountPaymentTypes.POSTPAYMENT': 'الدفع الآجل',
    'auto.billing.request.history.table.emptyMessage': 'لم يُقدَّم أي طلب فوترة',
    'auto.billing.request.history.table.date': 'تاريخ الإنشاء',
    'auto.billing.request.history.table.period': 'الفترة',
    'auto.billing.request.history.table.user': 'المستخدم',
    'auto.billing.request.history.table.previewButton': 'معاينة',
    'auto.billing.request.history.table.downloadButton': 'تنزيل',
    'auto.billing.referential.serviceCodes.card.title': 'رموز الخدمات',
    'auto.billing.referential.serviceCodes.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.card.title': 'كيانات الفوترة',
    'auto.billing.referential.billingEntities.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.add': '+ إضافة كيان',
    'auto.billing.referential.billingEntities.form.create.title': 'إنشاء كيان فوترة',
    'auto.billing.referential.billingEntities.form.create.subtitle': ' ',
    'auto.billing.referential.billingEntities.costCompute.title': 'أسلوب الحساب',
    'auto.billing.referential.billingEntities.costCompute.subtitle': ' ',
    'auto.billing.referential.billingEntities.table.label': 'التسمية',
    'auto.billing.referential.billingEntities.table.code': 'الرمز',
    'auto.billing.referential.billingEntities.table.groups': 'المجموعات المرتبطة',
    'auto.billing.referential.billingEntities.table.groupingBy': 'التوزيع',
    'auto.billing.referential.billingEntities.table.emptyMessage': 'لم يُحدد أي كيان فوترة لهذه العلامة التجارية',
    'auto.billing.referential.billingEntities.form.label.title': 'التسمية',
    'auto.billing.referential.billingEntities.form.code.title': 'الرمز',
    'auto.billing.referential.billingEntities.form.code.text': 'الرمز',
    'auto.billing.referential.billingEntities.form.groups.text': 'الهدف',
    'auto.billing.referential.billingEntities.form.groupingBy.title': 'نوع التوزيع',
    'auto.billing.referential.billingEntities.form.label.subtitle': 'إنشاء كيان فوترة',
    'auto.billing.referential.billingEntities.form.groupingBy.options.PRICING_RULE': 'نظام التسعير',
    'auto.billing.referential.billingEntities.form.groupingBy.options.BILLING_ENTITY': 'بدون توزيع',
    'auto.billing.referential.billingEntities.form.groupingBy.options.GROUP': 'المجموعة',
    'auto.billing.referential.billingEntities.form.groupingBy.options.ACCOUNT_PAYMENT_TYPE': 'أسلوب الإدارة',
    'auto.billing.referential.billingEntities.errors.duplicate.code':
        'الرمز {code} مرتبط مسبقاً بكيان الفوترة {entity}',
    'auto.billing.referential.billingEntities.errors.duplicate.group':
        'كيان الفوترة {entity} لديه المجموعة(المجموعات) التالية مسبقاً: {groups}',
    'auto.billing.referential.serviceCodes.perceivedAmountCode.label': 'المبلغ المحصّل لحساب الغير',
    'auto.billing.referential.serviceCodes.admissionLevelCostCode.label': 'الفوترة حسب شريحة الدخول',
    'auto.billing.referential.serviceCodes.fixedCostCode.label': 'الفوترة الجماعية للتكاليف الثابتة',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.card.title': 'المبلغ المحصّل لحساب الغير',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.code.label': 'الرمز',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.vat.label': 'ضريبة القيمة المضافة',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.add': '+ إضافة رمز',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.emptyMessage': 'لم يُدخل أي رمز',
    'auto.billing.referential.accountingCostCompute.constantCost': 'الفوترة الجماعية للتكاليف الثابتة',
    'auto.billing.referential.accountingCostCompute.partitionedConstantCost': 'الفوترة بالشرائح',
    'auto.billing.referential.accountingCostCompute.summedUpByAdmissionFeesAmount': 'الفوترة لكل غطاء',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.constantCost': 'التكلفة الثابتة الجماعية',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.summedUpByAdmissionFeesAmount': 'لكل غطاء',
    'auto.billing.referential.accountingCostCompute.modal.sliceFrom': 'الشريحة من',
    'auto.billing.referential.accountingCostCompute.modal.to': 'إلى',
    'auto.billing.referential.accountingCostCompute.modal.constantCost': 'التكلفة الثابتة الجماعية',
    'auto.billing.referential.accountingCostCompute.modal.summedUpByAdmissionFeesAmount': 'لكل غطاء',
    'auto.billing.referential.accountingCostCompute.modal.billingMode': 'أسلوب الفوترة',
    'auto.billing.referential.accountingCostCompute.modal.title': 'إضافة شريحة جديدة',
    'auto.billing.referential.accountingCostCompute.modal.input.maxLowerThanOrEqualToMin':
        'يجب أن تكون الشريحة القصوى أكبر من الحد الأدنى',
    'auto.billing.referential.accountingCostCompute.modal.input.intersection': 'تتداخل هذه الشريحة مع [{from} - {to}]',
    'auto.billing.referential.accountingCostCompute.modal.input.negative': 'يجب أن تكون القيمة موجبة',
    'auto.billing.referential.accountingCostCompute.partitionedCostByGuest': 'XXXX',
    'auto.billing.referential.accountingCostCompute.addSlice': '+ إضافة شريحة',
    'auto.billing.referential.accountingCostCompute.amount': 'المبلغ الإجمالي (شاملاً الضريبة)',
    'auto.billing.filters.entity': 'كيان الفوترة',
    'auto.billing.referential.accountingGroups.code.text': 'XXXX رمز المجموعة',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.range': 'عدد الأغطية',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.mode': 'أسلوب الحساب',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.value': 'القيم',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.emptyMessage':
        'لم تُحدد شرائح لأسلوب الفوترة هذا',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.to': 'إلى',
    'route.brands': 'العلامات التجارية',
    'route.brandInfo': 'المعلومات',
    'route.brandInfoV2': 'المعلومات',
    'route.brandMedias': 'الوسائط',
    'route.configIOPay': 'إعداد Adyen',
    'route.configEdenred': 'إعداد Edenred',
    'route.configPaygreen': 'إعداد Paygreen',
    'route.integrations': 'التكاملات',
    'route.stripeIntegration': 'Stripe',
    'route.grantsAndEntranceFees': 'الإعانات ورسوم الدخول',
    'route.options': 'الخيارات',
    'route.brandHistory': 'السجل',
    'route.groups': 'التسلسل الهرمي',
    'route.brandChannels': 'القنوات',
    'route.brandMenus': 'القوائم',
    'route.brandMenu': 'المعلومات',
    'route.brandRestaurants': 'المطاعم',
    'route.brandUsers': 'المستخدمون',
    'route.billing': 'فضاء الفوترة الخاص بي',
    'route.home': 'الرئيسية',
    'route.pricingRule': 'نظام التسعير',
    'route.logout': 'تسجيل الخروج',
    'route.configUbereats': 'تكامل Uber Eats',
    'route.configDeliveroo': 'تكامل Deliveroo',
    'route.configDeliverect': 'تكامل Deliverect',
    'route.configCrous': 'تكامل Crous',
    'route.createGrant': 'إعانة جديدة',
    'route.grant': 'الإعانات',
    'route.createEntranceFee': 'رسوم دخول جديدة',
    'route.entranceFee': 'رسوم الدخول',
    'route.createPricingRule': 'قاعدة تسعير جديدة',
    'route.analytics': 'نظرة عامة',
    'route.restaurantIntegration': 'التكامل',
    'route.autoBilling': 'الفوترة التلقائية',
    'route.autoBilling.referential': 'المرجع',
    'route.autoBilling.request': 'طلب الفوترة',
    'route.autoBilling.referential.createEntity': 'إنشاء كيان فوترة',
    'route.autoBilling.referential.editEntity': 'تعديل كيان فوترة',
    'route.orders': 'الطلبات',
    'route.orderDetails': 'تفاصيل الطلب',
    'route.restaurantInfo': 'المعلومات',
    'route.restaurantChannels': 'القنوات',
    'route.restaurantUsers': 'المستخدمون',
    'route.restaurantMenus': 'القوائم',
    'route.restaurantMenu': 'المعلومات',
    'route.restaurantTickets': 'التذاكر',
    'route.restaurantMedias': 'الوسائط',
    'route.restaurantIntegrations': 'التكاملات',
    'route.restaurantPayments': 'وسائل الدفع',
    'route.restaurantOptions': 'الخيارات',
    'route.restaurantPricingRevaluation': 'إعادة تقييم الأسعار',
    'route.createGroup': 'مجموعة جديدة',
    'route.createSection': 'قسم جديد',
    'route.createSubSection': 'قسم فرعي جديد',
    'route.editGroup': 'تعديل مجموعة',
    'route.editSection': 'تعديل قسم',
    'route.editSubSection': 'تعديل قسم فرعي',
    'route.adminTools': 'أدوات المسؤول',
    'route.menus': 'القوائم',
    'route.menuOperations': 'عمليات القوائم',
    'route.posLayout': 'خطة لوحة مفاتيح نقطة البيع',
    'route.categories': 'الفئات',
    'route.products': 'المنتجات',
    'route.steps': 'الخطوات',
    'route.tags': 'الوسوم',
    'route.functions': 'الوظائف',
    'route.brandCustomer': 'العملاء',
    'route.brandOrders': 'الطلبات',
    'route.crossSelling': 'البيع المتقاطع',
    'route.tableLayout': 'مخططات الطاولات',
    'route.tableLayout.room': 'القاعات',
    'route.salesSummary': 'الملخص المالي',
    'route.tickets': 'التذاكر',
    'route.reportStatus': 'حالة التقرير',
    'route.pos': 'نقطة البيع',
    'route.posConfiguration': 'الإعداد',
    'route.posDevices': 'أجهزة المبيعات',
    'route.posAccess': 'الأدوار والصلاحيات',
    'route.posAccess.users': 'مستخدمو نقطة البيع',
    'route.posAccess.roles': 'أدوار نقطة البيع',
    'route.posAccess.groups': 'مجموعات نقطة البيع',
    'route.accessFlags': 'الأذونات',
    'route.userRestaurants': 'المطاعم المرتبطة',
    'route.updateUserPassword': 'تعديل كلمة المرور',
    'route.userInfo': 'المعلومات',
    'route.badgeReader': 'قارئات الشارات',
    'route.posDeviceInformation': 'المعلومات',
    'route.posDeviceConfiguration': 'الإعداد',
    'route.posDeviceAdditionalDevices': 'الأجهزة الطرفية',
    'route.posDeviceArchives': 'الأرشيفات الضريبية',
    'route.posDeviceFeatures': 'الخيارات',
    'route.posDevicePreferences': 'التفضيلات',
    'route.posDeviceCatalogHistory': 'سجل الكتالوجات',
    'route.listCustomers': 'العملاء',
    'route.customerSettings': 'الإعدادات',
    'route.customerPricingRules': 'أنظمة التسعير',
    'route.splioLoyaltyIntegration': 'Splio',
    'route.pickupPoints': 'نقاط الاستلام',
    'route.comoLoyaltyIntegration': 'Como',
    'route.zerosixLoyaltyIntegration': 'Zerosix',
    'route.operationZones': 'منطقة العمليات',
    'route.createBrandWebhook': 'إنشاء webhook',
    'route.editBrandWebhook': 'تعديل webhook',
    'operationZones.page.title': 'منطقة العمليات',
    'operationZones.page.description':
        'حدد المناطق الجغرافية التي تمارس فيها علامتك التجارية نشاطها. يجب تحديد منطقة رئيسية للكيان القانوني المرجعي.',
    'operationZones.emptyState': 'لم يتم تحديد أي منطقة',
    'operationZones.emptyState.description': 'اختر منطقة جغرافية واحدة أو أكثر من القائمة أدناه لتحديد مناطق عملياتك.',
    'operationZones.availableTerritories': 'المناطق الجغرافية المتاحة',
    'operationZones.selectedCount': '{count} محدد(ة)',
    'operationZones.solution': 'الحل',
    'operationZones.warning.title': 'الإعداد غير مكتمل',
    'operationZones.warning.description':
        '{count, plural, one {{count} منطقة محددة تحتاج إلى الإعداد لتكون تشغيلية.} other {{count} منطقة محددة تحتاج إلى الإعداد لتكون تشغيلية.}}',
    'operationZones.warning.hint': 'يرجى إكمال المعلومات القانونية والتقنية عبر زر "تهيئة".',
    'operationZones.immutabilityNotice':
        'لا يمكن تعديل منطقة العمليات بعد إنشاء المطعم. <supportLink>تواصل مع الدعم الفني</supportLink> إذا لزم الأمر.',
    'operationZones.primaryZone': 'المنطقة الرئيسية',
    'operationZones.setPrimary.disabled': 'قم بتهيئة هذه المنطقة قبل تعيينها كمنطقة رئيسية',
    'operationZones.cannotRemoveLastZone': 'يجب أن يكون للمطعم منطقة عمليات واحدة على الأقل',
    'operationZones.primaryBadge': 'رئيسية',
    'operationZones.secondaryZonesActive':
        '+ {count} {count, plural, one {منطقة ثانوية نشطة} other {منطقة ثانوية نشطة}}',
    'operationZones.configure': 'تهيئة',
    'operationZones.viewVatRates': 'عرض المعدلات',
    'operationZones.toConfigure': 'للتهيئة',
    'operationZones.entity': 'الكيان',
    'operationZones.vat': 'ضريبة القيمة المضافة',
    'operationZones.posConfig': 'إعداد نقطة البيع',
    'operationZones.notFilled': 'غير مُعبّأ',
    'operationZones.pending': 'قيد الانتظار',
    'operationZones.initialized': 'مُهيَّأة',
    'operationZones.configured': 'مُعدَّة',
    'operationZones.noPosDevice': 'أنشئ نقطة بيع قبل تهيئة هذه المنطقة',
    'operationZones.configModal.title': 'التهيئة: {zoneName}',
    'operationZones.configModal.subtitle': 'الإعدادات القانونية والضريبية ({code})',
    'operationZones.configModal.entitySection': 'معلومات الكيان',
    'operationZones.configModal.socialReason': 'الاسم التجاري',
    'operationZones.configModal.address': 'العنوان',
    'operationZones.configModal.postalCode': 'الرمز البريدي',
    'operationZones.configModal.city': 'المدينة',
    'operationZones.configModal.vatNumber': 'رقم ضريبة القيمة المضافة',
    'operationZones.configModal.siret': 'SIRET',
    'operationZones.configModal.save': 'حفظ',
    'operationZones.configModal.socialReason.placeholder': 'مثال: Restaurant SARL',
    'operationZones.configModal.address.placeholder': '123 شارع...',
    'operationZones.configModal.postalCode.placeholder': '75000',
    'operationZones.configModal.city.placeholder': 'باريس',
    'operationZones.configModal.vatNumber.placeholder': 'مثال: FR 12 345678901',
    'operationZones.configModal.siret.placeholder': 'مثال: 522 296...',
    'operationZones.multiProvider': 'الاختيار متاح',
    'operationZones.configModal.nifCif': 'NIF / CIF',
    'operationZones.configModal.nifCif.placeholder': 'مثال: B12345678',
    'operationZones.configModal.fiscalRepresentative': 'الممثل الضريبي',
    'operationZones.configModal.fiscalRepresentative.placeholder': 'اسم الممثل الضريبي',
    'operationZones.configModal.fiscalIdCode': 'رمز التعريف الضريبي',
    'operationZones.configModal.fiscalIdCode.placeholder': 'مثال: RSSMRA85T10A562S',
    'operationZones.configModal.vatNumberBtw': 'رقم ضريبة القيمة المضافة (BTW)',
    'operationZones.configModal.vatNumberBtw.placeholder': 'مثال: BE 0123.456.789',
    'operationZones.configModal.enterpriseNumber': 'رقم المؤسسة',
    'operationZones.configModal.enterpriseNumber.placeholder': 'مثال: 0123.456.789',
    'operationZones.configModal.if': 'IF',
    'operationZones.configModal.if.placeholder': 'مثال: 12345678',
    'operationZones.configModal.ice': 'ICE',
    'operationZones.configModal.ice.placeholder': 'مثال: 001234567000045',
    'operationZones.configModal.selectProvider': 'اختر أسلوب الامتثال',
    'operationZones.configModal.fiskaltrust': 'Fiskaltrust',
    'operationZones.configModal.fiskaltrustDescription': 'برنامج وسيط للامتثال الضريبي لجهاز البيع',
    'operationZones.configModal.noIntegration': 'بدون تكامل',
    'operationZones.configModal.noIntegrationDescription': 'لن يتم إعداد أي برنامج وسيط للضرائب',
    'operationZones.configModal.nf525': 'NF525',
    'operationZones.configModal.nf525Description': 'شهادة الامتثال الضريبي الفرنسية',
    'operationZones.configModal.boiteNoire': 'الصندوق الأسود',
    'operationZones.configModal.boiteNoireDescription': 'وحدة الامتثال الضريبي البلجيكية',
    'operationZones.configModal.middlewareSection': 'إعداد البرنامج الوسيط (Fiskaltrust)',
    'operationZones.configModal.cashboxId': 'معرّف صندوق المبيعات',
    'operationZones.configModal.cashboxId.placeholder': 'مثال: a1b2c3d4-...',
    'operationZones.configModal.accessToken': 'رمز الوصول',
    'operationZones.configModal.accessToken.placeholder': 'مثال: AZE123...',
    'operationZones.configModal.back': 'رجوع',
    'operationZones.deactivate.title': 'تعطيل منطقة العمليات',
    'operationZones.deactivate.message':
        'هل أنت متأكد من الرغبة في تعطيل منطقة العمليات هذه؟ ستُفقد جميع المعلومات المهيّأة (الكيان القانوني، الضرائب، إعداد نقطة البيع).',
    'adminTools.confirmModal.description': 'هل أنت متأكد من الرغبة في تنفيذ هذا الإجراء؟',
    'brand.adminTools.editCustomerLoyalties.title': 'إضافة/إزالة نقاط الولاء IO لعميل من هذه العلامة التجارية',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.emailsOrCards': 'name@domain.com أو A1B2C3D4E5',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.loyaltyAmountToAdd': '400 تعادل 4 يورو',
    'brand.adminTools.editCustomerLoyalties.form.emailsOrCards': 'البريد الإلكتروني أو رقم بطاقة الولاء للعميل',
    'brand.adminTools.editCustomerLoyalties.form.loyaltyAmountToAdd': 'المبلغ',
    'brand.adminTools.editCustomerLoyalties.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.editCustomerLoyalties.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.unarchiveCustomer.title': 'إلغاء أرشفة ضيف',
    'brand.adminTools.unarchiveCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.unarchiveCustomer.form.customerId': 'معرّف العميل المراد إلغاء أرشفته',
    'brand.adminTools.unarchiveCustomer.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.unarchiveCustomer.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.deleteTransaction.title': 'حذف معاملة',
    'brand.adminTools.deleteTransaction.form.placeholder.transactionId': '1234567',
    'brand.adminTools.deleteTransaction.form.transactionId': 'المعاملة المراد حذفها',
    'brand.adminTools.deleteTransaction.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.deleteTransaction.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.addUserToRestaurant.title': 'تعيين حساب مطعم لمطعم آخر ضمن نفس العلامة التجارية',
    'brand.adminTools.addUserToRestaurant.form.placeholder.email': 'example@restaurant.com',
    'brand.adminTools.addUserToRestaurant.form.email': 'البريد الإلكتروني للحساب',
    'brand.adminTools.addUserToRestaurant.form.placeholder.restaurantId': '1111',
    'brand.adminTools.addUserToRestaurant.form.restaurantId': 'معرّف المطعم المراد تعيينه',
    'brand.adminTools.addUserToRestaurant.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.addUserToRestaurant.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.deleteUnassignedImages.title': 'حذف الصور غير المستخدمة لهذه العلامة التجارية',
    'brand.adminTools.deleteUnassignedImages.description1':
        'نص برمجي لحذف جميع الصور غير المستخدمة (مثلاً تلك المرتبطة بمنتجات/قوائم تم حذفها لاحقاً)',
    'brand.adminTools.deleteUnassignedImages.description2':
        'يُنصح بحذف جميع القوائم غير الضرورية من العلامة التجارية ومطاعمها قبل تنفيذ هذا النص البرمجي لضمان فاعلية التنظيف.',
    'brand.adminTools.deleteUnassignedImages.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.deleteUnassignedImages.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.importGeojsonPolygon.title': 'استيراد ملف GeoJson كمنطقة توصيل',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.restaurantId': '1234',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.areaName': 'Creteil',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.geoJsonPolygon':
        '[[4.8395748,50.0926849],[4.8393237,50.0926889],[4.8392677,50.0926748]]',
    'brand.adminTools.importGeojsonPolygon.form.restaurantId': 'معرّف المطعم',
    'brand.adminTools.importGeojsonPolygon.form.areaName': 'اسم منطقة التوصيل المراد إنشاؤها',
    'brand.adminTools.importGeojsonPolygon.form.geoJsonPolygon': 'أدخل إحداثيات مضلع GeoJson',
    'brand.adminTools.importGeojsonPolygon.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.importGeojsonPolygon.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.deleteCustomer.title': 'حذف عميل/ضيف',
    'brand.adminTools.deleteCustomer.description1':
        'أدخل معرّف العميل الذي تريد حذفه (يمكنك إدخال عدة معرّفات مفصولة بفاصلة، بدون مسافة، مثلاً: 1234567,1234568,1234569)',
    'brand.adminTools.deleteCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.deleteCustomer.form.customerId': 'معرّف العميل المراد حذفه',
    'brand.adminTools.deleteCustomer.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.deleteCustomer.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.razCustomer.title': 'إعادة تصفير رصيد عميل/ضيف',
    'brand.adminTools.razCustomer.description1':
        'أدخل معرّف العميل الذي تريد تصفير رصيد محفظته الإلكترونية (يمكنك إدخال عدة معرّفات مفصولة بفاصلة، بدون مسافة، مثلاً: 1234567,1234568,1234569)',
    'brand.adminTools.razCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.razCustomer.form.customerId': 'معرّف(ات) العميل للتصفير (مفصولة بفاصلة)',
    'brand.adminTools.razCustomer.form.placeholder.brandId': '414',
    'brand.adminTools.razCustomer.form.brandId':
        'معرّف العلامة التجارية للتصفير (إذا أدخلت معرّف العلامة التجارية، سيتم تصفير رصيد جميع عملاء ما بعد الدفع في هذه العلامة التجارية، وسيتم تجاهل حقل معرّف(ات) العميل أعلاه)',
    'brand.adminTools.razCustomer.form.placeholder.date': '01/02/2024',
    'brand.adminTools.razCustomer.form.date':
        'تاريخ تطبيق التصفير (الساعة 5 صباحاً)، اتركه فارغاً إذا أردت التصفير الفوري',
    'brand.adminTools.razCustomer.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.razCustomer.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.copySchedules.title': 'نسخ جداول الاستلام أو CEL من مطعم إلى مطعم(مطاعم) آخر',
    'brand.adminTools.copySchedules.form.placeholder.scheduleType': 'pickup أو cel',
    'brand.adminTools.copySchedules.form.placeholder.idSource': '900',
    'brand.adminTools.copySchedules.form.placeholder.idsDestination': '901',
    'brand.adminTools.copySchedules.form.scheduleType': 'نوع الجدول الزمني للنسخ (أدخل pickup أو cel)',
    'brand.adminTools.copySchedules.form.idSource': 'معرّف المطعم المصدر',
    'brand.adminTools.copySchedules.form.idsDestination':
        'معرّف(ات) المطعم الوجهة (يمكنك إدخال عدة معرّفات مفصولة بفاصلة، بدون مسافة، مثلاً: 901,902,903)',
    'brand.adminTools.copySchedules.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.copySchedules.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.changeOrderDateInReport.title': 'تعديل تاريخ طلب في التقارير (سيغير أيضاً تاريخ المعاملة)',
    'brand.adminTools.changeOrderDateInReport.form.orderPosId': 'رقم الطلب (orderId)، يمكن الفصل بفاصلة',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.orderPosId': '1234567,1234568,1234569,...',
    'brand.adminTools.changeOrderDateInReport.form.day': 'اليوم',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.day': 'مثال: 14',
    'brand.adminTools.changeOrderDateInReport.form.month': 'الشهر',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.month': 'مثال: 7',
    'brand.adminTools.changeOrderDateInReport.form.year': 'السنة',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.year': 'مثال: 2025',
    'brand.adminTools.changeOrderDateInReport.form.hour': 'الساعة',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.hour': 'مثال: 10',
    'brand.adminTools.changeOrderDateInReport.form.minutes': 'الدقائق',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.minutes': 'مثال: 35',
    'brand.adminTools.changeOrderDateInReport.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.changeOrderDateInReport.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.editPasswordExpiresAt.title': 'إجبار علامة تجارية/ضيف على تغيير كلمة المرور',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.shouldResetPassword': 'force أو cancel',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.brandId': '900',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.customerId': ' ',
    'brand.adminTools.editPasswordExpiresAt.form.shouldResetPassword':
        'إجبار على تغيير كلمة المرور (force) أو إلغاء تغيير كلمة المرور (cancel)',
    'brand.adminTools.editPasswordExpiresAt.form.brandId': 'العلامة التجارية المستهدفة',
    'brand.adminTools.editPasswordExpiresAt.form.customerId':
        'الضيف(الضيوف) المستهدف(المستهدفون) يمكنك إدخال عدة معرّفات مفصولة بفاصلة، بدون مسافة، مثلاً: 123456,234567,345678). اتركه فارغاً لاستهداف العلامة التجارية بأكملها',
    'brand.adminTools.editPasswordExpiresAt.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.editPasswordExpiresAt.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.editProductSkuFromProductId.title': 'تعديل SKU لعدة منتجات من ملف Excel',
    'brand.adminTools.editProductSkuFromProductId.description': 'تنزيل {fileTemplate} على جهاز الكمبيوتر الخاص بك',
    'brand.adminTools.editProductSkuFromProductId.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.editProductSkuFromProductId.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.importProductInMenu.title': 'استيراد منتجات إلى قائمة موجودة مسبقاً',
    'brand.adminTools.importProductInMenu.description': 'تنزيل {fileTemplate} على جهاز الكمبيوتر الخاص بك',
    'brand.adminTools.importProductInMenu.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.importProductInMenu.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.importProductFromSku.title': 'تعديل واستيراد المنتجات بناءً على SKU',
    'brand.adminTools.importProductFromSku.description1':
        'استخدم {metabaseLink} للحصول على قائمة منتجات قائمتك، يمكنك تعديل أو إضافة منتجات جديدة (SKU غير إلزامي للمنتجات الجديدة).',
    'brand.adminTools.importProductFromSku.description1bis':
        'لا تعدّل SKU المنتجات الموجودة، فهو المعرّف الفريد للمنتج. لا تغير أسماء الأعمدة',
    'brand.adminTools.importProductFromSku.description2': 'تنزيل {fileTemplate} على جهاز الكمبيوتر الخاص بك',
    'brand.adminTools.importProductFromSku.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.importProductFromSku.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdSource': 'معرّف القائمة المصدر',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdSource': 'معرّف القائمة المصدر',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdDestination': 'معرّف القائمة الوجهة',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdDestination': 'معرّف القائمة الوجهة',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterCategory': '(اختياري)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterCategory': 'تصفية حسب الفئة',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterTag': '(اختياري)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterTag': 'تصفية حسب الوسم',
    'brand.adminTools.copyProductFromMenuIdToMenuId.title': 'نسخ منتجات من قائمة إلى أخرى',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description1':
        'أدخل معرّف القائمة المصدر ومعرّف القائمة الوجهة. يمكنك أيضاً تصفية المنتجات حسب الفئة و/أو الوسم لنسخ منتجات محددة فقط.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description2': 'لاحظ أن المراجع الخارجية والخطوات لن تُنسخ',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description3':
        'لن تُنسخ الصور إلا إذا كانت القائمة الوجهة في نفس المطعم كالقائمة المصدر، أو إذا كانت القائمة المصدر على مستوى العلامة التجارية والقائمة الوجهة على مستوى المطعم في نفس العلامة التجارية',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.importBackofficeUsers.title': 'استيراد مستخدمي الواجهة الخلفية',
    'brand.adminTools.importBackofficeUsers.description': 'تنزيل {fileTemplate} على جهاز الكمبيوتر الخاص بك',
    'brand.adminTools.importBackofficeUsers.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.importBackofficeUsers.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.editProductInfoFromProductId.title': 'تعديل المنتجات من ملف Excel',
    'brand.adminTools.editProductInfoFromProductId.description1':
        'استخدم {metabaseLink} للحصول على قائمة منتجات قائمتك، ثم املأ الأعمدة المخصصة للتعديل وأرفع الملف. (لا تغير أسماء الأعمدة)',
    'brand.adminTools.editProductInfoFromProductId.description2': 'تنزيل {fileTemplate} على جهاز الكمبيوتر الخاص بك',
    'brand.adminTools.editProductInfoFromProductId.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.editProductInfoFromProductId.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.editStepInfoFromStepId.title': 'تعديل الخطوات من ملف Excel',
    'brand.adminTools.editStepInfoFromStepId.description0':
        'يتيح هذا النص البرمجي تعديل أسماء ومراجع وتسميات الخطوات جماعياً، وليس قائمة المنتجات.',
    'brand.adminTools.editStepInfoFromStepId.description1':
        'استخدم {metabaseLink} للحصول على قائمة خطوات قائمتك، ثم املأ الأعمدة المخصصة للتعديل وأرفع الملف. (لا تغير أسماء الأعمدة)',
    'brand.adminTools.editStepInfoFromStepId.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.editStepInfoFromStepId.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.editProductPriceInAdminTools.title': 'تعديل أسعار المنتجات (خارج الخطوات وضمنها) من ملف Excel',
    'brand.adminTools.editProductPriceInAdminTools.description1':
        'استخدم {metabaseLink} للحصول على قائمة منتجات قائمتك، ثم املأ عمود السعر الجديد وأرفع الملف. (لا تغير أسماء الأعمدة)',
    'brand.adminTools.editProductPriceInAdminTools.description2': 'تنزيل {fileTemplate} على جهاز الكمبيوتر الخاص بك',
    'brand.adminTools.editProductPriceInAdminTools.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.editProductPriceInAdminTools.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.editProductTagFromProductId.title': 'إضافة وسم(وسوم) لعدة منتجات من ملف Excel',
    'brand.adminTools.editProductTagFromProductId.description': 'تنزيل {fileTemplate} على جهاز الكمبيوتر الخاص بك',
    'brand.adminTools.editProductTagFromProductId.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.editProductTagFromProductId.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.makeEwalletTransaction.title': 'إجراء معاملات المحفظة الإلكترونية من ملف Excel',
    'brand.adminTools.makeEwalletTransaction.description': 'تنزيل {fileTemplate} على جهاز الكمبيوتر الخاص بك',
    'brand.adminTools.makeEwalletTransaction.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'brand.adminTools.makeEwalletTransaction.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.bulkUploadDualScreenImage.title': 'رفع صورة الشاشة المزدوجة على جميع أجهزة البيع في علامة تجارية',
    'brand.adminTools.bulkUploadDualScreenImage.description':
        'ارفع صورة (PNG أو JPG) وأدخل معرّف العلامة التجارية. ستُطبَّق الصورة على جميع أجهزة البيع في العلامة التجارية.',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdLabel': 'معرّف العلامة التجارية',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdPlaceholder': 'أدخل معرّف العلامة التجارية',
    'brand.adminTools.bulkUploadDualScreenImage.form.success': 'تم رفع الصورة على جميع أجهزة البيع.',
    'brand.adminTools.transformGuestFile.title':
        'تحويل ملف بيانات الضيوف المستخرج من الموقع الجديد إلى تنسيق Innovorder',
    'brand.adminTools.transformGuestFile.fileFormat': 'تنسيق الملف الأصلي',
    'brand.adminTools.transformGuestFile.form.success': 'تم تحويل الملف بنجاح',
    'brand.adminTools.transformGuestFile.form.url': 'انقر هنا لتنزيل الملف',
    'brand.adminTools.transformGuestFile.fileFormat.JES': 'JES',
    'brand.adminTools.transformGuestFile.fileFormat.CSI': 'CSI',
    'brand.adminTools.transformGuestFile.fileFormat.X-GIL': 'x-gil',
    'brand.adminTools.transformGuestFile.fileFormat.PI-ELECTRONICS': 'Pi Electronique',
    'brand.adminTools.generateSalesReport.title': 'رفع مبيعات IO إلى نظام SI Sodexo',
    'brand.adminTools.generateSalesReport.description':
        'مزامنة مبيعات IO مع نظام SI Sodexo لمطعم محدد (في حال استخدام فترة زمنية، ستتم المزامنة للفترة المحددة)',
    'brand.adminTools.generateSalesReport.form.checkbox': 'استخدام فترة زمنية',
    'brand.adminTools.generateSalesReport.form.restaurant': 'اختر مطعماً',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.title': 'ربط SKU المنتجات بخرائط المعرّفات الخارجية',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.description':
        'إنشاء خرائط بين المعرّفات الداخلية للمنتجات وSKU الخاصة بها لقائمة محددة',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.restaurant': 'المطعم',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.menu': 'القائمة',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.success': 'تم تنفيذ النص البرمجي بنجاح.',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.error': 'حدث خطأ أثناء تشغيل النص البرمجي.',
    'spotlight.search.placeholder': 'ماذا تريد أن تفعل؟',
    'spotlight.section.suggestion': 'اقتراح',
    'spotlight.section.history': 'السجل',
    'spotlight.context.brand': 'العلامة التجارية',
    'spotlight.context.restaurant': 'المطعم',
    'spotlight.error.noHistory': 'ليس لديك بعد أي رابط مؤهل ضمن سجل التصفح الخاص بك',
    'orderList.title': 'الطلبات',
    'orderList.subtitle': 'استرجع طلبات عملائك وأصدقائك المقربين',
    'orderList.filters.allRestaurants': 'جميع المطاعم',
    'orderList.filters.restaurantHeader': 'مطاعمي',
    'orderList.filters.restaurantPlaceholder': 'البحث عن مطعم',
    'orderList.filters.dateRange.lastXdays': 'آخر {days} أيام',
    'orderList.filters.dateRange.custom': 'مخصص',
    'orderList.generation_history': 'سجل الإنشاء',
    'orderList.export': 'تصدير',
    'orderList.generate': 'إنشاء',
    'orderList.export.title': 'تصدير',
    'orderList.export.selectOneDay': 'تحديد يوم',
    'orderList.export.selectPeriod': 'تحديد فترة',
    'orderList.export.format': 'اختر تنسيق التصدير',
    'orderList.export.file.xlsx': 'Excel',
    'orderList.export.file.csv': 'CSV',
    'orderList.export.file.pdf': 'PDF',
    'orderList.export.dateRage.errorMessage': 'لا يمكنك تحديد أكثر من 31 يومًا',
    'orderList.export.presetDate.currentWeek': 'الأسبوع الحالي',
    'orderList.export.presetDate.currentMonth': 'الشهر الحالي',
    'orderList.export.presetDate.lastMonth': 'الشهر الماضي',
    'orderList.export.presetDate.chooseDate': 'يرجى تحديد فترة',
    'orderList.export.includeOrderStates': 'تضمين حالات الطلبات المختلفة',
    'order.field.ticketNumber': 'رقم التذكرة',
    'order.field.status': 'الحالة',
    'order.field.restaurant': 'المطعم',
    'order.field.channel': 'القناة',
    'order.field.customerName': 'الاسم الكامل',
    'order.field.customerNameMassCatering': 'اسم المستفيد',
    'order.field.badgeNumber': 'رقم البطاقة',
    'order.field.phone': 'رقم الهاتف',
    'order.field.pricingRule': 'نظام التسعير',
    'order.field.pricingRuleInOrder': 'نظام التسعير المطبق',
    'order.field.company': 'الشركة',
    'order.field.orderId': 'رقم الطلب',
    'order.field.consumptionMode': 'طريقة الاستهلاك',
    'order.field.orderDate': 'تاريخ الطلب',
    'order.field.expectedDate': 'تاريخ التسليم',
    'order.field.ticketDate': 'تاريخ التذكرة',
    'order.field.totalWithVat': 'الإجمالي شامل الضريبة',
    'order.field.turnoverWithVat': 'رقم الأعمال شامل الضريبة',
    'order.field.paymentMethod': 'طريقة الدفع',
    'order.field.paymentStatus': 'حالة الدفع',
    'order.field.paymentAmount': 'مبلغ الدفع',
    'order.status.PAID': 'مدفوع',
    'order.status.CANCELLED': 'ملغى',
    'order.status.VALIDATED': 'مؤكد',
    'order.status.PAID_CANCELLED': 'مدفوع (ملغى)',
    'order.status.CONTRA_ENTRY': 'قيد مقابل',
    'order.status.INCOHERENT': 'طلب غير متسق',
    'order.channel.': 'غير معروف',
    'order.channel.1': 'كشك',
    'order.channel.2': 'CEL',
    'order.channel.5': 'نقطة البيع',
    'order.channel.8': 'DA',
    'order.channel.9': 'Uber Eats',
    'order.channel.10': 'Deliveroo',
    'order.channel.11': 'Just Eat',
    'order.consumptionMode.1': 'توصيل',
    'order.consumptionMode.2': 'للاصطحاب',
    'order.consumptionMode.3': 'تناول في المكان',
    'order.consumptionMode.4': 'درايف',
    'order.webPaymentStatus.PAYMENT_OK': 'مدفوع',
    'order.webPaymentStatus.PAYMENT_PENDING': 'غير مدفوع',
    'order.webPaymentStatus.PAYMENT_REFUSED': 'مرفوض',
    'order.webPaymentStatus.PAYMENT_REFUNDED': 'مسترد',
    'order.paymentMethod.AlloResto': 'AlloResto',
    'order.paymentMethod.AmericanExpress': 'American Express',
    'order.paymentMethod.Cash': 'نقدًا',
    'order.paymentMethod.Change': 'الفكة',
    'order.paymentMethod.Check': 'شيك',
    'order.paymentMethod.CreditCard': 'بطاقة بنكية',
    'order.paymentMethod.CreditNote': 'إشعار دائن',
    'order.paymentMethod.CreditNoteIssued': 'إشعار دائن صادر',
    'order.paymentMethod.Deliveroo': 'Deliveroo',
    'order.paymentMethod.ELuncheonVoucher': 'قسيمة مطعم إلكترونية',
    'order.paymentMethod.EWallet': 'E-Wallet',
    'order.paymentMethod.ExternalPayment': 'دفع خارجي',
    'order.paymentMethod.Foodora': 'Foodora',
    'order.paymentMethod.Ingenico': 'Ingenico',
    'order.paymentMethod.LuncheonVoucher': 'قسيمة غداء',
    'order.paymentMethod.Lydia': 'Lydia',
    'order.paymentMethod.Nepting': 'Nepting',
    'order.paymentMethod.OnlineCreditCard': 'بطاقة بنكية عبر الإنترنت',
    'order.paymentMethod.Paygreen': 'Paygreen',
    'order.paymentMethod.RestoFlash': 'Resto Flash',
    'order.paymentMethod.Stripe': 'Stripe',
    'order.paymentMethod.Transfer': 'تحويل بنكي',
    'order.paymentMethod.UberEats': 'Uber Eats',
    'order.paymentMethod.Unknown': 'أخرى',
    'order.paymentMethod.Unknown2': 'أخرى 2',
    'order.paymentMethod.Edenred': 'Edenred',
    'orderDetail.error.incoherent': 'يرجى الاتصال بالدعم لتسوية الطلب',
    'orderDetail.title.1': 'كشك',
    'orderDetail.title.2': 'طلب عبر الإنترنت',
    'orderDetail.title.5': 'نقطة البيع',
    'orderDetail.title.8': 'توزيع آلي',
    'orderDetail.title.9': 'Uber Eats',
    'orderDetail.title.10': 'Deliveroo',
    'orderDetail.title.11': 'Just Eat',
    'orderDetail.title.contraEntry': 'طلب قيد مقابل',
    'orderDetail.status.PAID': 'تحصيل',
    'orderDetail.status.VALIDATED': 'فاتورة',
    'orderDetail.status.CANCELLED': 'ملغى',
    'orderDetail.tabStatus.PAID': 'بيع مدفوع',
    'orderDetail.tabStatus.VALIDATED': 'سلة مؤكدة',
    'orderDetail.tabStatus.CANCELLED': 'إلغاء',
    'orderDetail.paymentStatus.PAID': 'مدفوع',
    'orderDetail.paymentStatus.CANCELLED': 'ملغى',
    'orderDetail.paymentStatus.REFUNDED': 'مسترد',
    'orderDetail.shift.default': 'وردية افتراضية',
    'orderDetail.header.guestNumber': 'عدد الأغطية:',
    'orderDetail.header.currency': 'العملة:',
    'orderDetail.header.orderedAt': 'تاريخ الطلب',
    'orderDetail.header.deliverAt': 'موعد التسليم المتوقع',
    'orderDetail.header.deliverAtRange': 'مخطط للفترة الزمنية:',
    'orderDetail.header.status': 'الحالة',
    'orderDetail.header.payment': 'الدفع',
    'orderDetail.header.table': 'الطاولة',
    'orderDetail.kpi.date': '{date, date}',
    'orderDetail.kpi.time': '{date, date, ::HHmm}',
    'orderDetail.kpi.timeRange': 'من {start, date, ::HHmm} إلى {end, date, ::HHmm}',
    'orderDetail.ticketInfo': 'تفاصيل الطلب',
    'orderDetail.comment': 'تعليق',
    'orderDetail.userName': 'اسم العميل',
    'orderDetail.taxInfo': 'تفاصيل ضريبة القيمة المضافة',
    'orderDetail.paymentInfo': 'وسائل الدفع',
    'orderDetail.customerInfo': 'معلومات العميل',
    'orderDetail.deliveryInfo': 'التوصيل',
    'orderDetail.loyaltyInfo': 'الولاء',
    'orderDetail.posInfo': 'معلومات نقطة البيع',
    'orderDetail.transactionInfo': 'تفاصيل المعاملة',
    'orderDetail.orderPhotos': 'الصور المرتبطة بالطلب',
    'orderDetail.customer.name': 'الاسم الأول واسم العائلة',
    'orderDetail.customer.email': 'البريد الإلكتروني',
    'orderDetail.customer.phone': 'رقم الهاتف',
    'orderDetail.customer.badgeNumber': 'رقم البطاقة',
    'orderDetail.customer.pricingRule': 'نظام التسعير',
    'orderDetail.customer.pricingRuleAssigned': 'نظام التسعير المعين',
    'orderDetail.customer.group': 'المجموعة',
    'orderDetail.customer.section': 'القسم',
    'orderDetail.customer.subSection': 'القسم الفرعي',
    'orderDetail.customer.balanceInformation.ewalletBalanceBeforeOrder': 'رصيد E-Wallet السابق',
    'orderDetail.customer.balanceInformation.ewalletBalanceAfterOrder': 'رصيد E-Wallet الجديد',
    'orderDetail.Pos.restaurant': 'المطعم',
    'orderDetail.Pos.seller': 'المشغل',
    'orderDetail.Pos.deviceName': 'اسم الجهاز',
    'orderDetail.Pos.deviceId': 'معرف نقطة البيع',
    'orderDetail.action.text': 'إجراءات الطلب',
    'orderDetail.action.cancel': 'إلغاء',
    'orderDetail.action.refund': 'استرداد',
    'orderDetail.action.cancelWithContraEntry': 'إلغاء الطلب (قيد مقابل)',
    'orderDetail.cancel.title.reason': 'إلغاء الطلب',
    'orderDetail.cancel.title.manualPaymentMethod': 'طريقة دفع الاسترداد',
    'orderDetail.cancel.text1': 'عند الحاجة، يمكنك إلغاء طلب العميل.',
    'orderDetail.cancel.text2': 'يجب عليك اختيار سبب الإلغاء أدناه.',
    'orderDetail.cancel.text3': 'إذا لم يكن السبب ضمن القائمة، انقر على «أخرى».',
    'orderDetail.cancel.text4': 'سيُرسل سبب الإلغاء الذي تختاره بالبريد الإلكتروني إلى العميل.',
    'orderDetail.cancel.text5': 'ستُعاد كميات المنتجات المخصومة إلى المخزون.',
    'orderDetail.cancel.text6': 'يمكنك اختيار طريقة الدفع المرتبطة بالاسترداد.',
    'orderDetail.cancel.text7': '⚠️ من الضروري استرداد مبلغ العميل ماديًا لتفادي الفوارق المحاسبية.',
    'orderDetail.cancel.reason.description.label': 'حقل نصي حر (اختياري)',
    'orderDetail.cancel.reason.placeholder': 'اختر سبب الإلغاء',
    'orderDetail.cancel.reason.description.placeholder': '250 حرفًا كحد أقصى',
    'orderDetail.cancel.manualPaymentMethod.placeholder': 'اختر طريقة الدفع',
    'orderDetail.cancel.reason.CANNOT_FULFILL_ORDER': 'تعذّر إتمام الطلب',
    'orderDetail.cancel.reason.ORDERING_MISTAKE': 'خطأ في الطلب',
    'orderDetail.cancel.reason.UNSATISFIED_CUSTOMER': 'عميل غير راضٍ (لا تُعاد الكميات إلى المخزون)',
    'orderDetail.cancel.reason.CUSTOMER_NO_SHOW': 'لم يحضر العميل',
    'orderDetail.cancel.reason.CUSTOMER_LEAVES': 'غادر العميل',
    'orderDetail.cancel.reason.LEARNING_MODE': 'تدريب',
    'orderDetail.cancel.reason.TECHNICAL': 'خطأ تقني',
    'orderDetail.cancel.reason.OTHER': 'أخرى...',
    'orderDetail.cancel.manualPaymentMethod.Cash': 'نقدًا',
    'orderDetail.cancel.manualPaymentMethod.CreditCard': 'بطاقة بنكية',
    'orderDetail.cancel.confirm': 'إلغاء الطلب',
    'orderDetail.cancel.validate': 'تأكيد الإلغاء',
    'orderDetail.ticket.itemSum': 'إجمالي المنتجات',
    'orderDetail.ticket.grantSum': 'إجمالي الدعم',
    'orderDetail.ticket.entranceFeeSum': 'إجمالي رسوم الدخول',
    'orderDetail.ticket.pricingRule': 'نظام التسعير: ',
    'orderDetail.ticket.discountSum': 'إجمالي الخصومات',
    'orderDetail.ticket.tvaSum': 'إجمالي ضريبة القيمة المضافة',
    'orderDetail.ticket.finalPrice': 'الإجمالي',
    'orderDetail.ticket.discount': 'رمز الترويج:',
    'orderDetail.tax.taxrate': 'معدل ضريبة القيمة المضافة',
    'orderDetail.tax.totalExclTax': 'إجمالي خالٍ من الضريبة',
    'orderDetail.tax.totalTax': 'ضريبة القيمة المضافة',
    'orderDetail.tax.totalInclTax': 'إجمالي شامل الضريبة',
    'orderDetail.transaction.transactionIds': 'معرف المعاملة',
    'orderDetail.payment.quantity': 'الكمية',
    'orderDetail.payment.price': 'السعر',
    'orderDetail.delivery.address': 'العنوان',
    'orderDetail.delivery.apartmentNumber': 'رقم الشقة',
    'orderDetail.delivery.digicode': 'الرمز الرقمي',
    'orderDetail.delivery.phoneNumber': 'رقم الهاتف',
    'orderDetail.delivery.additionalInfo': 'معلومات إضافية',
    'orderDetail.linkedOrder.title.origin': 'الرابط بطلب القيد المقابل',
    'orderDetail.linkedOrder.title.contra_entry': 'الرابط بالطلب الملغى',
    'orderDetail.linkedOrder.date.origin': 'تاريخ طلب القيد المقابل',
    'orderDetail.linkedOrder.date.contra_entry': 'تاريخ الطلب الملغى',
    'orderDetail.contraEntryInfo.title': 'معلومات القيد المقابل',
    'orderDetail.contraEntryInfo.validator': 'المدقق',
    'orderDetail.contraEntryInfo.cancellationReasonDescription': 'حقل نصي حر',
    'route.ioPayTransactions': 'المعاملات',
    'route.ioPayReports': 'التقارير',
    'route.ioPayTransfers': 'التحويلات',
    'route.ioPayConfiguration': 'الإعداد',
    'route.ioPayTransferDetail': 'تفاصيل التحويل',
    'route.ioPayTransactionDetail': 'تفاصيل المعاملة',
    'ioPay.title': 'Adyen',
    'transactions.title': 'المعاملات',
    'transactions.detail.title': 'بطاقة المعاملة',
    'transactions.subtitle': 'استعراض معاملات عملائك',
    'transaction.field.id': 'المعرف',
    'transaction.field.type': 'النوع',
    'transaction.field.brand': 'العلامة التجارية',
    'transaction.field.customerEmail': 'البريد الإلكتروني',
    'transaction.field.date': 'التاريخ',
    'transaction.field.paymentMethod': 'طريقة الدفع',
    'transaction.field.paymentStatus': 'وضع الدفع',
    'transaction.field.paymentAmount': 'مبلغ الدفع',
    'transaction.field.paymentAmount.tooltip': 'المبلغ المدفوع من قبل العميل',
    'transaction.field.reversalAmount': 'المبلغ المُحوَّل من Innovorder',
    'transaction.field.reversalAmount.tooltip':
        'المبلغ المُحوَّل بعد خصم عمولة الدفع فقط (قد يكون المبلغ سالبًا إذا لم تمر الأموال عبر Innovorder وتُحوَّل مباشرةً إلى حسابك البنكي)',
    'transaction.field.amount': 'مبلغ المعاملة',
    'transaction.field.amount.tooltip': 'مجموع المبالغ المُحوَّلة من Innovorder مطروحًا منها المستردات',
    'transaction.field.fee': 'العمولة',
    'transaction.field.channel': 'القناة',
    'transaction.field.transfer': 'التحويل',
    'transaction.field.currency': 'العملة',
    'transaction.field.status': 'الحالة',
    'transaction.field.ip': 'عنوان IP',
    'transaction.field.referer': 'المرجع',
    'transaction.field.userAgent': 'User Agent',
    'transaction.field.customerCompleteName': 'الاسم الكامل',
    'transaction.field.email': 'البريد الإلكتروني',
    'transaction.field.customerId': 'معرف العميل',
    'transaction.field.badgeNumber': 'رقم البطاقة',
    'transaction.field.lastUpdate': 'تاريخ التحديث',
    'transaction.field.source': 'المصدر',
    'transaction.field.orderId': 'رقم الطلب',
    'transaction.field.error': 'خطأ',
    'transaction.field.restaurant': 'المطعم',
    'transaction.field.paymentMethodType.WEB': 'بطاقة بنكية عبر الإنترنت',
    'transaction.field.paymentMethodType.PROXIMITY': 'بطاقة بنكية',
    'transaction.field.paymentMethod.MEAL_VOUCHER': 'قسيمة مطعم',
    'transaction.field.paymentMethod.BANK_CARD': 'بطاقة بنكية',
    'transaction.status.PENDING': 'قيد المعالجة',
    'transaction.status.PENDING_3DS': '3DS قيد المعالجة',
    'transaction.status.DONE': 'ناجح',
    'transaction.status.FAILED': 'مرفوض',
    'transaction.status.ERROR': 'خطأ',
    'transaction.type.CAPTURE': 'دفع',
    'transaction.type.REFUND': 'استرداد',
    'transaction.channel.WEB': 'ويب',
    'transaction.channel.PROXIMITY': 'قريب',
    'transaction.source.WEBORDERING': 'طلب عبر الإنترنت',
    'transaction.source.EWALLET': 'إعادة شحن E-Wallet',
    'transaction.source.KIOSK': 'كشك',
    'transaction.source.NOTIFICATION': 'إشعار',
    'transaction.detail.card.main': 'تفاصيل المعاملة',
    'transaction.detail.card.finance': 'البيانات المالية',
    'transaction.detail.card.web': 'معلومات بيانات الويب',
    'transaction.detail.card.customer': 'معلومات العميل',
    'transaction.detail.card.order': 'الطلب المرتبط',
    'transaction.detail.card.paymentMethod': 'وسائل الدفع',
    'transfers.title': 'التحويلات',
    'transfers.subtitle': 'التحويلات إلى حسابك',
    'configuration.iopay.title': 'إعداد Adyen',
    'configuration.iopay.subtitle':
        'ستجد هنا جميع الكيانات القانونية التي أنشأتها لشركتك. لقد جمعنا لك نظرة عامة واضحة وموجزة عن مطاعمك وE-wallet لتسهيل إعداداتها.',
    'configuration.error.unaccessible': 'غير موجود أو صلاحيات غير كافية',
    'transfer.field.id': 'المعرف',
    'transfer.field.ref': 'المرجع',
    'transfer.field.configurationName': 'التاجر',
    'transfer.field.amount': 'مبلغ التحويل',
    'transfer.field.transactionCount': 'عدد المعاملات',
    'transfer.field.status': 'الحالة',
    'transfer.field.executedAt': 'تاريخ التنفيذ',
    'transfer.status.PENDING': 'قيد المعالجة',
    'transfer.status.SUCCESS': 'مؤكد',
    'transfer.status.SENT_OUT': 'مُرسَل',
    'transfer.status.FAILED': 'فاشل',
    'transfer.kpi.date': '{date, date} {date, time, ::HHmm}',
    'transfer.detail.title': 'تفاصيل التحويل',
    'transfer.transactions.title': 'معاملات التحويل',
    'legalEntity.field.entity': 'الكيان القانوني',
    'legalEntity.field.siret': 'SIRET',
    'legalEntity.field.city': 'المدينة',
    'legalEntity.field.status': 'الحالة',
    'legalEntity.field.associatedRestaurants': 'المطاعم المرتبطة',
    'legalEntity.field.actions': 'الإجراءات',
    'legalEntity.create.title': 'إنشاء كيان قانوني',
    'legalEntity.status.1': 'خطأ KYC',
    'legalEntity.status.2': 'بانتظار الاكتمال',
    'legalEntity.status.3': 'قيد المعالجة',
    'legalEntity.status.4': 'موافق',
    'legalEntity.action.addRestaurant': 'إضافة مطعم',
    'legalEntity.action.addEwallet': 'إضافة E-wallet',
    'legalEntity.action.completeKyc': 'إكمال KYC',
    'legalEntity.action.updateKyc': 'تحديث KYC',
    'legalEntity.wizard.step1.title': 'إنشاء كيان قانوني جديد',
    'legalEntity.wizard.step1.legalName': 'الاسم القانوني للشركة',
    'legalEntity.wizard.step1.legalName.placeholder': 'يرجى إدخال الاسم القانوني للشركة كما هو مسجل في SIRET',
    'legalEntity.wizard.step1.legalName.tooltip': 'الاسم القانوني للشركة كما هو مسجل في SIRET',
    'legalEntity.wizard.step1.organizationType': 'نوع المنظمة',
    'legalEntity.wizard.step1.organizationType.placeholder': 'يرجى تحديد نوع منظمتك',
    'legalEntity.wizard.step1.siret': 'SIRET',
    'legalEntity.wizard.step1.siret.placeholder': 'يرجى إدخال رقم SIRET الخاص بك',
    'legalEntity.wizard.step1.siret.tooltip': 'رقم SIRET للشركة',
    'legalEntity.wizard.step1.addressStreet': 'عنوان الكيان القانوني',
    'legalEntity.wizard.step1.addressStreet.placeholder': 'يرجى إدخال عنوان الكيان القانوني',
    'legalEntity.wizard.step1.addressStreet2': 'تفاصيل إضافية للعنوان (اختياري)',
    'legalEntity.wizard.step1.addressStreet2.placeholder': 'يرجى إدخال تفاصيل إضافية للعنوان إذا لزم الأمر',
    'legalEntity.wizard.step1.addressZipcode': 'الرمز البريدي',
    'legalEntity.wizard.step1.addressZipcode.placeholder': 'يرجى إدخال الرمز البريدي',
    'legalEntity.wizard.step1.addressCity': 'المدينة',
    'legalEntity.wizard.step1.addressCity.placeholder': 'يرجى إدخال اسم المدينة',
    'legalEntity.wizard.step1.industryCode': 'رمز الصناعة',
    'legalEntity.wizard.step1.contactEmail': 'البريد الإلكتروني للتواصل',
    'legalEntity.wizard.step1.contactEmail.placeholder':
        'يرجى إدخال عنوان البريد الإلكتروني المرتبط بهذا الكيان القانوني',
    'legalEntity.wizard.step1.iban': 'IBAN',
    'legalEntity.wizard.step1.iban.placeholder': 'يرجى إدخال IBAN الخاص بالكيان القانوني',
    'legalEntity.wizard.step1.iban.tooltip': 'IBAN الخاص بالكيان القانوني',
    'legalEntity.wizard.step2.title': 'إضافة مطعم جديد',
    'legalEntity.wizard.step2.titleMassCatering': 'إضافة مطعم جديد أو E-wallet',
    'legalEntity.wizard.step2.chooseRestaurant': 'تحديد مطعم',
    'legalEntity.wizard.step2.chooseRestaurantMassCatering': 'تحديد مطعم أو E-wallet',
    'legalEntity.wizard.step2.completeFieldsTitle': 'الحقول المطلوب تعبئتها',
    'legalEntity.wizard.step2.conecsTitle': 'معرفات CONECS',
    'legalEntity.wizard.step2.conecsTitleOptional': '(اختياري)',
    'legalEntity.wizard.step2.conecsTitleOptional.tooltip':
        'أدخل معرفات CONECS (ID) لتتمكن من تفعيل وسيلة الدفع CONECS على هذا المطعم للمدفوعات القريبة',
    'legalEntity.wizard.step2.ewallet': 'E-wallet',
    'legalEntity.wizard.step2.selectRestaurant': 'المطعم',
    'legalEntity.wizard.step2.selectRestaurantMassCatering': 'مطعم أو E-wallet',
    'legalEntity.wizard.step2.selectRestaurant.placeholder': 'يرجى تحديد مطعم',
    'legalEntity.wizard.step2.phoneNumber': 'رقم الهاتف',
    'legalEntity.wizard.step2.phoneNumber.placeholder': 'يرجى إدخال رقم الهاتف المرتبط بهذا المطعم',
    'legalEntity.wizard.step2.shopperStatement': 'العنوان على كشف الحساب البنكي',
    'legalEntity.wizard.step2.shopperStatement.placeholder': 'يرجى إدخال العنوان الذي سيظهر على كشف الحساب البنكي',
    'legalEntity.wizard.step2.shopperStatement.tooltip': 'البيان الظاهر على كشف الحساب البنكي للعميل النهائي',
    'legalEntity.wizard.step2.restaurantAddressStreet': 'عنوان المطعم',
    'legalEntity.wizard.step2.restaurantAddressStreet.placeholder': 'يرجى إدخال عنوان المطعم',
    'legalEntity.wizard.step2.restaurantAddressStreet2': 'تفاصيل إضافية للعنوان (اختياري)',
    'legalEntity.wizard.step2.restaurantAddressStreet2.placeholder': 'يرجى إدخال تفاصيل إضافية للعنوان إذا لزم الأمر',
    'legalEntity.wizard.step2.restaurantAddressZipcode': 'الرمز البريدي للمطعم',
    'legalEntity.wizard.step2.restaurantAddressZipcode.placeholder': 'يرجى إدخال الرمز البريدي للمطعم',
    'legalEntity.wizard.step2.restaurantAddressCity': 'المدينة',
    'legalEntity.wizard.step2.restaurantAddressCity.placeholder': 'يرجى إدخال مدينة المطعم',
    'legalEntity.wizard.step2.restaurantIban': 'IBAN',
    'legalEntity.wizard.step2.restaurantIban.placeholder': 'يرجى إدخال IBAN لتحويل الأموال',
    'legalEntity.wizard.step2.restaurantIban.tooltip':
        'أدخل معرفات CONECS (ID) لتتمكن من تفعيل وسيلة الدفع CONECS على هذا المطعم للمدفوعات القريبة',
    'legalEntity.wizard.step2.conecsId': 'CONECS MID',
    'legalEntity.wizard.step2.conecsId.placeholder': 'يرجى إدخال MID CONECS الموجود على بطاقة التوطين الخاصة بك',
    'legalEntity.wizard.step2.conecsAssociatedSiret': 'SIRET المرتبط بعقد CONECS',
    'legalEntity.wizard.step2.conecsAssociatedSiret.placeholder': 'يرجى إدخال SIRET المرتبط بعقد CONECS',
    'legalEntity.organizationType.1': 'شركة خاصة',
    'legalEntity.organizationType.2': 'شركة عامة',
    'legalEntity.organizationType.3': 'شراكة مسجلة',
    'legalEntity.organizationType.4': 'منظمة غير ربحية أو جمعية خيرية',
    'legalEntity.organizationType.5': 'منظمة حكومية',
    'legalEntity.organizationType.6': 'جمعية مسجلة كشخص اعتباري',
    'legalEntity.industryCode.specialFoodServices': 'خدمات غذائية متخصصة',
    'legalEntity.industryCode.fullServiceRestaurants': 'مطاعم بخدمة كاملة',
    'legalEntity.industryCode.limitedServiceRestaurants': 'مطاعم بخدمة محدودة (وجبات سريعة)',
    'legalEntity.industryCode.cafeteriasGrillBuffets': 'كافيتيريات وبوفيهات',
    'legalEntity.industryCode.snacksNonalcoholicBeverages': 'وجبات خفيفة ومشروبات غير كحولية',
    'legalEntity.industryCode.bakeries': 'مخابز',
    'billing.title': 'مساحة الفوترة الخاصة بي',
    'billing.subtitle': 'مرحبًا، تم إنشاء هذه المساحة لتبسيط إدارة الفواتير.',
    'billing.description':
        'ستجد هنا الفواتير مرتبة زمنيًا حسب خدمة الدفع، وأصبح من السهل الآن الاطلاع على المدفوعات الأخيرة وتنزيل الفواتير وتتبع سجل الفواتير بنقرة واحدة.',
    'billing.information.edit': 'تعديل معلومات الفوترة',
    'billing.noIssuedInvoices': 'لا توجد فواتير صادرة',
    'billing.table.creationDate': 'تاريخ الإنشاء',
    'billing.table.amount': 'المبلغ',
    'billing.table.status': 'الحالة',
    'billing.table.service': 'الخدمة',
    'billing.table.invoiceNumber': 'رقم الفاتورة',
    'billing.table.invoiceName': 'اسم الفاتورة',
    'billing.table.dueDate': 'تاريخ الاستحقاق',
    'billing.table.downloadPDF': 'تنزيل PDF',
    'billing.editConfiguration.selectEntityStep.title': 'الكيانات القانونية',
    'billing.editConfiguration.selectEntityStep.subtitle': 'تحديد كيان قانوني لتعديل معلومات الفوترة',
    'billing.editConfiguration.selectEntityStep.legalEntity': 'الكيانات القانونية',
    'billing.editConfiguration.selectEntityStep.legalEntity.placeHolder': 'يرجى التحديد من القائمة',
    'billing.editConfiguration.selectEntityStep.noLabel': 'كيان قانوني بدون اسم',
    'billing.editConfiguration.configureBillingStep.title': 'معلومات الفوترة',
    'billing.editConfiguration.configureBillingStep.beneficiaryName': 'اسم المستفيد',
    'billing.editConfiguration.configureBillingStep.beneficiaryEmail': 'عنوان البريد الإلكتروني المرتبط بالفاتورة',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress': 'عنوان المستفيد',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress2': 'معلومات إضافية',
    'billing.editConfiguration.configureBillingStep.beneficiaryZipCode': 'الرمز البريدي',
    'billing.editConfiguration.configureBillingStep.beneficiaryCity': 'المدينة',
    'billing.editConfiguration.configureBillingStep.recipients': 'مستلمو الفاتورة',
    'billing.editConfiguration.configureBillingStep.recipients.placeholder': 'عناوين البريد الإلكتروني للمستلمين',
    'billing.editConfiguration.configureBillingStep.recipients.createLabel':
        'إضافة عنوان البريد الإلكتروني "{email}" إلى المستلمين',
    'billing.editConfiguration.configureBillingStep.genericErrorMessage':
        'حدث خطأ أثناء إنشاء معلومات الإعداد أو تعديلها',
    'billing.invoices.download': 'تنزيل',
    'billing.invoices.status.1': 'مستحق الدفع',
    'billing.invoices.status.2': 'مدفوع',
    'billing.invoices.psp.4': 'Stripe',
    'billing.invoices.name.4': 'فاتورة Stripe الموحدة',
    'reports.title': 'تقارير Adyen',
    'reports.subtitle':
        'اطلع على المعاملات المحولة إلى حسابك البنكي مع التفاصيل لكل معاملة في كل تحويل. يتيح لك هذا التقرير التحقق المحاسبي من معاملات E-wallet مع Adyen.',
    'reports.text': 'إنشاء نوع أو أنواع من التقارير',
    'reports.choosePeriod': 'اختر فترة',
    'reports.chooseReport': 'تحديد نوع أو أنواع من التقارير',
    'reports.outgoingTransfers': 'التحويلات',
    'reports.reportType': 'نوع (أنواع) التقرير',
    'reports.error.missingDates': 'يرجى اختيار تاريخين',
    'reports.error.missingReportType': 'يرجى اختيار تقرير',
    'reports.error.missingBrand': 'لا توجد علامة تجارية مرتبطة بالمستخدم الحالي',
    'pricingRevaluation.tableCard.title': 'إعادة تقييم الأسعار',
    'pricingRevaluation.tableCard.subtitle':
        'حدد معدل إعادة التقييم المطلوب، وما إذا كان سيطبق على الخيارات والإضافات، ثم حدد القوائم المراد إعادة تقييمها وانقر على زر التأكيد.',
    'pricingRevaluation.input.placeholder': 'معدل إعادة التقييم',
    'consumptionMode.MODE_DELIVERY': 'توصيل',
    'consumptionMode.MODE_TAKE_AWAY': 'للاصطحاب',
    'consumptionMode.MODE_SIT_IN': 'تناول في المكان',
    'consumptionMode.MODE_DRIVE': 'درايف',
    'paymentMethods.tableCard.title': 'إدارة وإعداد',
    'paymentMethods.tableCard.subtitle': 'وسائل الدفع الخاصة بك',
    'paymentMethods.tab.pos': 'نقاط البيع',
    'paymentMethods.tab.web': 'الطلب عبر الإنترنت',
    'paymentMethods.tab.kiosk': 'الأكشاك',
    'paymentMethods.tab.kiosk.integration.title': 'المدفوعات الفورية',
    'paymentMethods.tab.kiosk.integration.desc1':
        'يستلزم الدفع بالبطاقة البنكية على الأكشاك أن يمتلك المطعم حساب Ingenico.',
    'paymentMethods.tab.kiosk.integration.desc2': 'تتوفر وسائل دفع فورية أخرى عند تفعيل المصادقة على الأكشاك.',
    'paymentMethods.tab.kiosk.payment.title': 'المدفوعات عند الاستلام',
    'paymentMethods.tab.kiosk.payment.desc': 'أبلغ المستخدمين بوسائل الدفع المقبولة في المطعم عند الكاونتر.',
    'paymentMethods.tab.kiosk.payment': 'المدفوعات',
    'paymentMethods.tab.kiosk.payment.accepted': 'مقبولة',
    'paymentMethods.tab.kiosk.payment.refused': 'مرفوضة',
    'paymentMethods.consumptionMode': 'تحديد أوضاع الاستهلاك',
    'paymentMethods.externalId': 'رمز خارجي',
    'configure.ingenico': 'إعداد Ingenico',
    'configure.nepting': 'إعداد Nepting',
    'configure.stripe': 'إعداد Stripe',
    'configure.edenred': 'إعداد Edenred',
    'configure.iopay': 'إعداد Adyen',
    'configure.paygreen': 'إعداد Paygreen',
    'configure.ewallet': 'إعداد E-Wallet',
    'configure.yavin': 'إعداد IOPay',
    'configure.yavin.neptingConfigured': 'تعذّر إعداد IOPay لأن Nepting قيد الاستخدام.',
    'configure.nepting.yavinConfigured': 'تعذّر إعداد Nepting لأن IOPay قيد الاستخدام.',
    'configure.stripe.iopayConfigured': 'تعذّر إعداد Stripe لأن Adyen قيد الاستخدام.',
    'configure.iopay.stripeConfigured': 'تعذّر إعداد Adyen لأن Stripe قيد الاستخدام.',
    'customer.form.modalDescription': 'يرجى تعبئة الحقول الإلزامية *',
    'customer.form.firstName': 'الاسم الأول *',
    'customer.form.lastName': 'اسم العائلة *',
    'customer.form.badgeNumber': 'رقم البطاقة {index} *',
    'customer.form.badgeType': 'نوع البطاقة',
    'customer.form.badge.default': 'تعيين كرئيسي',
    'customer.form.badgeType.placeholder': 'يرجى تحديد نوع البطاقة',
    'customer.form.addBadge': 'إضافة بطاقة',
    'customer.form.email': 'عنوان البريد الإلكتروني *',
    'customer.form.phoneNumber': 'رقم الهاتف (اختياري)',
    'customer.form.arrivalDate': 'تاريخ الوصول (اختياري)',
    'customer.form.departureDate': 'تاريخ المغادرة (اختياري)',
    'customer.form.password': 'كلمة المرور *',
    'customer.form.confirmPassword': 'تأكيد كلمة المرور *',
    'customer.form.clientInfoSection': 'المعلومات العامة للمستفيد',
    'customer.form.pricingRuleSection': 'إعداد قواعد التسعير',
    'customer.form.accountPaymentTypeLabel': 'نوع حساب العميل *',
    'customer.form.accountPaymentTypePlaceHolder': 'يرجى تحديد نوع حساب العميل',
    'customer.form.guestGroupIdLabel': 'المجموعة *',
    'customer.form.guestGroupIdPlaceHolder': 'يرجى تحديد مجموعة',
    'customer.form.pricingRuleCodeLabel': 'رمز نظام التسعير *',
    'customer.form.pricingRuleCodePlaceHolder': 'يرجى تحديد نظام تسعير',
    'customer.form.tariffCode': 'رمز التعريفة (اختياري)',
    'customer.form.studentNumber': 'رقم المستفيد (اختياري)',
    'customer.form.pricingRuleInfo': 'ألا يظهر رمز نظام التسعير الخاص بك في القائمة؟ يرجى إنشاؤه ',
    'customer.form.groupInfo': 'لتحديد مجموعاتك، اذهب إلى صفحة العلامة التجارية > الهيكل التنظيمي ',
    'customer.form.sectionInfo': 'لتحديد أقسامك، اذهب إلى صفحة العلامة التجارية > الهيكل التنظيمي ',
    'customer.form.subSectionInfo': 'لتحديد أقسامك الفرعية، اذهب إلى صفحة العلامة التجارية > الهيكل التنظيمي ',
    'customer.form.here': 'هنا',
    'customer.form.section': 'القسم (اختياري)',
    'customer.form.subSection': 'القسم الفرعي (اختياري)',
    'customer.form.selectOptions.cash': 'نقدًا',
    'customer.form.selectOptions.prepayment': 'دفع مسبق',
    'customer.form.selectOptions.postpayment_bankdebit': 'دفع لاحق: خصم من الراتب',
    'customer.form.selectOptions.postpayment_guest': 'دفع لاحق: ضيوف',
    'brand.customers.action.import': 'استيراد',
    'brand.customers.action.export': 'تصدير',
    'brand.customers.page.title': 'العملاء',
    'brand.customers.page.description': 'ستجد هنا القائمة الكاملة للعملاء المسجلين في علامتك التجارية.',
    'customer.modal.import.title': 'استيراد العملاء',
    'customer.modal.import.firstPart': 'تنزيل {fileTemplate} على جهاز الكمبيوتر',
    'customer.modal.import.secondPart': 'تعبئة الملف ببيانات عملائك',
    'customer.modal.import.thirdPart': 'رفع الملف لاستيراد عملائك',
    'customer.modal.import.report.title': 'تقرير الاستيراد',
    'customer.modal.import.report.result': 'النتيجة',
    'customer.modal.import.report.success': 'ناجح',
    'customer.modal.import.report.error': 'خطأ',
    'customer.modal.import.report.message': '{created} تم إنشاؤهم، {updated} تم تحديثهم، {unchanged} بدون تغيير',
    'customer.modal.import.warning':
        "تنبيه! أعمدة 'رمز التعريفة' و'رمز الدعم' و'رمز الدخول' و'رمز نظام التسعير' مهجورة وسيتم تجاهلها عند الاستيراد. يرجى استخدام جدول أنظمة التسعير لإعداد هذه المعلومات.",
    'customer.modal.import.addNew.title': 'إضافة عملاء جدد',
    'customer.modal.import.addNew.step1': 'تنزيل {link} على جهاز الكمبيوتر',
    'customer.modal.import.addNew.step1.link': 'ملف النموذج',
    'customer.modal.import.addNew.step2': 'تعبئة الملف ببيانات عملائك الجدد',
    'customer.modal.import.addNew.step3': 'رفع الملف المعبأ أدناه',
    'customer.modal.import.update.title': 'تحديث العملاء الحاليين',
    'customer.modal.import.update.step1': 'تنزيل {link} على جهاز الكمبيوتر',
    'customer.modal.import.update.step1.link': 'قاعدة العملاء الحالية',
    'customer.modal.import.update.step1.loading': 'جارٍ التحميل...',
    'customer.modal.import.update.step2': 'تعديل بيانات العملاء الذين تريد تحديثهم',
    'customer.modal.import.update.step3': 'رفع الملف المعدّل أدناه',
    'customer.modal.import.update.warning': 'ملاحظة: يجب أن يتطابق معرف العميل مع عميل موجود لإتمام التحديث.',
    'customer.modal.import.options.title': 'خيارات الاستيراد',
    'customer.modal.import.options.multiBadge': 'استيراد متعدد البطاقات',
    'customer.modal.import.options.autoImportGuestHierarchy':
        'استيراد تلقائي للهيكل التنظيمي (المجموعات والأقسام والأقسام الفرعية)',
    'customer.modal.import.error.noResponse': 'فشل الاستيراد - لا استجابة من الخادم',
    'customer.modal.import.error.invalidResponse': 'استجابة غير صالحة من الخادم',
    'customer.modal.import.error.fileTooLarge': 'الملف كبير جدًا (الحد الأقصى 20 ميغابايت)',
    'customer.modal.import.loading.reading': 'جارٍ قراءة الملف...',
    'customer.modal.import.loading.importing': 'جارٍ الاستيراد...',
    'customer.modal.import.result.lineError': 'السطر {lineNumber}{nameDisplay}: {error}',
    'customer.modal.import.result.fieldError': 'لم يتم تعديل الحقول ({fields}) (السطر {line})',
    'customer.modal.import.result.genericError': 'حدث خطأ',
    'customer.modal.import.result.created': 'العملاء المُنشأون: {count}',
    'customer.modal.import.result.updated': 'العملاء المُحدَّثون: {count}',
    'customer.modal.import.result.unchanged': 'العملاء غير المعدَّلين/غير المُنشأين: {count}',
    'customer.modal.import.result.errors': 'أخطاء',
    'customer.modal.import.result.warnings': 'تحذيرات',
    'customer.modal.import.result.otherWarning.PRICING_RULE': 'بعض قواعد التسعير غير موجودة في النظام: ',
    'customer.modal.import.result.otherWarning.ENTRANCE_FEE': 'بعض رسوم الدخول غير موجودة في النظام: ',
    'customer.modal.import.result.otherWarning.EMPTY_GUEST_GROUP': 'بعض المستفيدين لديهم مجموعة فارغة (الأسطر: ',
    'customer.modal.import.result.otherWarning.UNEXISTING_GUEST_GROUP': 'بعض مجموعات المستفيدين غير موجودة (الأسطر: ',
    'customer.modal.import.result.otherWarning.UNAUTHORIZED_PRICING_RULE':
        'بعض قواعد التسعير غير مسموح بها للمجموعة (الأسطر: ',
    'customer.modal.import.result.restrictedFieldsInfo':
        'لا يمكن تحديث حقول «كلمة المرور» و«رمز PIN» و«الرصيد» إلا إذا لم ينفذ العميل أي معاملة بعد.',
    'customer.create.modalTitle': 'إنشاء مستفيد جديد',
    'customer.update.modalTitle': 'تعديل المستفيد',
    'customer.tab.info': 'المعلومات',
    'customer.tab.ewallet': 'E-Wallet',
    'customer.tab.student': 'الإطعام الجماعي',
    'customer.tab.orders': 'سجل الطلبات',
    'route.customerPricingPolicy': 'السياسة التسعيرية',
    'customer.pricingPolicy.defaultTitle': 'السياسة الافتراضية',
    'customer.pricingPolicy.defaultDescription':
        'ستُطبَّق السياسة التسعيرية الافتراضية على كل عميل يُنشئ حسابه عبر وحدة الطلب على الويب.',
    'customer.pricingPolicy.customTitle': 'سياسة مخصصة',
    'customer.pricingPolicy.entranceFee': 'رسوم الدخول',
    'customer.pricingPolicy.pricingPolicy': 'نظام التسعير',
    'customer.pricingPolicy.group': 'المجموعة',
    'customer.pricingPolicy.groupPlaceholder': 'مجموعتي',
    'customer.pricingPolicy.domainName': 'اسم النطاق',
    'customer.pricingPolicy.delete': 'حذف',
    'customer.pricingPolicy.noEntranceFee': 'لا رسوم دخول',
    'customer.pricingPolicy.noPricingRule': 'لا قاعدة تسعير',
    'customer.pricingPolicy.noGroup': 'لا مجموعة',
    'customer.pricingPolicy.enableWhitelisting': 'تقييد التسجيل على النطاقات المعلنة',
    'customer.pricingPolicy.enableWhitelistingInfo':
        'بتفعيل هذا الخيار، لا يُسمح بالتسجيل عبر الإنترنت إلا للنطاقات المعلنة',
    'customer.pricingPolicy.save': 'حفظ',
    'customer.student.info.title': 'المعلومات',
    'customer.student.info.desctiption': 'المعلومات المتعلقة بوضع الإطعام الجماعي.',
    'customer.student.info.account.type': 'نوع البطاقة',
    'customer.student.info.group': 'المجموعة',
    'customer.student.info.section': 'القسم',
    'customer.student.info.sub.section': 'القسم الفرعي',
    'customer.student.info.badge.number': 'رقم البطاقة',
    'customer.student.info.pricing.code': 'رمز التعريفة',
    'customer.student.info.student.number': 'رقم المستفيد',
    'customer.student.pricing.rules.title': 'قواعد التسعير',
    'customer.student.pricing.rules.desctiption':
        'يمكنك تخصيص قواعد تسعير محددة لكل عميل. يمكن أن يمتلك العميل رمز دعم و/أو رمز دخول أو رمز نظام تسعير (مجموعة من رسوم الدخول و/أو الدعم).',
    'customer.student.pricing.rules.deprecated':
        '⚠️ حقلا رمز الدخول ورمز الدعم مهجوران الآن لصالح حقل رمز نظام التسعير (الذي يجمع الدخول والدعم). {moreInfo}',
    'customer.student.pricing.rules.more_info': 'مزيد من المعلومات',
    'customer.student.pricing.rules.grant.code': 'رمز الدعم',
    'customer.student.pricing.rules.entrance.fee.code': 'رمز الدخول',
    'customer.student.pricing.rules.code': 'رمز نظام التسعير',
    'customer.student.overdraft.title': 'السحب على المكشوف المسموح به لـ E-Wallet',
    'customer.student.overdraft.desctiption':
        'يمكنك تخصيص الحد الأقصى للسحب على المكشوف المسموح به للعميل عند استخدام E-Wallet الخاص به.',
    'customer.student.overdraft.price.label': 'السحب على المكشوف المسموح به لـ E-Wallet',
    'customer.student.overdraft.disabled': 'السحب على المكشوف الافتراضي لـ E-Wallet مُطبَّق على هذا العميل.',
    'customer.student.badge.title': 'حظر البطاقة الرئيسية للمستفيد',
    'customer.student.badge.description': 'يمكنك حظر عمل البطاقة الرئيسية مؤقتًا.',
    'customer.student.badge.table.default': 'رئيسية',
    'customer.student.badge.table.number': 'رقم البطاقة',
    'customer.student.badge.table.type': 'النوع',
    'customer.student.badge.table.status': 'الحالة',
    'customer.student.badge.table.action': 'الإجراء',
    'customer.student.badge.table.status.active': '✓ مفعّل',
    'customer.student.badge.table.status.blocked': '✕ محظور',
    'customer.student.add.badge': '+ إضافة بطاقة',
    'customer.student.badge.form.add': 'إضافة بطاقة',
    'customer.student.badge.form.update': 'تعديل بطاقة',
    'customer.student.badge.form.default': 'تعيين كرئيسية',
    'customer.ordersList.title': 'الطلبات',
    'customer.ordersList.subtitle': 'استعراض طلبات عميلك',
    'customer.ordersList.downloadTickets': 'تنزيل التذاكر',
    'customer.ordersList.exportStarted': 'جارٍ تصدير التذاكر. يرجى الانتظار...',
    'customer.ordersList.exportSuccess': 'تم تصدير التذاكر بنجاح!',
    'customer.ordersList.exportFailed': 'فشل تصدير التذاكر. يرجى المحاولة مرة أخرى.',
    'customer.ordersList.exportNoTicketsForDates': 'لا توجد تذاكر للتواريخ المحددة.',
    'customer.ordersList.downloadChoice.all': 'جميع التذاكر',
    'customer.ordersList.downloadChoice.selectedRange': 'التواريخ المحددة فقط',
    'order.field.downloadTicket': 'تنزيل',
    'pricingRevaluation.options.exceeding': 'تطبيق على التجاوزات',
    'pricingRevaluation.options.options': 'تطبيق على الخيارات',
    'pricingRevaluation.options.updateInPlace': 'قائمة الثلاجة المتصلة/مسح الصينية',
    'pricingRevaluation.options.updateInPlace.tooltip':
        'إذا كانت خانة الاختيار محددة، ستُطبَّق إعادة التقييم مباشرةً على القائمة الأصلية للحفاظ على المعرفات (ستُنشأ نسخة من القائمة بدون إعادة تقييم). \nإذا لم تكن خانة الاختيار محددة، ستُطبَّق إعادة التقييم على نسخة من القائمة (معرفات جديدة) ولن تتغير القائمة الأصلية.',
    'pricingRevaluation.table.menu.name': 'اسم القائمة',
    'pricingRevaluation.table.menu.isActive': 'القائمة نشطة',
    'pricingRevaluation.table.menu.channels': 'القنوات',
    'pricingRevaluation.table.menu.selected': 'محدد',
    'pricingRevaluation.table.emptyMessage': 'لم يتم العثور على قوائم لهذا المطعم',
    'pricingRevaluation.table.search': 'البحث عن قوائم',
    'pos_layout.name': 'خطة مفاتيح نقطة البيع',
    'pos_layout.page.title': 'خطة مفاتيح نقطة البيع',
    'pos_layout.page.description': 'نظّم خطة المفاتيح ثم انشرها على نقطة البيع أو نقاط البيع المرتبطة.',
    'pos_layout.sort': 'إعادة الترتيب',
    'pos_layout.sort.random': 'عشوائي',
    'pos_layout.sort.by_name': 'حسب الاسم',
    'pos_layout.sort.by_price': 'حسب السعر',
    'pos_layout.tabletSize': 'حجم الجهاز اللوحي',
    'pos_layout.inches': 'بوصة',
    'pos_layout.publishDescription':
        'هل أنت متأكد من رغبتك في حفظ ونشر القائمة وخطة المفاتيح على نقطة (نقاط) البيع المرتبطة؟',
    'pos_layout.assignPos': 'ربط نقاط البيع',
    'pos_layout.modal.warning': 'تنبيه',
    'pos_layout.modal.publish.description':
        'الفئات التالية في خطة المفاتيح لا تحتوي على منتجات مرتبطة: \n• {categories} \nهل تريد تأكيد نشر خطة المفاتيح هذه؟',
    'pos_layout.modal.save.description':
        'الفئات التالية في خطة المفاتيح لا تحتوي على منتجات مرتبطة: \n• {categories} \nهل تريد تأكيد حفظ خطة المفاتيح هذه؟',
    'pos_layout.customPrice': 'سعر حر',
    'pos_layout.functions.create.title': 'إضافة مفتاح وظيفي',
    'pos_layout.functions.edit.title': 'تعديل المفتاح الوظيفي',
    'pos_layout.functions.type': 'نوع المفتاح',
    'pos_layout.functions.type.placeholder': 'تحديد نوع',
    'pos_layout.functions.type.webview': 'رابط ويب / URL',
    'pos_layout.functions.name': 'اسم المفتاح',
    'pos_layout.functions.url': 'رابط الويب/URL المستهدف',
    'pos_layout.functions.submit': 'حفظ',
    'pos_layout.functions.verifyLink': 'التحقق من الرابط',
    'pos_layout.functions.widthPercent': 'العرض',
    'pos_layout.functions.heightPercent': 'الارتفاع',
    'pos_device.role.independent': 'مستقل',
    'pos_device.role.master': 'رئيسي',
    'pos_device.role.slave': 'تابع',
    'pos_device.role.independent.plural': 'مستقلة',
    'pos_device.role.master.plural': 'رئيسية',
    'pos_device.role.slave.plural': 'تابعة',
    'action.action': 'إجراء',
    'action.edit': 'تعديل',
    'action.duplicate': 'تكرار',
    'action.copy': 'نسخ',
    'action.export': 'تصدير',
    'action.publish': 'نشر',
    'action.delete': 'حذف',
    'action.hide': 'إخفاء',
    'customers.page.title': 'العملاء',
    'customers.page.description': 'استعراض عملائك',
    'customers.id': 'المعرف',
    'customers.name': 'العميل',
    'customers.email': 'البريد الإلكتروني',
    'customers.phone': 'رقم الهاتف',
    'customers.totalSpentAmount': 'إجمالي الإنفاق',
    'customers.orderCount': 'عدد الطلبات',
    'customers.averageCart': 'متوسط قيمة السلة',
    'customers.lastOrder': 'آخر طلب',
    'customers.frequency': 'التكرار',
    'customers.status': 'الحالة',
    'customers.ewalletBalance': 'رصيد E-Wallet',
    'customers.archivedAt': 'تم الأرشفة في',
    'customers.disabledAt': 'تم التعطيل في',
    'customers.showArchivedCustomers': 'عرض العملاء المؤرشفين',
    'customers.showDisabledCustomers': 'عرض العملاء المعطَّلين',
    'customers.options': 'الخيارات',
    'customers.domainNames': 'أسماء النطاقات',
    'customers.selectDomainNames': 'اختر أسماء النطاقات',
    'customers.groups': 'المجموعات',
    'customers.selectGroups': 'اختر المجموعات',
    'menu.name': 'اسم القائمة',
    'menu.categories': 'الفئات',
    'menu.products': 'المنتجات',
    'menu.functions': 'الوظائف',
    'menu.page.title': 'القوائم',
    'menu.page.description': 'أنشئ قوائمك وأدِرها',
    'menu.table.associatedChannels': 'القنوات المرتبطة',
    'menu.action.newMenu': '+ قائمة جديدة',
    'menu.action.manualImportCrous': 'فرض استيراد Crous',
    'menu.action.seeOperations': 'عرض العمليات',
    'menu.action.changeColor': 'تغيير اللون',
    'menu.action.editProduct': 'تعديل المنتج',
    'menu.action.editCategory': 'تعديل الفئة',
    'menu.action.editFunction': 'تعديل الوظيفة',
    'menu.action.import': 'استيراد قائمة',
    'menu.action.noImport': 'لا أرغب في استيراد ملف',
    'menu.modal.manualImportCrous.title': 'الاستيراد اليدوي لكتالوج CROUS',
    'menu.modal.manualImportCrous.description':
        'هل أنت متأكد من رغبتك في تشغيل استيراد يدوي لكتالوج CROUS لهذا المطعم؟',
    'menu.action.aiMenuScan': 'مسح ذكي (تجريبي)',
    'menu.modal.aiMenuScan.title': 'رقمنة قائمتك الجديدة (تجريبي)',
    'menu.modal.aiMenuScan.description.part1': 'استورد قائمتك الجديدة بصيغة PDF أو صورة',
    'menu.modal.aiMenuScan.description.part2': 'انقر على توليد قائمة Excel',
    'menu.modal.aiMenuScan.description.part3': 'قم بتنزيل ملف Excel للقائمة الجديدة تلقائيًا مع المعلومات المتاحة',
    'menu.modal.aiMenuScan.action.cancel': 'إلغاء',
    'menu.modal.aiMenuScan.action.generate': 'توليد قائمة Excel',
    'menu.modal.bannersDeactivated':
        '{count, plural, one {تم تعطيل # لافتة ترويجية} other {تم تعطيل # لافتات ترويجية}}',
    'menu.modal.create.importMenu': 'استيراد قائمة',
    'menu.modal.create.createMenu': 'إنشاء قائمة',
    'menu.modal.error.wrongName': 'أدخل اسمًا صحيحًا',
    'menu.modal.create.import.excel.tab': 'Excel',
    'menu.modal.create.import.json.tab': 'JSON',
    'menu.modal.create.import.pos.tab': 'نقطة البيع',
    'menu.modal.create.import.excel.title': 'إضافة قائمة جديدة',
    'menu.modal.create.import.excel.description.firstPart': 'قم بتنزيل {fileTemplate} على جهاز الحاسوب الخاص بك',
    'menu.modal.create.import.excel.description.secondPart':
        'أملأ ملف النموذج بمعلومات منتجاتك التي تُكوِّن القائمة الجديدة',
    'menu.modal.create.import.excel.description.thirdPart': 'استورد ملفك الجديد بالنقر على الزر أدناه',
    'menu.modal.create.import.pos.title': 'استيراد قائمة موجودة',
    'menu.modal.create.import.pos.description.firstPart': 'اختر نقطة بيع Innovorder التي تريد استيراد قائمتها',
    'menu.modal.create.import.json.title': 'استيراد قائمة موجودة',
    'menu.modal.create.import.json.description.firstPart': 'تحقق من أن ملفك بصيغة JSON',
    'menu.modal.create.import.json.description.secondPart': 'استورد ملفك الجديد بالنقر على الزر أدناه',
    'menu.modal.duplicate.title': 'تكرار قائمة',
    'menu.modal.delete.title': 'حذف قائمة',
    'menu.modal.delete.description': 'هل أنت متأكد من رغبتك في حذف القائمة: "{menuName}" ؟',
    'menu.modal.copy.title': 'نسخ قائمة',
    'menu.modal.publish.title': 'نشر القائمة',
    'menu.modal.publish.autoPublish': 'إعادة تحميل الأكشاك بعد التأكيد',
    'menu.modal.publish.devicePublish': 'نشر القوائم على نقاط البيع التالية:',
    'menu.modal.publish.deliverooPublish': 'نشر القوائم على العلامات التجارية Deliveroo التالية:',
    'menu.modal.publish.ubereatsPublish': 'نشر القوائم على العلامات التجارية UberEats التالية:',
    'menu.modal.publish.duplicateBarCode': '\n- الباركود {barCode} مكرر للمنتجات التالية: {products}',
    'menu.modal.error.name': 'أدخل اسمًا في الحقل المخصص',
    'menu.modal.error.channels': 'يجب تعطيل خيار المزامنة مع نقاط البيع المرتبطة',
    'menu.modal.menu.name': 'اسم القائمة',
    'menu.modal.message.defaultIncompatibleDisclaimer':
        'يمكنك ربط نقاط البيع الرئيسية أو المستقلة فقط بإصدار 7.0 كحد أدنى',
    'menu.modal.message.versionIncompatibleDisclaimer': 'يمكنك ربط نقاط البيع التي تعمل بإصدار {values} كحد أدنى فقط',
    'menu.modal.message.roleIncompatibleDisclaimer': 'لا يمكنك ربط نقاط البيع {values}',
    'menu.modal.channels.shouldSyncPos': 'المزامنة مع نقاط البيع',
    'menu.modal.channels.isSyncFromPosEnabled': 'تحديث القائمة عند إجراء تعديلات من نقاط البيع المرتبطة',
    'menu.modal.channels.selectActive': 'تفعيل القائمة على القنوات التالية',
    'menu.modal.channels.associatedChannels': 'القنوات المرتبطة',
    'menu.modal.channels.pos.selectActive': 'اختر نقاط البيع لربطها بالقائمة',
    'menu.modal.channels.deliveroo.selectActive': 'اختر علامات Deliveroo التجارية لربطها بالقائمة',
    'menu.modal.channels.ubereats.selectActive': 'اختر علامات UberEats التجارية لربطها بالقائمة',
    'menu.modal.channels.pos.notFound': 'لم يتم العثور على أي نقطة بيع.',
    'menu.modal.channels.associatePos': 'ربط نقاط البيع',
    'menu.modal.channels.associateDeliveroo': 'ربط علامات Deliveroo التجارية',
    'menu.modal.channels.associateUberEats': 'ربط علامات UberEats التجارية',
    'menu.modal.channels.editMenu': 'تعديل القائمة',
    'menu.modal.channels.createMenu': 'إنشاء القائمة',
    'menu.modal.channels.selectPos': 'اختيار نقاط البيع',
    'menu.modal.channels.selectDeliveroo': 'اختيار علامات Deliveroo التجارية',
    'menu.modal.channels.selectUberEats': 'اختيار علامات UberEats التجارية',
    'menu.modal.externalId': 'الكود الخارجي',
    'menu.modal.warn.shift.title': 'عملية خطرة',
    'menu.modal.warn.shift.text': 'قد يؤثر تعديل قائمة أثناء الخدمة على تجربة العميل في الأكشاك المرتبطة.',
    'menu.modal.warn.shift.button': 'موافق',
    'menu.importPOS.cancel': 'ليس الآن',
    'menu.importPOS.title': 'استيراد قوائم نقاط البيع المفقودة إلى لوحة الإدارة',
    'menu.importPOS.step1.title': 'جديد: أضف قوائم نقاط البيع الخاصة بك هنا بنقرة واحدة!',
    'menu.importPOS.step1.bullet.1': 'إدارة أبسط وأعمق لخطة اللمس والقوائم',
    'menu.importPOS.step1.bullet.2': 'إمكانية إعداد خطة اللمس مسبقًا وتفعيلها بنقرة واحدة',
    'menu.importPOS.step1.bullet.3': 'إمكانية استخدام نفس القائمة لنقطة البيع والكشك والطلب عبر الإنترنت',
    'menu.importPOS.step1.info':
        'فقط نقاط البيع بإصدار أعلى من 7 وفئة مستقلة أو رئيسية يمكنها حفظ قائمتها في لوحة الإدارة',
    'menu.importPOS.step2.pos': 'نقاط البيع المستوردة إلى لوحة الإدارة',
    'menu.importPOS.step2.switch': 'تحديث القائمة عند إجراء تعديلات مستقبلية من نقطة البيع المرتبطة',
    'menu.importPOS.step3.title': 'تم بنجاح!',
    'menu.importPOS.step3.subtitle': 'يمكنك الآن إدارة نقاط البيع الخاصة بك مباشرةً من لوحة الإدارة!',
    'menu.importPOS.step3.link': 'الوصول إلى الوثائق',
    'menu.importPOS.step3.info1': 'انقر على القائمة التي تختارها لعرضها وتعديلها',
    'menu.importPOS.step3.info2':
        'يمكنك تكرار قائمة لإعداد قائمتك القادمة أو تعديل نقاط البيع وأوضاع الاستهلاك المرتبطة بكل قائمة',
    'menu.importPOS.step3.info3':
        'طالما لم تنشر قائمة، ستبقى دون تغيير في نقاط البيع المرتبطة.\n<strong>يجب عليك إذن تنفيذ إجراء النشر حتى تُطبَّق التعديلات التي أجريتها على القائمة في لوحة الإدارة على نقاط البيع.</strong>\nيمكن القيام بذلك من خيارات كل قائمة في صفحة القوائم أو من صفحة خطة اللمس.',
    'menuoperation.page.title': 'عمليات القوائم',
    'menuoperation.page.description': 'اطلع على عمليات القوائم الخاصة بمطعمك',
    'menuoperation.type': 'النوع',
    'menuoperation.type.update': 'تحديث',
    'menuoperation.type.publish': 'نشر',
    'menuoperation.type.propagation': 'نشر موسع',
    'menuoperation.message.from': 'من',
    'menuoperation.message.from.brandMenu': 'من قائمة العلامة التجارية:',
    'menuoperation.message.to': 'إلى',
    'menuoperation.errorModal.title': 'تقرير النشر',
    'menuoperation.errorModal.message': 'تعذر إتمام النشر.',
    'menuoperation.errorModal.checklist.intro': 'يرجى التحقق من النقاط التالية قبل التأكيد مجددًا:',
    'menuoperation.errorModal.checklist.requiredFields': 'جميع الحقول الإلزامية للمنتج مكتملة',
    'menuoperation.errorModal.checklist.requiredMenuImage': 'القائمة تحتوي على صورة',
    'menuoperation.errorModal.checklist.noSubCategories': 'القائمة لا تحتوي على فئات فرعية',
    'menuoperation.errorModal.checklist.imageFormats':
        'الصور تستوفي الأبعاد المطلوبة (بين 320×320 بكسل و6000×6000 بكسل)',
    'menuoperation.errorModal.checklist.syncSettings': 'إعدادات المزامنة مُهيَّأة بشكل صحيح',
    'menuoperation.errorModal.checklist.stepDepthLimit': 'لم يتجاوز حد عمق الخطوات (مستويان كحد أقصى لـ Deliveroo).',
    'menuoperation.actions': 'الإجراءات',
    'menuoperation.action.download': 'القائمة السابقة',
    'menuoperation.action.download.before': 'القائمة الأولية',
    'menuoperation.action.download.after': 'القائمة النهائية',
    'menuoperation.download.error.title': 'فشل التنزيل',
    'menuoperation.download.error': 'تعذر تنزيل القائمة المؤرشفة. يرجى المحاولة مجددًا لاحقًا.',
    'menu.tags.title': 'العلامات',
    'menu.tags.table.name': 'الاسم',
    'menu.tags.create.link': 'إنشاء علامة جديدة',
    'menu.tags.create.error.alreadyTaken': 'هذه العلامة موجودة بالفعل',
    'menu.tags.edit.title': 'تعديل علامة',
    'menu.tags.create.title': 'إنشاء علامة',
    'menu.tags.form.color.label': 'اللون',
    'menu.tags.delete.confirm': 'هل أنت متأكد من رغبتك في حذف {count} علامة/علامات؟',
    'menu.functions.title': 'الوظائف',
    'menu.functions.subtitle': 'أضف وعدِّل وعيِّن وظائف لخطة اللمس الخاصة بك',
    'menu.functions.table.name': 'الاسم',
    'menu.functions.table.type': 'النوع',
    'menu.functions.table.status': 'الحالة',
    'menu.functions.table.action': 'الإجراء',
    'menu.functions.status.active': 'نشطة',
    'menu.functions.status.inactive': 'غير نشطة',
    'menu.functions.noData': 'لا توجد وظائف مُنشأة',
    'menu.functions.delete.confirm': 'هل أنت متأكد من رغبتك في حذف {count} وظيفة/وظائف؟',
    'menu.steps.title': 'الخطوات',
    'menu.steps.add.title': 'خطوة جديدة',
    'menu.steps.duplicate': 'تكرار',
    'menu.steps.convert': 'تحويل',
    'menu.steps.delete.confirm': 'هل أنت متأكد من رغبتك في حذف {count} خطوة/خطوات؟',
    'menu.steps.convert.toCustomization.confirm':
        'بعد التحويل، ستحتاج إلى ضبط تفاصيل وخيارات خطوة التخصيص الخاصة بك. هل تريد المتابعة؟',
    'menu.steps.convert.toCrossSelling.confirm':
        'عند تحويل الخطوة، لن يتم الاحتفاظ بمعلومات الحد الأدنى/الأقصى للاختيارات والخيارات المفعّلة. هل تريد المتابعة؟',
    'menu.steps.bulkConvertError': 'لإجراء تحويل جماعي، يجب أن تكون جميع الخطوات من نفس النوع (بيع إضافي أو تخصيص)',
    'menu.steps.column.name': 'الاسم',
    'menu.steps.column.choices': 'الاختيارات المتاحة',
    'menu.steps.column.min': 'الحد الأدنى',
    'menu.steps.column.max': 'الحد الأقصى',
    'menu.steps.column.stepRef': 'المرجع',
    'menu.steps.column.parentsProducts': 'عدد المنتجات الأصلية',
    'menu.steps.edit.title': 'تعديل خطوة',
    'menu.steps.editCustomization.title': 'تعديل خطوة التخصيص',
    'menu.steps.editCrossSelling.title': 'تعديل خطوة البيع الإضافي',
    'menu.steps.createCustomization.title': 'إنشاء تخصيص',
    'menu.steps.createCrossSelling.title': 'إنشاء بيع إضافي',
    'menu.steps.convert.title': 'تنبيه',
    'menu.steps.column.type': 'النوع',
    'menu.steps.typeName.1': 'تخصيص',
    'menu.steps.typeName.2': 'بيع إضافي',
    'menu.steps.form.ticketLabel': 'تسمية التذكرة',
    'menu.steps.form.minChoice': 'الحد الأدنى للاختيارات',
    'menu.steps.form.maxChoice': 'الحد الأقصى للاختيارات',
    'menu.steps.form.stepRef': 'المرجع',
    'menu.steps.form.maxChoice.error.greaterThanMin': 'يجب أن يكون أكبر من الحد الأدنى',
    'menu.steps.form.isDescriptionDisplayEnabled': 'عرض الأوصاف',
    'menu.steps.form.options': 'الخيارات',
    'menu.steps.form.isExcessAllowed': 'تجاوز الحد',
    'menu.steps.form.isGroupEnabled': 'التجميع',
    'menu.steps.form.isImageDisplayEnabled': 'عرض الصور',
    'menu.steps.form.isQuantitySelectionEnabled': 'الكمية',
    'menu.steps.form.isWeightStrategyEnabled': 'استخدام الأوزان',
    'menu.steps.form.stepProduct': 'قائمة الاختيارات',
    'menu.steps.form.stepProduct.add': 'إضافة اختيار',
    'menu.steps.form.stepProduct.orderByName': 'ترتيب حسب الاسم',
    'menu.steps.form.stepProduct.orderByPrice': 'ترتيب حسب السعر',
    'menu.steps.form.stepProduct.setForAllOption': 'نشر القيم',
    'menu.steps.form.stepProduct.name': 'الاسم',
    'menu.steps.form.stepProduct.price': 'السعر',
    'menu.steps.form.stepProduct.excessPrice': 'سعر التجاوز',
    'menu.steps.form.stepProduct.weight': 'الوزن الوحدوي',
    'menu.steps.form.stepProduct.group': 'المجموعة',
    'menu.steps.form.stepProduct.maxQuantity': 'الحد الأقصى للكمية',
    'menu.steps.form.stepProduct.posIsSelectedByDefault': 'محدد افتراضيًا (POS)',
    'menu.steps.form.stepProduct.posMinProductQuantity': 'الحد الأدنى للكمية (POS)',
    'menu.steps.form.stepProduct.posDefaultProductQuantity': 'الكمية الافتراضية (POS)',
    'menu.steps.form.stepProduct.displayPOSFields': 'عرض سمات POS',
    'menu.steps.form.stepProduct.import': 'استيراد',
    'menu.steps.form.stepProduct.importWithPrice': 'استيراد مع السعر',
    'menu.steps.form.stepProduct.importWithoutPrice': 'استيراد بدون السعر',
    'menu.steps.propagate.title': 'نشر الخطوات',
    'menu.categories.title': 'الفئات',
    'menu.categories.subtitle': 'تعديل فئات قائمتك',
    'menu.categories.addCategory': 'إنشاء فئة',
    'menu.categories.noData': 'لا توجد فئات في القائمة.',
    'menu.categories.addProduct': 'إضافة منتج',
    'menu.categories.createProduct': 'إنشاء منتج',
    'menu.categories.deleteCategory': 'حذف',
    'menu.categories.removeProduct': 'إزالة',
    'menu.categories.deleteCategory.confirm':
        'هل أنت متأكد من رغبتك في حذف هذه الفئة؟\nلن تكون متاحة بعد الآن وستصبح عناصرها الفرعية (المنتجات والفئات الفرعية) يتيمة.',
    'menu.categories.create.title': 'إنشاء فئة',
    'menu.categories.edit.title': 'تعديل فئة',
    'menu.categories.products': '{productCount, plural, =0 {لا توجد منتجات} one {# منتج} other {# منتجات}}',
    'menu.categories.create.error.alreadyTaken': 'هذه الفئة موجودة بالفعل',
    'menu.products.title': 'المنتجات',
    'menu.products.table.image': 'الصورة',
    'menu.products.table.name': 'الاسم',
    'menu.products.table.categories': 'الفئات',
    'menu.products.table.price': 'السعر',
    'menu.products.table.vat': 'ضريبة القيمة المضافة',
    'menu.products.table.sku': 'SKU',
    'menu.products.table.tags': 'العلامات',
    'menu.products.reload.kiosk': 'إعادة تحميل',
    'menu.products.create.link': 'إنشاء منتج',
    'menu.products.massEdit': 'تعديل جماعي',
    'menu.products.duplicate': 'تكرار',
    'menu.products.copy': 'نشر',
    'menu.products.copy.title': 'نشر المنتجات',
    'menu.products.copy.form.restaurants.title': 'اختر المطاعم المستهدفة',
    'menu.products.copy.form.restaurants.label': 'الوجهات',
    'menu.products.copy.form.restaurants.tooltip': 'اختر مطاعم العلامة التجارية التي ستستقبل نشر المنتج و/أو خطواته.',
    'menu.products.copy.form.restaurants.tooltip.title': 'اختر المطاعم المستهدفة',
    'menu.products.copy.form.restaurants.tooltip.example':
        'من قائمة العلامة التجارية، تقرر نشر حلوى Brownie فقط إلى المطعمين A وB ← فقط هذان المطعمان سيحصلان على هذا المنتج الجديد.',
    'menu.products.copy.form.updateIgnoreAttributes.title': 'عند النشر، لا أرغب في الكتابة فوق الخصائص التالية على:',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip':
        'عند نشر منتج من العلامة التجارية إلى مطعم يوجد فيه بالفعل (منفردًا أو عبر خطوة)، يمكنك اختيار الاحتفاظ ببعض خصائص هذا المنتج الفردي: العلامة، الفئة الأصلية، الصورة، السعر، ضريبة القيمة المضافة، الاسم والوصف.',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.title': 'الاحتفاظ ببعض الخصائص عند نشر منتج موجود مسبقًا',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.example':
        'المنتج الفردي Cookie موجود بالفعل في المطعم بصورة مخصصة وسعر محدد ← إذا حددت "الصورة" و"السعر"، ستُحفظ هذه القيم حتى بعد النشر من العلامة التجارية.\n\n👉 بالنسبة للمنتجات الجديدة، تُنشر جميع خصائص العلامة التجارية تلقائيًا.',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.products':
        'المنتجات الموجودة بالفعل في قوائم المطاعم المستهدفة',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.steps':
        'الخطوات الموجودة بالفعل في قوائم المطاعم المستهدفة',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.title':
        'الاحتفاظ ببعض الخصائص عند نشر خطوة موجودة مسبقًا',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.description':
        'عند نشر خطوة من العلامة التجارية إلى مطعم يوجد فيها بالفعل، يمكنك اختيار الاحتفاظ ببعض خصائص هذه الخطوة: سعر المنتج في الخطوة، الحد الأقصى للكمية لكل منتج (إذا كان خيار الكمية مفعَّلًا) وسعر التجاوز.',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.example':
        'في المطعم، خطوة "اختر حلوى" تحتوي على Cookie بـ 2€ وحد أقصى للكمية 3.\nتنشر العلامة التجارية في الخطوة Cookie بـ 1€ وحد أقصى للكمية 1.\n← إذا احتفظت بـ "سعر المنتج" و"الحد الأقصى للكمية"، يحتفظ المطعم بـ Cookie بـ 2€ وحد أقصى 3.\n\n👉 بالنسبة للخطوات الجديدة، تُنشر جميع خصائص العلامة التجارية تلقائيًا.',
    'menu.products.copy.form.updateIgnoreAttributes.placeholder': 'عند النشر، لا أرغب في الكتابة فوق الخصائص التالية',
    'menu.products.copy.form.attribute.price': 'السعر',
    'menu.products.copy.form.attribute.vat': 'ضريبة القيمة المضافة',
    'menu.products.copy.form.attribute.name': 'الاسم',
    'menu.products.copy.form.attribute.description': 'الوصف',
    'menu.products.copy.form.attribute.categories': 'الفئات الأصلية',
    'menu.products.copy.form.attribute.tags': 'العلامات',
    'menu.products.copy.form.attribute.imageId': 'الصورة',
    'menu.products.copy.form.attribute.exceedPrice': 'سعر التجاوز',
    'menu.products.copy.form.attribute.maxProductQuantity': 'الحد الأقصى للكمية',
    'menu.products.copy.form.publishAfterCopy.title': 'عند النشر، أرغب في:',
    'menu.products.copy.form.publishAfterCopy.tooltip': 'نشر القوائم تلقائيًا على نقاط البيع المرتبطة',
    'menu.products.copy.form.publishAfterCopy.tooltip.title': 'النشر التلقائي',
    'menu.products.copy.form.publishAfterCopy.tooltip.example':
        'إذا تم التفعيل، ستُنشر القوائم تلقائيًا على جميع نقاط البيع المرتبطة بالمطاعم المستهدفة.',
    'menu.products.copy.form.publishAfterCopy': 'نشر القوائم تلقائيًا على نقاط البيع المرتبطة',
    'menu.products.copy.form.publishAfterCopy.disclaimer':
        '⚠️ تنبيه: من الضروري إضافة المنتجات الجديدة المنشورة إلى خطة اللمس',
    'menu.products.copy.form.strategy.title': 'استراتيجية النشر للخطوات الموجودة بالفعل في القوائم المستهدفة',
    'menu.products.copy.form.strategy.tooltip':
        'يتم استبدال الخطوات الموجودة في المطعم بتلك المُهيَّأة في قائمة العلامة التجارية (بما في ذلك المنتجات والأسعار).',
    'menu.products.copy.form.strategy.tooltip.title': 'الاستراتيجية: تحديث الخطوات الموجودة',
    'menu.products.copy.form.strategy.tooltip.example':
        'المطعم A لديه خطوة "اختر حلوى" مع Pain perdu وFruits وCookie (2€).\nتنشر العلامة التجارية Cookie (1€) وBrownie (2€) ← سيحتوي المطعم A على Cookie (1€) وBrownie (2€).\n\n👉 يتم تحديث المنتج الفردي Cookie وإنشاء Brownie وإزالة Pain perdu من الخطوة.',
    'menu.products.copy.form.strategy.replace':
        'تحديث الخطوات الموجودة في قائمة/قوائم المطعم/المطاعم بتلك المنشورة من قائمة العلامة التجارية',
    'menu.products.copy.form.strategy.replace.tooltip.title': 'الاستراتيجية: تحديث الخطوات الموجودة',
    'menu.products.copy.form.strategy.replace.tooltip.description':
        'يتم استبدال الخطوات الموجودة في المطعم بتلك المُهيَّأة في قائمة العلامة التجارية (بما في ذلك المنتجات والأسعار).',
    'menu.products.copy.form.strategy.replace.tooltip.example':
        'المطعم A لديه خطوة "اختر حلوى" مع Pain perdu وFruits وCookie (2€).\nتنشر العلامة التجارية Cookie (1€) وBrownie (2€) ← سيحتوي المطعم A على Cookie (1€) وBrownie (2€).\n\n👉 يتم تحديث المنتج الفردي Cookie وإنشاء Brownie وإزالة Pain perdu من الخطوة.',
    'menu.products.copy.form.strategy.update_and_keep_existing':
        'تحديث الخطوات الموجودة في قائمة/قوائم المطعم/المطاعم والاحتفاظ بالمنتجات الموجودة الغائبة في خطوة قائمة العلامة التجارية',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.title':
        'الاستراتيجية: التحديث والاحتفاظ بالمنتجات الموجودة',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.description':
        'تُحدَّث خطوات المطعم بخطوات العلامة التجارية، لكن يتم الاحتفاظ بالمنتجات الموجودة الغائبة من قائمة العلامة التجارية.',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.example':
        'المطعم A لديه خطوة "اختر حلوى" مع Pain perdu (1€) وFruits (2€) وCookie (2€).\nتنشر العلامة التجارية Cookie (1€) وBrownie (2€) ← سيحتوي المطعم A على Pain perdu (1€) وFruits (2€) وCookie (1€) وBrownie (2€).\n\n👉 يتم تحديث Cookie وإنشاء Brownie والاحتفاظ بـ Pain perdu في الخطوة.',
    'menu.products.copy.form.strategy.keep_existing': 'عدم تعديل الخطوات الموجودة بالفعل في القوائم المستهدفة',
    'menu.products.copy.form.strategy.keep_existing.tooltip.title': 'الاستراتيجية: عدم تعديل الخطوات الموجودة',
    'menu.products.copy.form.strategy.keep_existing.tooltip.description':
        'لا تتم تعديل الخطوات الموجودة في المطعم أثناء النشر.',
    'menu.products.copy.form.strategy.keep_existing.tooltip.example':
        'المطعم A لديه خطوة "اختر حلوى" مع Pain perdu (1€) وFruits (2€) وCookie (2€).\nتنشر العلامة التجارية Cookie (1€) وBrownie (2€) ← يحتفظ المطعم A بـ Pain perdu (1€) وFruits (2€) وCookie (2€).\n\n👉 يتم تحديث Cookie وإنشاء Brownie.',
    'menu.products.copy.form.channel.title': 'اختر القنوات المستهدفة',
    'menu.products.copy.form.channel.tooltip':
        'اختر القنوات (مثل: نقطة البيع، الطلب الإلكتروني، الكشك) التي سيُطبَّق عليها نشر المنتج و/أو خطواته.',
    'menu.products.copy.form.channel.tooltip.title': 'اختر القنوات المستهدفة',
    'menu.products.copy.form.channel.tooltip.example':
        'تنشر حلوى Brownie لكنك تختار الكشك فقط ← سيظهر المنتج فقط في قوائم الكشك للمطاعم المختارة.',
    'menu.products.copy.form.channel.web': 'الطلب الإلكتروني أو على الطاولة',
    'menu.products.copy.form.channel.kiosk': 'الكشك',
    'menu.products.copy.form.channel.pos': 'نقاط البيع',
    'menu.products.copy.form.channel.marketplace': 'Marketplace (UberEats/Deliveroo)',
    'menu.products.copy.form.channel.null': 'غير مرتبط',
    'menu.products.copy.form.other.strategies.title': 'إنشاء المنتجات الجديدة',
    'menu.products.copy.form.other.strategies.tooltip':
        'عند نشر منتجات جديدة، تنشر العلامة التجارية في الخطوة Cookie بـ 2€ وحد أقصى للكمية 3. إذا احتفظت بـ "سعر المنتج" و"الحد الأقصى للكمية"، يحتفظ المطعم بـ Cookie بـ 2€ وحد أقصى 3. ← إذا احتفظت بـ "سعر المنتج" و"الحد الأقصى للكمية"، يحتفظ المطعم بـ Cookie بـ 2€ وحد أقصى 3.',
    'menu.products.copy.form.other.strategies.tooltip.title': 'إنشاء المنتجات الجديدة',
    'menu.products.copy.form.other.strategies.tooltip.example':
        'عند نشر منتجات جديدة، تنشر العلامة التجارية في الخطوة Cookie بـ 2€ وحد أقصى للكمية 3. إذا احتفظت بـ "سعر المنتج" و"الحد الأقصى للكمية"، يحتفظ المطعم بـ Cookie بـ 2€ وحد أقصى 3.\n← إذا احتفظت بـ "سعر المنتج" و"الحد الأقصى للكمية"، يحتفظ المطعم بـ Cookie بـ 2€ وحد أقصى 3.',
    'menu.products.copy.form.other.strategies.tags': 'إنشاء العلامات المفقودة للمنتجات تلقائيًا أثناء النشر',
    'menu.products.copy.form.other.strategies.categories': 'إنشاء الفئات المفقودة للمنتجات تلقائيًا أثناء النشر',
    'menu.products.copy.form.posMenus.title': 'قوائم نقاط البيع النشطة',
    'menu.products.copy.form.posMenus.description':
        'يعرض هذا الجدول فقط المطاعم التي تمتلك أكثر من قائمة نقطة بيع نشطة. إذا كانت هناك قائمة نقطة بيع واحدة نشطة فقط، يتم النشر عليها افتراضيًا.',
    'menu.products.copy.form.posMenus.tooltip': 'اختر قوائم نقاط البيع التي تريد نشر المنتجات عليها لكل مطعم.',
    'menu.products.copy.form.posMenus.tooltip.title': 'اختيار قوائم نقاط البيع',
    'menu.products.copy.form.posMenus.tooltip.example':
        'إذا كان لمطعم عدة قوائم نقاط بيع، يمكنك اختيار النشر على قائمة أو أكثر منها.',
    'menu.products.copy.form.posMenus.column.restaurant': 'اسم المطعم',
    'menu.products.copy.form.posMenus.column.menus': 'القائمة/القوائم النشطة',
    'menu.products.copy.form.posMenus.empty': 'لا تتوفر قوائم نقاط بيع للمطاعم المختارة',
    'menu.products.copy.form.posMenus.placeholder': 'اختر القوائم...',
    'menu.products.copy.form.posMenus.warning':
        '⚠️ تنبيه: بشكل افتراضي، تُختار جميع القوائم النشطة لمطعم ما لنشر المنتجات.',
    'menu.products.copy.form.marketplaceMenus.title': 'قوائم Marketplace النشطة',
    'menu.products.copy.form.marketplaceMenus.description':
        'يعرض هذا الجدول فقط المطاعم التي تمتلك أكثر من قائمة marketplace نشطة. إذا كانت هناك قائمة marketplace واحدة نشطة فقط، يتم النشر عليها افتراضيًا.',
    'menu.products.copy.form.marketplaceMenus.tooltip': 'اختر قوائم marketplace التي تريد نشر المنتجات عليها لكل مطعم.',
    'menu.products.copy.form.marketplaceMenus.tooltip.title': 'اختيار قوائم Marketplace',
    'menu.products.copy.form.marketplaceMenus.tooltip.example':
        'إذا كان لمطعم عدة قوائم marketplace، يمكنك اختيار النشر على قائمة أو أكثر منها.',
    'menu.products.copy.form.marketplaceMenus.column.restaurant': 'اسم المطعم',
    'menu.products.copy.form.marketplaceMenus.column.menus': 'القائمة/القوائم النشطة',
    'menu.products.copy.form.marketplaceMenus.empty': 'لا تتوفر قوائم marketplace للمطاعم المختارة',
    'menu.products.copy.form.marketplaceMenus.placeholder': 'اختر القوائم...',
    'menu.products.copy.form.marketplaceMenus.warning':
        '⚠️ تنبيه: بشكل افتراضي، تُختار جميع القوائم النشطة لمطعم ما لنشر المنتجات.',
    'menu.products.copy.form.publishAfterCopy.marketplace.title': 'عند النشر، أرغب في:',
    'menu.products.copy.form.publishAfterCopy.marketplace': 'نشر القوائم تلقائيًا على منصات Marketplace المرتبطة',
    'menu.products.copy.form.publishAfterCopy.marketplace.disclaimer':
        'ستُنشر القوائم على منصات Marketplace المرتبطة بالمطاعم.',
    'menu.products.copy.form.disclaimer':
        '⚠️ تنبيه: سيتم نسخ هذا/هذه المنتج/المنتجات على جميع المطاعم المختارة في جميع قوائمها. قبل الحفظ، تحقق من الاسم والوصف والصورة وضريبة القيمة المضافة والسعر.',
    'menu.copy.validate.title': 'التحقق من المنتجات/الخطوات المراد نشرها',
    'menu.copy.validate.success': 'جميع المنتجات/الخطوات المراد نشرها تحتوي على SKU/مرجع خطوة مُهيَّأ',
    'menu.copy.validate.warning': 'SKU غير مُدخَل في بطاقة منتج قائمة العلامة التجارية',
    'menu.copy.validate.error': 'SKU مكرر أو مرجع الخطوة غير مُدخَل في قائمة العلامة التجارية',
    'menu.copy.validate.step.missing.identifier.detail': 'مرجع الخطوة غير مُدخَل على الخطوة',
    'menu.copy.validate.product.missing.identifier.detail': 'SKU غير مُدخَل على المنتج',
    'menu.copy.validate.step.duplicate.identifier.detail': 'تعارض في المرجع <b>{identifier}</b> بين الخطوات',
    'menu.copy.validate.product.duplicate.identifier.detail': 'تعارض في SKU <b>{identifier}</b> بين المنتجات',
    'menu.products.overwrite': 'حدد المربع على اليسار لتعديل الحقول',
    'menu.products.overwriteRelations': 'حدد المربع على اليسار لاستبدال كل شيء بدلًا من إضافة عناصر',
    'menu.products.error.alreadyTaken': 'هذا المنتج موجود بالفعل',
    'menu.products.error.billingCodeRequired': 'الفوترة التلقائية تتطلب ملء هذا الحقل',
    'menu.products.add.title': 'إضافة منتج',
    'menu.products.edit.title': 'تعديل منتج',
    'menu.products.propagate.title': 'نشر المنتجات',
    'menu.products.create.title': 'إنشاء منتج',
    'menu.products.delete.confirm': 'هل أنت متأكد من رغبتك في حذف {count} منتج/منتجات؟',
    'menu.products.form.price': 'السعر شامل الضريبة',
    'menu.product.form.pricePerkg': 'السعر شامل الضريبة / كجم',
    'menu.products.form.priceType': 'نوع السعر',
    'menu.products.form.priceType.placeholder': 'نوع السعر',
    'menu.products.form.priceType.fixed': 'سعر ثابت',
    'menu.products.form.priceType.customizablePrice': 'منتج بسعر حر',
    'menu.products.form.priceType.customizablePriceAndLabel': 'منتج بسعر وتسمية حرة',
    'menu.products.form.measurementUnit': 'يُقاس بـ',
    'menu.products.form.measurementUnit.placeholder': 'يُقاس بـ',
    'menu.products.form.measurementUnit.unit': 'وحدة',
    'menu.products.form.measurementUnit.kg': 'كجم',
    'menu.products.form.kg.channelRestriction': 'المنتجات بالكيلوغرام غير متاحة على قناة الكشك.',
    'menu.products.form.availability': 'التوفر حسب القناة',
    'menu.products.form.webAvailability': 'الويب',
    'menu.products.form.kioskAvailability': 'الكشك',
    'menu.products.form.servingCount': 'عدد الأغطية',
    'menu.products.form.barCode': 'الباركود',
    'menu.products.form.ticketLabel': 'تسمية الإنتاج',
    'menu.products.form.ticketLabel.checkbox': 'استخدام تسمية إنتاج مختلفة عن اسم المنتج',
    'menu.products.form.noVat': 'منتج غير خاضع لضريبة القيمة المضافة',
    'menu.products.form.vat': 'ضريبة القيمة المضافة الافتراضية',
    'product.vatGroup': 'مجموعة ضريبة القيمة المضافة',
    'product.vatGroup.withHint': 'مجموعة ضريبة القيمة المضافة (على الطاولة / للإحضار / التوصيل)',
    'product.selectVatGroup': 'اختر مجموعة ضريبة القيمة المضافة',
    'product.vatGroup.noOperationZone': 'لا توجد منطقة عمليات مُهيَّأة لهذا المطعم',
    'product.vatGroup.eatIn': 'على الطاولة',
    'product.vatGroup.takeAway': 'للإحضار',
    'product.vatGroup.delivery': 'التوصيل',
    'product.vatGroup.hint':
        'لتغيير ضريبة القيمة المضافة حسب وضع الاستهلاك، يرجى تعديل حقل «مجموعة ضريبة القيمة المضافة (على الطاولة / للإحضار / التوصيل)» من الآن فصاعدًا',
    'menu.products.form.image.placeholder': 'الصورة',
    'menu.products.form.externalId': 'الكود الخارجي',
    'menu.products.form.sku': 'sku',
    'menu.products.form.sku.placeholder': 'اختر SKU',
    'menu.products.form.sku.noOption': 'لا يمكن إنشاء SKU جديد إلا على مستوى العلامة التجارية',
    'menu.products.form.createSku': 'إنشاء SKU "{value}"',
    'menu.products.form.replaceSkuAll': 'استبدال SKU "{currentSku}" بـ "{value}" (على جميع المنتجات ذات نفس الـ SKU)',
    'menu.products.form.replaceSkuThisProduct': 'استبدال SKU "{currentSku}" بـ "{value}" (على هذا المنتج فقط)',
    'menu.products.form.createTag': 'إنشاء العلامة "{value}"',
    'menu.products.form.billingCode': 'كود الفاتورة',
    'menu.products.form.purchasePrice': 'سعر العقد',
    'menu.products.form.description': 'الوصف',
    'menu.products.form.description.tooLong': 'يجب ألا يتجاوز الوصف 1500 حرف',
    'menu.products.form.additionalInformation': 'معلومات إضافية',
    'menu.products.form.section.options': 'الخيارات',
    'menu.products.form.section.quantity': 'إدارة المخزون',
    'menu.products.form.section.externalData': 'البيانات الخارجية',
    'menu.products.form.currentQuantitySwitch': 'تفعيل إدارة المخزون للمنتج',
    'menu.products.form.defaultQuantitySwitch': 'إعادة تعيين المخزون يوميًا',
    'menu.products.form.currentQuantityInput': 'الكمية في المخزون',
    'menu.products.form.defaultQuantityInput': 'الكمية في بداية اليوم',
    'menu.products.form.defaultQuantityHint': 'كل يوم بين الساعة 4 و5 صباحًا، ستُعاد الكمية إلى القيمة الافتراضية',
    'menu.products.form.isEligibleLuncheon': 'مؤهل لقسائم الطعام',
    'menu.products.form.isFinalProduct': 'منتج نهائي',
    'menu.products.form.subsidizable': 'منتج قابل للإعانة',
    'menu.products.form.admissible': 'منتج قابل للقبول',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants': 'مضاعفة رسوم القبول/الإعانة عند كل إضافة لعربة التسوق',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants.tooltip':
        'بتفعيل هذا الخيار، ستُضاعَف رسوم القبول (والإعانات) في الطلب إذا أُضيف المنتج أكثر من مرة إلى عربة التسوق أو إذا أُضيف منتج آخر يحمل نفس الخيار. تتم المضاعفة في حدود السقف اليومي والسقف المحدد في النظام التسعيري.',
    'menu.products.form.excludedFromUrssaf': 'عدم الحساب في الحد الأدنى للـ URSSAF',
    'menu.products.form.section.pos': 'السمات الخاصة بنقاط البيع',
    'menu.products.form.minQuantity': 'الحد الأدنى للكمية',
    'menu.products.form.alwaysAskForCustomization': 'طلب الخطوات دائمًا',
    'menu.products.form.discountable': 'السماح بالخصومات على المنتج',
    'menu.products.form.isDeposit': 'منتج من نوع وديعة',
    'menu.products.form.posPrice': 'مبلغ الوديعة',
    'menu.products.form.vatSitIn': 'ضريبة القيمة المضافة على الطاولة',
    'menu.products.form.vatDelivery': 'ضريبة القيمة المضافة للتوصيل',
    'menu.products.form.vatTakeAway': 'ضريبة القيمة المضافة للإحضار',
    'menu.products.form.section.kitchenOptions': 'خيارات شاشة المطبخ',
    'menu.products.form.isMenu': 'هو قائمة',
    'menu.products.form.is_customization': 'هو تخصيص',
    'menu.products.form.isProducible': 'عرض في الملخص',
    'menu.products.form.no_kitchen': 'عدم العرض في شاشة المطبخ',
    'menu.products.form.section.consumptionMode': 'توفر المنتج حسب وضع الاستهلاك',
    'menu.products.form.consumptionModeType.mode_sit_in': 'على الطاولة',
    'menu.products.form.consumptionModeType.mode_delivery': 'توصيل',
    'menu.products.form.consumptionModeType.mode_take_away': 'للإحضار',
    'menu.products.form.consumptionModeType.mode_drive': 'درايف',
    'menu.products.form.tags': 'العلامات',
    'menu.products.form.tags.placeholder': 'ابحث عن علامة أو علامات للربط',
    'menu.products.form.steps': 'الخطوات',
    'menu.products.form.steps.page': 'الصفحة {pageNumber}',
    'menu.products.form.steps.addToNewPage': 'إضافة إلى صفحة جديدة',
    'menu.products.form.steps.addEachToNewPage': 'إضافة كل خطوة إلى صفحة جديدة',
    'menu.products.form.steps.addToPage': 'الصفحة التي ستُضاف إليها الخطوة',
    'menu.products.form.steps.addEmptyPage': 'إضافة صفحة',
    'menu.products.form.categories': 'الفئات الأصلية',
    'menu.products.form.productType': 'النوع',
    'menu.products.form.productType.placeholder': 'نوع المنتج',
    'menu.products.form.productType.product': 'منتج',
    'menu.products.form.productType.deposit': 'وديعة',
    'menu.products.form.categories.placeholder': 'ابحث عن فئة أو فئات أصلية',
    'menu.products.form.externalReference': 'المرجع الخارجي',
    'menu.products.form.externalReference.placeholder': 'اسم المرجع',
    'menu.products.form.externalReference.name': 'الاسم',
    'menu.products.form.externalReference.value': 'القيمة',
    'menu.products.form.machineCode': 'كود آلة Nayax للمنتج',
    'menu.products.form.steps.add': 'إضافة خطوة',
    'menu.products.form.steps.addPage': 'اسحب الخطوة هنا لإنشاء صفحة جديدة',
    'menu.products.form.steps.column.name': 'الاسم',
    'menu.products.form.steps.column.type': 'النوع',
    'menu.products.form.steps.column.choices': 'الاختيارات المتاحة',
    'menu.products.form.steps.column.position': 'الصفحة',
    'menu.products.form.steps.column.subPosition': 'الموضع',
    'menu.products.form.steps.column.min': 'الحد الأدنى',
    'menu.products.form.steps.column.max': 'الحد الأقصى',
    'menu.products.form.steps.column.parentsProducts': 'عدد المنتجات الأصلية',
    'menu.products.form.steps.cross-selling.add': 'إضافة بيع إضافي',
    'menu.products.form.steps.customization.add': 'إضافة تخصيص',
    'menu.products.form.steps.type.cross-selling': 'بيع إضافي',
    'menu.products.form.steps.type.customization': 'تخصيص',
    'reportGenerationsHistory.title': 'سجل التوليد',
    'reportGenerationsHistory.subtitle': 'ستجد هنا سجل عمليات التصدير الخاصة بك.',
    'reportGenerationsHistory.tableCard.title': 'التصديرات',
    'reportGenerationsHistory.tableCard.subtitle': 'قائمة التصديرات',
    'reportGenerationsHistory.tableCard.actionLabel': 'تحديث الصفحة',
    'reportGenerationsHistory.emptyMessage': 'سجل التوليد الخاص بك فارغ',
    'reportGenerationsHistory.tableHeader.createdAt': 'التاريخ',
    'reportGenerationsHistory.tableHeader.fileName': 'اسم الملف',
    'reportGenerationsHistory.tableHeader.reportType': 'الحالة',
    'reportGenerationsHistory.tableHeader.status': 'التقدم',
    'reportGenerationsHistory.tableHeader.action': 'تنزيل',
    'reportGenerationsHistory.tableRow.reportType.pre_invoicing': 'ما قبل الفوترة',
    'reportGenerationsHistory.tableRow.reportType.orders': 'الطلبات',
    'reportGenerationsHistory.tableRow.reportType.badge_balance': 'حركات الشارات',
    'reportGenerationsHistory.tableRow.reportType.sales_summary': 'الملخص المالي',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary': 'الملخص المالي حسب وضع الإدارة',
    'reportGenerationsHistory.tableRow.reportType.ewallet_stats_by_users': 'رصيد الشارات لكل عميل',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary_exclude_tax':
        'الملخص المالي حسب وضع الإدارة (بدون ضريبة)',
    'reportGenerationsHistory.tableRow.reportType.ewallet': 'المحفظة الإلكترونية',
    'reportGenerationsHistory.tableRow.reportType.accounting': 'محاسبة',
    'reportGenerationsHistory.tableRow.reportType.monthly_sales_report': 'تقرير المبيعات الشهري',
    'reportGenerationsHistory.tableRow.generationStatus.succeed': 'مكتمل',
    'reportGenerationsHistory.tableRow.generationStatus.in_progress': 'جارٍ',
    'reportGenerationsHistory.tableRow.generationStatus.failed': 'فشل',
    'reportGenerationsHistory.tableRow.action.download': 'تنزيل',
    'report.emptyMessage': 'لا توجد نتائج',
    'report.title.monthly_sales_report': 'تقرير المبيعات الشهري',
    'report.selectDateRangeButton.text': 'من {startDate} إلى {endDate}',
    'report.calendarModal.dateRage.errorMessage': 'لا يمكنك تحديد أكثر من {maxRangeInDays} يومًا',
    'report.calendarModal.title': 'اختر فترة زمنية',
    'report.calendarModal.submit': 'تأكيد',
    'report.filtersButton.text': 'الفلاتر',
    'report.filtersModal.title': 'اختر الفلاتر',
    'report.filtersModal.submit': 'تصفية',
    'report.filtersModal.form.restaurantLabel': 'المطاعم',
    'report.filtersModal.form.devicesLabel': 'نقاط البيع',
    'report.filtersModal.form.sourcesLabel': 'قنوات الطلب',
    'report.filtersModal.form.tagsLabel': 'العلامات',
    'report.filtersModal.form.consumptionModesLabel': 'أوضاع الاستهلاك',
    'report.filtersModal.form.sellersLabel': 'البائعون',
    'report.filtersModal.form.vatsLabel': 'ضريبة القيمة المضافة',
    'report.filtersModal.form.categoriesLabel': 'الفئات',
    'report.filtersModal.form.loyaltyLabel': 'عرض الطلبات المدفوعة بالنقاط فقط',
    'report.filtersModal.form.only_parentsLabel': 'عرض الفئات الأصلية',
    'report.filtersModal.saveAs.placeholder': 'حفظ باسم...',
    'report.filtersModal.saveAs.save': 'حفظ وتطبيق',
    'report.exportButton.text': 'تصدير',
    'report.exportResultModal.title': 'تصدير CSV',
    'report.exportResultModal.resultSuccess': 'جارٍ توليد التصدير',
    'report.exportResultModal.stayInPage': 'البقاء في هذه الصفحة',
    'report.exportResultModal.redirectToGenerationHistory': 'عرض التصديرات الجارية',
    'report.exportResultModal.resultFail': 'A problem has occurred, please try again in a few moments',
    'report.savedFiltersDropdown.placeholder': 'الفلاتر المحفوظة',
    'report.savedFiltersDropdown.deleteModal.title': 'تنبيه',
    'report.savedFiltersDropdown.deleteModal.description': 'هل أنت متأكد من رغبتك في الحذف؟',
    'salesSummary.tableCard.title': 'إنشاء تصدير جديد',
    'salesSummary.tableCard.subtitle': 'حدد معاييرك وفلاترك، ثم انقر على "توليد".',
    'salesSummary.form.choosePeriod': 'اختر فترة زمنية',
    'salesSummary.form.reportType': 'صيغة التقرير',
    'salesSummary.form.reportType.collectiveCateringSalesSummary': 'الملخص المالي حسب وضع الإدارة',
    'salesSummary.form.reportType.collectiveCateringSalesSummaryExclTax': 'الملخص المالي حسب وضع الإدارة (بدون ضريبة)',
    'salesSummary.form.reportType.salesSummary': 'الملخص المالي',
    'salesSummary.form.restaurants': 'المطاعم',
    'salesSummary.form.groups': 'المجموعات',
    'salesSummary.form.pricingRules': 'النظام التسعيري',
    'salesSummary.form.accountedOrders': 'الطلبات المُحتسَبة',
    'salesSummary.form.accountedOrders.all': 'الطلبات + القيود المعاكسة',
    'salesSummary.form.accountedOrders.ordersOnly': 'الطلبات',
    'salesSummary.form.accountedOrders.contraEntriesOnly': 'القيود المعاكسة',
    'salesSummary.exportResultModal.title': 'توليد التصدير',
    'shift.default': 'افتراضي',
    'shift.allDays': 'كل الأيام',
    'shift.period': 'من {start} إلى {end}',
    'shift.days.MON': 'الاثنين',
    'shift.days.TUE': 'الثلاثاء',
    'shift.days.WED': 'الأربعاء',
    'shift.days.THU': 'الخميس',
    'shift.days.FRI': 'الجمعة',
    'shift.days.SAT': 'السبت',
    'shift.days.SUN': 'الأحد',
    'shift.amount.required': 'المبلغ إلزامي',
    'shift.amount.positive': 'يجب أن يكون المبلغ إيجابيًا',
    'shift.threshold.positive': 'يجب أن يكون الحد إيجابيًا',
    'shift.ceiling.required': 'إلزامي للإعانة بالنسبة المئوية',
    'shift.vat.required': 'ضريبة القيمة المضافة إلزامية',
    'shift.vat.positive': 'يجب أن تكون ضريبة القيمة المضافة إيجابية',
    'brandHistory.tableCard.title': 'السجل',
    'brandHistory.tableCard.subtitle': 'ابحث عن الإجراءات المنفذة على العلامة التجارية',
    'brandHistory.emptyMessage': 'لم يتم العثور على سجل',
    'brandHistory.searchPlaceholder': 'البحث في السجل',
    'brandHistory.entityType': 'نوع الكيان',
    'brandHistory.entityType.GRANT': 'إعانة',
    'brandHistory.entityType.ENTRANCE_FEE': 'رسوم القبول',
    'brandHistory.entityType.PRICING_RULE': 'النظام التسعيري',
    'brandHistory.entityType.PRODUCT': 'منتج',
    'brandHistory.entityType.STEP': 'خطوة',
    'brandHistory.entityType.CATEGORY': 'فئة',
    'brandHistory.entityType.MENU': 'قائمة',
    'brandHistory.entityType.MODULE': 'وحدة',
    'brandHistory.entityType.CUSTOMER': 'عميل',
    'brandHistory.entityType.CUSTOMERS_IMPORT': 'استيراد العملاء',
    'brandHistory.entityType.CUSTOMERS_UPDATE': 'تعديل العملاء',
    'brandHistory.entityType.USER': 'مستخدم',
    'brandHistory.entityType.CHANNEL': 'قناة',
    'brandHistory.entityType.CONSUMPTION_MODE': 'وضع الاستهلاك',
    'brandHistory.entityType.ORDER': 'طلب',
    'brandHistory.entityType.BRAND': 'علامة تجارية',
    'brandHistory.entityType.RESTAURANT': 'مطعم',
    'brandHistory.entityName': 'اسم الكيان',
    'brandHistory.restaurant': 'مطعم',
    'brandHistory.user': 'مستخدم',
    'brandHistory.action': 'الإجراء',
    'brandHistory.eventDate': 'التاريخ',
    'brandHistory.action.create': 'إنشاء',
    'brandHistory.action.open': 'فتح',
    'brandHistory.action.activate': 'تفعيل',
    'brandHistory.action.duplicate': 'تكرار',
    'brandHistory.action.delete': 'حذف',
    'brandHistory.action.close': 'إغلاق',
    'brandHistory.action.deactivate': 'تعطيل',
    'brandHistory.action.cancel': 'إلغاء',
    'brandHistory.action.update': 'تعديل',
    'brandHistory.action.import': 'استيراد',
    'brandHistory.action.unknown': 'غير معروف',
    'brandHistory.modal.title': 'تقرير الإجراءات المنفذة',
    'brandHistory.modal.actions': 'تقرير الإجراءات',
    'brandHistory.modal.logs': 'تقرير السجلات',
    'brandHistory.modal.informations': 'المعلومات المرتبطة',
    'brandHistory.modal.entityName': 'اسم الكيان',
    'brandHistory.modal.user': 'المستخدم: ',
    'brandHistory.modal.date': 'تاريخ التغيير: ',
    'brandHistory.modal.close': 'إغلاق',
    'brandHistory.modal.empty': 'لا يوجد شيء هنا 😰',
    'crossSelling.name': 'اسم صفحة البيع التكميلي',
    'crossSelling.page.title': 'البيع التكميلي',
    'crossSelling.page.description': 'أنشئ صفحات البيع التكميلي وأدِرها',
    'crossSelling.action.newCrossSelling': '+ صفحة بيع تكميلي جديدة',
    'crossSelling.modal.duplicate.title': 'تكرار صفحة بيع تكميلي',
    'crossSelling.modal.create.title': 'إنشاء صفحة البيع التكميلي الخاصة بك',
    'crossSelling.modal.delete.title': 'حذف صفحة بيع تكميلي',
    'crossSelling.modal.delete.description': 'هل أنت متأكد من رغبتك في حذف الصفحة: "{crossSellingName}" ؟',
    'crossSelling.modal.error.name': 'أدخل اسمًا في الحقل المخصص',
    'crossSelling.modal.menu.name': 'اسم صفحة البيع التكميلي',
    'crossSelling.page.create.title': 'إنشاء صفحة بيع تكميلي',
    'crossSelling.page.update.title': 'تعديل صفحة البيع التكميلي "{crossSellingName}"',
    'crossSelling.page.create.description': 'إعداد صفحة البيع التكميلي',
    'crossSelling.page.update.description': 'إعداد صفحة البيع التكميلي',
    'crossSelling.products.image': 'الصورة',
    'crossSelling.products.name': 'الاسم',
    'crossSelling.products.price': 'السعر',
    'crossSelling.products.vat': 'ضريبة القيمة المضافة',
    'crossSelling.products.tags': 'العلامات',
    'crossSelling.products.sku': 'SKU',
    'crossSelling.products.menuName': 'القائمة',
    'crossSelling.products.menuState': 'حالة القائمة',
    'crossSelling.products.restaurantName': 'المطعم',
    'crossSelling.products.add': 'إضافة منتجات',
    'crossSelling.products.menuState.enabled': 'مفعَّل',
    'crossSelling.products.menuState.disabled': 'معطَّل',
    'tableLayout.name': 'اسم مخطط الطاولات',
    'tableLayout.page.title': 'مخططات الطاولات',
    'tableLayout.page.description': 'أنشئ مخططات الطاولات وأدِرها',
    'tableLayout.table.associatedPos': 'نقاط البيع المرتبطة',
    'tableLayout.action.newTableLayout': '+ مخطط طاولات جديد',
    'tableLayout.modal.create.title': 'إنشاء مخطط طاولات',
    'tableLayout.modal.edit.title': 'تعديل مخطط الطاولات "{tableLayoutName}"',
    'tableLayout.modal.delete.title': 'حذف مخطط طاولات',
    'tableLayout.modal.delete.description': 'هل أنت متأكد من رغبتك في حذف مخطط الطاولات: "{tableLayoutName}" ؟',
    'tableLayout.modal.publish.title': 'نشر مخطط طاولات',
    'tableLayout.modal.publish.description': 'هل أنت متأكد من رغبتك في نشر مخطط الطاولات: "{tableLayoutName}" ؟',
    'tableLayout.modal.error.name': 'أدخل اسمًا في الحقل المخصص',
    'room.name': 'اسم القاعة',
    'room.page.title': 'القاعات',
    'room.page.description': 'أنشئ قاعاتك وأدِرها',
    'room.action.newRoom': '+ قاعة جديدة',
    'room.action.publish': 'نشر مخطط الطاولات',
    'room.modal.create.title': 'إنشاء قاعة',
    'room.modal.edit.title': 'تعديل القاعة "{roomName}"',
    'room.modal.view.title': 'القاعة "{roomName}"',
    'room.modal.single': 'إضافة طاولة',
    'room.modal.single.placeholder': 'الطاولة الرئيسية',
    'room.modal.multiple': 'إضافة عدة طاولات',
    'room.modal.multiple.placeholder1': '1',
    'room.modal.multiple.placeholder2': '10',
    'room.modal.layout': 'تنظيم الطاولات',
    'room.modal.delete.title': 'حذف قاعة',
    'room.modal.delete.description': 'هل أنت متأكد من رغبتك في حذف القاعة: "{roomName}" ؟',
    'room.modal.error.name': 'أدخل اسمًا في الحقل المخصص',
    'room.modal.error.new_table_name': 'أدخل اسمًا أو رقمًا للطاولة',
    'room.modal.error.fill_start_and_end': 'أدخل قيمة بداية وقيمة نهاية (أكبر من قيمة البداية)',
    'room.modal.error.max_count_table': 'لا يمكنك أن تمتلك أكثر من {maxCount} طاولة لكل قاعة.',
    'pos.configuration': 'الإعداد',
    'pos.devices': 'نقاط البيع',
    'pos.access': 'الأدوار والصلاحيات',
    'pos.access.users': 'المستخدمون',
    'pos.access.roles': 'الأدوار',
    'pos.access.groups': 'المجموعات',
    'pos.users.page.title': 'مشغّلو نقاط البيع',
    'pos.roles.page.title': 'أدوار وصلاحيات نقاط البيع',
    'pos.groups.page.title': 'مجموعات الوصول لنقاط البيع',
    'pos.users.page.description': 'يتيح مشغّلو نقاط البيع تحديد المستخدمين الذين يمكنهم التفاعل مع نقاط البيع.',
    'pos.roles.page.description': 'تتيح أدوار نقاط البيع تحديد مجموعات الصلاحيات لمستخدمي نقاط البيع.',
    'pos.groups.page.description': 'تُدير مجموعات الوصول المستخدمين وارتباطهم بأجهزة النقاط البيعية في المطعم',
    'pos.users.action.newUser': 'إنشاء مشغّل جديد',
    'posUser.name.form.label': 'اسم المشغّل',
    'posUser.name.form.placeholder': 'اسم مشغّل نقطة البيع',
    'posUser.pinCode.form.label': 'رمز PIN للمشغّل',
    'posUser.pinCode.form.placeholder': 'رمز PIN لمشغّل نقطة البيع',
    'posUser.role.form.label': 'دور المشغّل',
    'posGroup.name.form.label': 'اسم المجموعة',
    'posGroup.name.form.placeholder': 'أدخل اسم مجموعة الوصول',
    'posGroup.users.form.label': 'المشغّلون',
    'posGroup.users.form.placeholder': 'اختر المشغّلين المرتبطين',
    'posGroup.devices.form.label': 'أجهزة النقاط البيعية',
    'posGroup.devices.form.placeholder': 'اختر أجهزة النقاط البيعية المرتبطة',
    'posUser.create.form.title': 'إنشاء مشغّل نقطة بيع جديد',
    'posGroup.create.form.title': 'إنشاء مجموعة وصول جديدة',
    'posGroup.edit.form.title': 'تعديل مجموعة الوصول',
    'posUser.edit.form.title': 'تعديل مشغّل نقطة البيع: ',
    'posUser.form.description': 'أدخل معلومات مشغّل نقطة البيع.',
    'posGroup.form.description': 'أدخل معلومات مجموعة وصول نقطة البيع.',
    'posUser.form.creation': 'إنشاء مشغّل نقطة بيع',
    'posUser.form.edit': 'تعديل مشغّل نقطة بيع',
    'posUser.form.update': 'تعديل مشغّل نقطة بيع',
    'posRole.form.title': 'دور نقطة البيع',
    'posRole.form.description': 'يمكنك تحديث صلاحيات دور نقطة البيع من هذه الصفحة',
    'posRole.form.creation': 'إنشاء دور نقطة بيع',
    'posRole.form.update': 'تعديل دور نقطة بيع',
    'posGroup.form.creation': 'إنشاء مجموعة وصول',
    'posGroup.form.update': 'تعديل مجموعة وصول',
    'posRole.form.rolePermissions': 'الصلاحيات للدور',
    'posRole.form.name.title': 'اسم الدور',
    'posRole.form.name.placeholder': 'الدور',
    'pos.groups.action.create': 'إنشاء مجموعة جديدة',
    'permissions.permissions': 'الصلاحيات',
    'assiciated.devices': 'أجهزة النقاط البيعية المرتبطة',
    'assiciated.operators': 'المشغّلون المرتبطون',
    'posRole.Operator': 'مشغّل',
    'posRole.Manager': 'مدير',
    'posRole.Owner': 'مالك',
    'posRole.Auditor': 'مدقق',
    'posRole.Treasurer': 'أمين الصندوق',
    'posRole.Support': 'دعم',
    'posRole.Trainer': 'مدرّب',
    'posRole.InCharge': 'مسؤول',
    'posRole.OperatorSupervisor': 'مشرف مشغّلين',
    'posRole.AssistantOperator': 'مساعد مشغّل',
    'posRole.AssistantToTheRegionalManager': 'مساعد مدير',
    'posRole.CustomOperator1': 'مشغّل مخصّص 1',
    'posRole.CustomOperator2': 'مشغّل مخصّص 2',
    'posRole.CustomOperator3': 'مشغّل مخصّص 3',
    'channels.page.title': 'قائمة القنوات',
    'channels.page.description':
        'تتيح لك قنوات الطلبات تقديم ميزات مثل الطلب عبر الإنترنت، والطلب عبر الكشك في نقطة البيع، أو إدارة برامج الولاء.',
    'channels.installed': 'التطبيق مثبَّت',
    'channels.button.configure': 'تهيئة',
    'channels.button.disable': 'تعطيل',
    'channels.button.enable': 'تفعيل',
    'channels.kiosk.name': 'الكشك',
    'channels.kiosk.description': 'أعد ابتكار تجربة نقطة البيع بأفضل طريقة.',
    'channels.web.name': 'الطلب عبر الإنترنت',
    'channels.web.description': 'نقطة بيع جديدة من موقعك الإلكتروني الخاص.',
    'channels.reception.name': 'الاستقبال',
    'channels.reception.description': 'واجهة مخصصة لطلباتك عبر الويب والكشك.',
    'channels.pos.name': 'POS',
    'channels.pos.description': 'نظام الدفع البسيط والمتكامل مع بيئتك.',
    'channels.kds.name': 'Kitchen display',
    'channels.kds.description': 'اجعل مطبخك أكثر كفاءة من خلال تنظيم مثالي.',
    'channels.loyalty.name': 'الولاء',
    'channels.loyalty.description': 'اكسب ولاء عملائك وأعدهم إلى نقطة البيع.',
    'channels.ewallet_kiosk.name': 'كشك إعادة شحن E-Wallet',
    'channels.ewallet_kiosk.description': 'القناة الجديدة لإعادة شحن المحفظة الإلكترونية بسرعة فائقة.',
    'channels.vending_machine.name': 'الآلة البائعة',
    'channels.vending_machine.description': 'قدّم الدفع بالمحفظة الإلكترونية على آلات القهوة وموزعات المشروبات.',
    'accessFlags.CAN_ACCESS_BRAND_HISTORY': 'يمكنه الوصول إلى صفحة سجل العلامة التجارية',
    'accessFlags.CAN_ACCESS_CUSTOMERS_SECTION': 'يمكنه الوصول إلى صفحة العملاء',
    'accessFlags.CAN_ACCESS_GRANTS_AND_ENTRANCE_FEES_SECTION': 'يمكنه الوصول إلى تبويب الدعم والرسوم',
    'accessFlags.CAN_ACCESS_IO_PAY': 'يمكنه الوصول إلى وحدة الدفع',
    'accessFlags.CAN_ARCHIVE_CUSTOMERS': 'يمكنه أرشفة العملاء',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_AMOUNT': 'يمكنه إنشاء طلبات بمبلغ سالب',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_BALANCE': 'يمكنه إنشاء طلبات تجعل رصيد المستخدم سالبًا',
    'accessFlags.CAN_CREDIT_POST_PAYMENT_CUSTOMERS_EWALLET': 'يمكنه إضافة رصيد إلى محفظة مستخدم بعد الدفع',
    'accessFlags.CAN_EDIT_AREAS': 'يمكنه تعديل مناطق التوصيل',
    'accessFlags.CAN_EDIT_AUTO_BILLING_REFERENTIAL': 'الفوترة التلقائية: يمكنه تعديل المرجعية',
    'accessFlags.CAN_EDIT_CUSTOMERS_CREDENTIALS': 'يمكنه تعديل بيانات اعتماد العملاء',
    'accessFlags.CAN_EXPORT_CUSTOMERS_CSV': 'يمكنه تصدير بيانات العملاء وإضافة/خصم رصيد المحافظ الإلكترونية',
    'accessFlags.CAN_FORCE_DEFAULT_CREDENTIALS_CHANGE': 'يمكنه إجبار العملاء الجدد على تغيير بياناتهم الافتراضية',
    'accessFlags.CAN_MANAGE_BO_USERS': 'يمكنه إدارة مستخدمي لوحة التحكم',
    'accessFlags.CAN_MANAGE_BRAND_EWALLET_OVERDRAFT':
        'يمكنه إدارة السحب على المكشوف المسموح به على مستوى العلامة التجارية',
    'accessFlags.CAN_MANAGE_CUSTOMER_EWALLET_OVERDRAFT': 'يمكنه إدارة السحب على المكشوف المسموح به على مستوى العميل',
    'accessFlags.CAN_ONLY_EDIT_PRICE_AND_PRODUCT_NAME': 'يمكنه تعديل السعر واسم المنتجات والخطوات المرتبطة فقط',
    'accessFlags.CAN_SYNC_SALES': 'يمكنه مزامنة المبيعات',
    'accessFlags.CAN_EDIT_TABLE_LAYOUT': 'يمكنه تعديل مخططات الطاولات',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE': 'يمكنه إنشاء طلبات بسعر مخصص',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE_FOR_ALL_PRODUCTS': 'يمكنه إنشاء طلبات بسعر مخصص لجميع المنتجات',
    'accessFlags.MENU_CATEGORY_CREATE_OR_DELETE': 'يمكنه إنشاء الفئات أو حذفها',
    'accessFlags.MENU_CATEGORY_EDIT': 'يمكنه تعديل الفئات',
    'accessFlags.MENU_CREATE_OR_DELETE': 'يمكنه إنشاء القوائم أو حذفها',
    'accessFlags.MENU_EDIT': 'يمكنه تعديل القوائم',
    'accessFlags.MENU_PRODUCT_CREATE_OR_DELETE': 'يمكنه إنشاء المنتجات أو حذفها',
    'accessFlags.MENU_PRODUCT_EDIT': 'يمكنه تعديل المنتجات',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_ONLY': 'تقييد التعديل على سعر المنتج فقط',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_BLOCKED_ONLY': 'منع تعديل سعر المنتج فقط',
    'accessFlags.MENU_STEP_CREATE_OR_DELETE': 'يمكنه إنشاء الخطوات أو حذفها',
    'accessFlags.MENU_STEP_EDIT': 'يمكنه تعديل الخطوات',
    'accessFlags.MENU_TAG_CREATE_OR_DELETE': 'يمكنه إنشاء الوسوم أو حذفها',
    'accessFlags.MENU_TAG_EDIT': 'يمكنه تعديل الوسوم',
    'accessFlags.CAN_CHANGE_OWN_PASSWORD': 'يمكنه تغيير كلمة مروره',
    'accessFlags.CAN_CANCEL_ORDER_WITH_CONTRA_ENTRY': 'يمكنه إلغاء طلب (قيد معاكس)',
    'accessFlags.CAN_CREATE_SKU': 'يمكنه إنشاء SKU',
    'accessFlagsGroups.customers': 'إدارة العملاء',
    'accessFlagsGroups.financial': 'الإدارة المالية / المحفظة الإلكترونية',
    'accessFlagsGroups.orders': 'إدارة الطلبات',
    'accessFlagsGroups.catalog': 'إدارة الكتالوج',
    'accessFlagsGroups.subsidies': 'الدعم والرسوم',
    'accessFlagsGroups.configuration': 'إعدادات المطعم',
    'accessFlagsGroups.administration': 'الإدارة والحساب',
    'accessFlagsGroups.others': 'صلاحيات أخرى',
    'accessFlagsSubsections.categories': 'الفئات',
    'accessFlagsSubsections.menus': 'القوائم',
    'accessFlagsSubsections.products': 'المنتجات',
    'accessFlagsSubsections.steps': 'الخطوات',
    'accessFlagsSubsections.tags': 'الوسوم',
    'accessFlagsControl.expandAll': 'توسيع الكل',
    'accessFlagsControl.collapseAll': 'طي الكل',
    'accessFlagsControl.permission': 'صلاحية',
    'accessFlagsControl.permissions': 'صلاحيات',
    'userRestaurants.noRestaurants': 'لا توجد مطاعم متاحة',
    'brandUsers.email': 'البريد الإلكتروني',
    'brandUsers.lastConnection': 'آخر اتصال',
    'brandUsers.login': 'تسجيل الدخول',
    'brandUsers.loginAs': 'تسجيل الدخول بصفتك',
    'brandUsers.loginAsBrandGroup': 'حساب متعدد العلامات التجارية (غير قابل للاتصال)',
    'brandUsers.newUser': '+ مستخدم جديد',
    'brandRestaurants.newRestaurant': '+ مطعم جديد',
    'brandRestaurants.create.restaurantInfo': 'معلومات المطعم',
    'brandRestaurants.create.restaurantName': 'اسم المطعم',
    'brandRestaurants.create.phone': 'رقم الهاتف',
    'brandRestaurants.create.address': 'العنوان',
    'brandRestaurants.create.locale': 'اللغة',
    'brandRestaurants.create.currency': 'العملة',
    'brandRestaurants.create.operationZone': 'منطقة التشغيل',
    'brandRestaurants.create.operationZone.skip': 'تخطي - التهيئة لاحقًا',
    'brandRestaurants.create.operationZoneConfigure': 'تهيئة منطقة التشغيل',
    'brandRestaurants.create.operationZone.selectProvider': 'اختر وضع الامتثال',
    'brandRestaurants.create.operationZone.currencyMismatch':
        'تستخدم هذه المنطقة عملة مختلفة عن عملة العلامة التجارية. علامة تجارية جديدة مطلوبة للعمل بهذه العملة.',
    'brandRestaurants.create.manager': 'المدير',
    'brandRestaurants.create.selectExistingUser': 'اختيار مستخدم موجود',
    'brandRestaurants.create.createNewUser': 'إنشاء مستخدم جديد',
    'brandRestaurants.create.skipManager': 'تخطي هذه الخطوة',
    'brandRestaurants.create.letUserChoosePassword': 'السماح للمستخدم باختيار كلمة مروره',
    'brandRestaurants.create.done.title': 'اكتمل الإعداد!',
    'brandRestaurants.create.done.message': 'أنت جاهز لتهيئة {name}',
    'brandRestaurants.create.done.configure': 'تهيئة',
    'user.create.title': 'إنشاء مستخدم جديد',
    'user.create.firstName': 'الاسم الأول',
    'user.create.lastName': 'اسم العائلة',
    'user.create.phone': 'رقم الهاتف',
    'user.create.email': 'البريد الإلكتروني',
    'user.create.password': 'كلمة المرور',
    'user.create.confirmPassword': 'تأكيد كلمة المرور',
    'user.create.letUserChoosePassword': 'السماح للمستخدم باختيار كلمة مروره',
    'user.create.error.phone.length': 'يجب أن يحتوي رقم الهاتف على 10 أرقام.',
    'user.create.error.phone.valid': 'هذا الرقم غير صحيح',
    'user.create.error.password.min': 'كلمة المرور غير صالحة (12 حرفًا كحد أدنى)',
    'user.create.error.passwordConfirm.sameAsPassword': 'يجب أن تكون كلمتا المرور متطابقتين',
    'brands.restaurantscount': 'عدد المطاعم',
    'brands.favorite': 'مفضّل',
    'brands.create': '+ علامة تجارية جديدة',
    'brands.form.title': 'إنشاء علامة تجارية جديدة',
    'brands.form.brandInfo': 'معلومات العلامة التجارية',
    'brands.form.brandInfo.title': 'اسم العلامة التجارية',
    'brands.form.selectUser': 'اختر مسؤول العلامة التجارية',
    'brands.form.selectUser.title': 'إنشاء مسؤول علامة تجارية',
    'brands.form.canals': 'اختر قنوات طلبات العلامة التجارية',
    'brands.form.canals.title': 'إدارة القنوات',
    'brands.form.brandName': 'الاسم',
    'brands.form.region': 'المنطقة واللغة',
    'brands.form.currency': 'العملة',
    'brands.form.firstName': 'الاسم الأول *',
    'brands.form.lastName': 'اسم العائلة *',
    'brands.form.phoneNumber': 'رقم الهاتف *',
    'brands.form.email': 'البريد الإلكتروني *',
    'brands.form.password': 'كلمة المرور *',
    'brands.form.confirmPassword': 'تأكيد كلمة المرور *',
    'brands.form.error.phone.valid': 'هذا الرقم غير صحيح',
    'brands.form.error.password.min': 'كلمة المرور غير صالحة (12 حرفًا كحد أدنى)',
    'brands.form.error.passwordConfirm.sameAsPassword': 'يجب أن تكون كلمتا المرور متطابقتين',
    'posPermissions.accessPermissions': 'صلاحيات الوصول',
    'posPermissions.otherPermissions': 'صلاحيات أخرى',
    'posPermissions.ACCESS_CATALOG_SCREEN': 'الكتالوج',
    'posPermissions.ACCESS_CUSTOMERS_SCREEN': 'العملاء',
    'posPermissions.ACCESS_CUSTOMISATION_SCREEN': 'الخيارات',
    'posPermissions.ACCESS_E_WALLET_SCREEN': 'E-Wallet',
    'posPermissions.ACCESS_MANAGE_CASH_FLOAT_SCREEN': 'الصندوق النقدي',
    'posPermissions.ACCESS_MANAGE_DISCOUNT_SCREEN': 'العروض الترويجية',
    'posPermissions.ACCESS_MANAGE_RUNNER_SCREEN': 'عمال التوصيل',
    'posPermissions.ACCESS_MANAGE_TABLES_SCREEN': 'مخطط الطاولات',
    'posPermissions.ACCESS_NEW_ORDER_SCREEN': 'طلب جديد',
    'posPermissions.ACCESS_ORDERS_FOLLOW_UP_SCREEN': 'متابعة الطلبات',
    'posPermissions.ACCESS_PARAMETER_SCREEN': 'الإعدادات',
    'posPermissions.ACCESS_PRINTER_SCREEN': 'الطابعات',
    'posPermissions.ACCESS_RAZ_SCREEN': 'التقارير',
    'posPermissions.ACCESS_TICKET_SCREEN': 'الإيصالات',
    'posPermissions.ACCESS_USER_SCREEN': 'المستخدمون',
    'posPermissions.APPLY_DISCOUNT': 'تطبيق عرض ترويجي',
    'posPermissions.CANCEL_ORDER': 'إلغاء الطلب',
    'posPermissions.CANCEL_VALIDATED_ORDER_ITEM': 'إلغاء منتج مؤكَّد من طلب',
    'posPermissions.CREATE_GROUP': 'إنشاء مجموعة',
    'posPermissions.CREATE_PRODUCT': 'إنشاء منتج',
    'posPermissions.DELETE_DEFAULT_PRINTER': 'حذف الطابعة الافتراضية',
    'posPermissions.DISCONNECT': 'قطع الاتصال بنقطة البيع',
    'posPermissions.ENTER_DISCOUNT_WHEN_PLACING_AN_ORDER': 'إدخال خصم عند تسجيل طلب',
    'posPermissions.EXPORT_ARCHIVE': 'تصدير الأرشيف',
    'posPermissions.FORCE_ORDER_SHIFT': 'فرض خدمة الطلب',
    'posPermissions.GENERATE_ARCHIVE': 'إنشاء الأرشيف الضريبي',
    'posPermissions.JUSTIFY_ORDERS': 'تبرير الطلبات',
    'posPermissions.LINK_A_BADGE': 'ربط شارة',
    'posPermissions.MODIFY_FEATURE_OPTIONS': 'تعديل الخيارات',
    'posPermissions.MODIFY_FUNCTION_FROM_GRID': 'تعديل وظيفة بالضغط المطوّل',
    'posPermissions.MODIFY_GROUP_FROM_GRID': 'تعديل مجموعة بالضغط المطوّل',
    'posPermissions.MODIFY_ORDER_ITEM_PRICE': 'تعديل سعر منتج في السلة',
    'posPermissions.MODIFY_PASSWORD': 'تعديل كلمة المرور',
    'posPermissions.MODIFY_PRODUCT_FROM_GRID': 'عرض بطاقة المنتج',
    'posPermissions.MODIFY_SKU_BILLING_CODE_PURCHASE_PRICE': 'تعديل كود المنتج والفوترة وسعر الفوترة',
    'posPermissions.MODIFY_PRODUCT_PRICE': 'تعديل السعر في بطاقة المنتج',
    'posPermissions.MODIFY_PRODUCT_OTHER_INFO': 'تعديل الخصائص الأخرى في بطاقة المنتج',
    'posPermissions.MODIFY_TICKET': 'تعديل الإيصال',
    'posPermissions.MODIFY_TICKET_GROUPS': 'تعديل مجموعات الإيصالات',
    'posPermissions.MODIFY_TICKET_ORDER_PLACES': 'تعديل نوع طلب الإيصالات',
    'posPermissions.MODIFY_TICKET_ORDER_STATUS': 'تعديل حالة طلب الإيصالات',
    'posPermissions.MODIFY_TICKET_QUANTITY': 'تعديل كميات الإيصالات',
    'posPermissions.MODIFY_VALIDATED_ORDER_ITEM': 'تعديل منتج مؤكَّد في طلب',
    'posPermissions.OFFER_PRODUCT_FOR_FREE': 'تقديم منتج مجانًا',
    'posPermissions.OPEN_CASH_DRAWER': 'فتح درج النقود',
    'posPermissions.PRINT_VALID_TICKET': 'طباعة الإيصالات المؤكَّدة',
    'posPermissions.REFUND_CLIENT': 'رد مبلغ لعميل',
    'posPermissions.REMOVE_PRODUCT_FROM_CATALOG': 'حذف منتج من الكتالوج',
    'posPermissions.REOPEN_ORDER': 'إعادة فتح طلب',
    'posPermissions.SEARCH_CLIENT': 'البحث عن عميل يدويًا',
    'posPermissions.SHOW_APPLY_PRICING_RULE_BUTTON': 'عرض زر الوجبة المجبرة في شاشة التمرير الجديد',
    'posPermissions.SYNC_ARCHIVE': 'مزامنة الأرشيف',
    'posPermissions.VIEW_AUDIT_TRAIL': 'عرض سجل التدقيق',
    'posPermissions.VIEW_FEATURE_OPTIONS': 'عرض الخيارات',
    'posPermissions.VIEW_ORDER_AUDIT': 'عرض تدقيقات الطلبات',
    'posPermissions.VIEW_REVENUE_IN_FOLLOW_UP': 'عرض رقم المبيعات في التقارير',
    'posPermissions.VIEW_TICKET_AUDIT': 'عرض تدقيقات الإيصالات',
    'posPermissions.VIEW_TICKET_TEMPLATE': 'عرض قوالب الإيصالات',
    'posPermissions.MODIFY_TICKET_PRINTER': 'تعديل طابعة الإيصالات',
    'posPermissions.VALIDATE_EPT_PAYMENT_OPERATIONS': 'التحقق من عمليات الدفع بالطرفية',
    'multiBrand.user': 'المستخدم',
    'badgeReader.empty': 'لم يُهيَّأ أي قارئ شارة',
    'badgeReader.notConfigured': 'يبدو أنه لا يوجد قارئ شارة مُهيَّأ لديك. يُرجى الانتقال إلى',
    'badgeReader.help': 'قسم المساعدة.',
    'badgeReader.create': 'إنشاء قارئ شارة',
    'badgeReader.table.title': 'قارئات الشارة',
    'badgeReader.table.name': 'اسم القارئ',
    'badgeReader.table.deviceUuid': 'UUID القارئ',
    'badgeReader.table.driver': 'تقنية القارئ',
    'badgeReader.table.driverConfigs': 'متغيرات التقنية',
    'badgeReader.table.readingConditions': 'قواعد القراءة',
    'badgeReader.table.keyboardLayout': 'Keyboard layout',
    'badgeReader.driverConfigs':
        'Baudrate = <b>{baudRate}</b> {br}Bits = <b>{dataBits}</b> {br}Parity = <b>{parity}</b> {br}Stop Bits = <b>{stopBits}</b>',
    'badgeReader.readingCondition.number': 'الشرط #{index}:',
    'badgeReader.readingCondition.stringLength': '• إذا كان الطول = {stringLength} حرفًا',
    'badgeReader.readingCondition.convertBefore.none': '• لا يتم إجراء أي تحويل',
    'badgeReader.readingCondition.convertBefore.hex-dec': '• يتم التحويل إلى أعداد عشرية = {stringLength}',
    'badgeReader.readingCondition.convertBefore.hex-ascii': '• يتم التحويل إلى ASCII = {stringLength}',
    'badgeReader.readingCondition.convertBefore.dec-hex': '• يتم التحويل إلى نظام ست عشري = {stringLength}',
    'badgeReader.readingCondition.convertBefore.remove-zero': '• يتم حذف الأصفار',
    'badgeReader.readingCondition.convertBefore.hex-inverter': '• يتم عكس الأحرف',
    'badgeReader.readingCondition.convertBefore.prefix': '• يتم إضافة بادئة بالحرف {prefix} حتى {substrLength} أحرف',
    'badgeReader.readingCondition.substrPositionStart': '• يتم القراءة من الحرف {substrPositionStart}',
    'badgeReader.readingCondition.substrLength': '• يتم قراءة {substrLength} حرفًا',
    'badgeReader.readingCondition.convertAfter.none': '• لا يتم تحويل هذه الأحرف {substrLength}',
    'badgeReader.readingCondition.convertAfter.hex-dec': '• يتم تحويل هذه الأرقام العشرية إلى {convertAfter}',
    'badgeReader.readingCondition.convertAfter.dec-hex': '• يتم تحويل هذه الأرقام الست عشرية إلى {convertAfter}',
    'badgeReader.readingCondition.convertAfter.hex-ascii': '• يتم تحويل هذه الأحرف ASCII إلى {convertAfter}',
    'badgeReader.readingCondition.convertAfter.remove-zero': '• يتم حذف الأصفار',
    'badgeReader.readingCondition.convertAfter.hex-inverter': '• يتم عكس هذه الأحرف {substrLength}',
    'badgeReader.delete.confirmation': 'هل أنت متأكد من رغبتك في الحذف؟',
    'badgeReader.delete.warning': 'تحذير',
    'badgeReader.cancel.confirmation': 'هل أنت متأكد من رغبتك في إلغاء التهيئة؟',
    'badgeReader.cancel.warning': 'تحذير',
    'badgeReader.driver.keyboard': 'إخراج لوحة المفاتيح',
    'badgeReader.driver.serial': 'البروتوكول التسلسلي (RS232)',
    'badgeReader.driver.toqla': 'Toqla',
    'badgeReader.keyboardLayout.QWERTY': 'QWERTY',
    'badgeReader.keyboardLayout.AZERTY': 'AZERTY',
    'badgeReader.convertion.none': 'بدون تحويل',
    'badgeReader.convertion.hex-dec': 'ست عشري إلى عشري',
    'badgeReader.convertion.hex-ascii': 'ست عشري إلى ASCII',
    'badgeReader.convertion.dec-hex': 'عشري إلى ست عشري',
    'badgeReader.step.information': 'إنشاء قارئ',
    'badgeReader.step.driverConfigs': 'متغيرات التقنية',
    'badgeReader.step.readingCondition': 'قواعد القراءة',
    'badgeReader.form.name': 'اسم القارئ',
    'badgeReader.form.deviceId': 'معرّف USB للقارئ',
    'badgeReader.form.deviceUuid': 'UUID القارئ',
    'badgeReader.form.driver': 'تقنية القارئ',
    'badgeReader.form.driverConfigBaudRate': 'Baudrate',
    'badgeReader.form.driverConfigDataBits': 'Bits',
    'badgeReader.form.driverConfigParity': 'Parity',
    'badgeReader.form.driverConfigStopBits': 'Stop Bits',
    'badgeReader.form.keyboardLayout': 'تخطيط لوحة المفاتيح',
    'badgeReader.form.readingCondition.order': 'الشرط رقم',
    'badgeReader.form.readingCondition.stringLength': 'الطول',
    'badgeReader.form.readingCondition.convertBefore': 'تحويل قبل؟',
    'badgeReader.form.readingCondition.substrPositionStart': 'البداية / البادئة',
    'badgeReader.form.readingCondition.substrLength': 'الطول',
    'badgeReader.form.readingCondition.convertAfter': 'تحويل بعد؟',
    'badgeReader.step.readingCondition.add': 'إضافة +',
    'badgeReader.form.convertion.none': 'معطّل',
    'badgeReader.form.convertion.hex-dec': 'Hex > Dec',
    'badgeReader.form.convertion.dec-hex': 'Dec > Hex',
    'badgeReader.form.convertion.remove-zero': 'حذف الأصفار',
    'badgeReader.form.convertion.qwerty-azerty': 'Qwerty > Azerty',
    'badgeReader.form.convertion.hex-inverter': 'Hexadecimal معكوس بت بت',
    'badgeReader.form.convertion.prefix': 'بادئة',
    'badgeReader.form.convertion.hex-ascii': 'Hex > ASCII',
    'posDevice.catalogHistory.title': 'سجل الكتالوجات',
    'posDevice.catalogHistory.table.hash': 'Hash',
    'posDevice.catalogHistory.table.date': 'تاريخ الإنشاء',
    'posDevice.catalogHistory.table.actions': 'الإجراءات',
    'posDevice.catalogHistory.button.download': 'تنزيل',
    'passwordUpdate.title': 'تحديث كلمة المرور',
    'passwordUpdate.currentPassword': 'كلمة المرور الحالية',
    'passwordUpdate.newPassword': 'كلمة المرور الجديدة',
    'passwordUpdate.confirmPassword': 'تأكيد كلمة المرور الجديدة',
    'passwordUpdate.update': 'حفظ',
    'passwordUpdate.passwordMismatch': 'كلمة المرور الجديدة وتأكيدها غير متطابقتين.',
    'passwordUpdate.passwordMinLength': 'يجب أن تحتوي كلمة المرور على 12 حرفًا على الأقل.',
    'passwordUpdate.success': 'تم تحديث كلمة المرور بنجاح',
    'notification.guestHierarchy.title': 'جديد',
    'notification.guestHierarchy.content': 'تطوّرت إعدادات هرمية الحسابات.',
    'notification.guestHierarchy.link': 'انقر لمعرفة المزيد',
    'guestHierarchyTraining.page1.title': 'مرحبًا بك في إدارة مسارات العملاء',
    'guestHierarchyTraining.page1.content':
        'تتيح إدارة مسارات العملاء ضبطًا دقيقًا لحسابات المستخدمين في لوحة التحكم (BO). تعتمد على هرمية <b>مجموعة → قسم → قسم فرعي</b> وتعيين <b>أنظمة التسعير</b> لهذه العناصر. يضمن هذا الهيكل إدارة محسّنة ومتسقة.',
    'guestHierarchyTraining.page2.title': 'الوصول إلى الهرمية',
    'guestHierarchyTraining.page2.content':
        'افتح تبويب <b>الهرمية</b> الجديد. تتيح هذه المساحة <b>إنشاء وتعديل</b> المجموعات والأقسام والأقسام الفرعية.',
    'guestHierarchyTraining.page3.title': 'إنشاء أو تعديل مجموعة',
    'guestHierarchyTraining.page3.content':
        '• انتقل إلى <b>الهرمية > المجموعات.</b> {br}• انقر على <b>"إنشاء مجموعة"</b> أو عدّل مجموعة قائمة. {br}• تمتلك المجموعة <b>تسمية فريدة</b> (1) {br}• حدد <b>أنظمة التسعير المسموح بها</b> للمستخدمين المرتبطين بهذه المجموعة (2)',
    'guestHierarchyTraining.page4.title': 'إنشاء أو تعديل قسم',
    'guestHierarchyTraining.page4.content':
        '• انتقل إلى <b>الهرمية > الأقسام.</b> {br}• انقر على <b>"إنشاء قسم"</b> أو عدّل قسمًا قائمًا. {br}• عيّن القسم لـ<b>مجموعة موجودة</b>. (1) {br}• التسمية الفريدة مطلوبة. (2) {br} • حدد <b>أنظمة التسعير المسموح بها</b> للمستخدمين المرتبطين بهذا القسم (3)',
    'guestHierarchyTraining.page5.title': 'إنشاء أو تعديل قسم فرعي',
    'guestHierarchyTraining.page5.content':
        '• انتقل إلى <b>الهرمية > الأقسام الفرعية.</b> {br}• انقر على <b>"إنشاء قسم فرعي"</b> أو عدّل قسمًا فرعيًا قائمًا. {br}• عيّن القسم الفرعي لـ<b>قسم موجود</b>. (1 و2) {br}• التسمية الفريدة مطلوبة. (3) {br} • حدد <b>أنظمة التسعير المسموح بها</b> للمستخدمين المرتبطين بهذا القسم الفرعي (4)',
    'guestHierarchyInfo.title': 'إنشاء مستخدم',
    'guestHierarchyInfo.content':
        'عند إنشاء مستخدم، تُصفَّى أنظمة التسعير المقترحة تلقائيًا بناءً على المجموعة أو القسم أو القسم الفرعي المختار.',
    'loyalty.features.title': 'الميزات المفعّلة',
    'loyalty.features.MultiRewardSelection': 'اختيار مكافآت متعددة',
    'loyalty.features.Promocode': 'أكواد ترويجية',
    'loyalty.features.Deals': 'العروض',
    'loyalty.features.PointPayment': 'الدفع بالنقاط',
    'splio.title': 'تكامل - ولاء Splio',
    'splio.integrationEnabled': 'التكامل مفعّل منذ {date}',
    'splio.description':
        'أدخل مفتاح API في الحقل التالي لربط برنامج Splio بمطعمك ومنتجات Innovorder.\nيمكن استرداد مفتاح API هذا من واجهة Splio الخاصة بك.',
    'splio.apiKey.placeholder': 'أدخل مفتاح API الخاص بـ Splio',
    'splio.apiKey': 'مفتاح API لـ Splio',
    'splio.programId': 'برنامج الولاء',
    'splio.allowCustomerRewardUsage': 'السماح للعملاء باستخدام المكافآت',
    'splio.formLink': 'روابط نموذج التسجيل',
    'splio.optIn': 'الموافقة على النشرة الإخبارية التسويقية',
    'splio.memberIdentifier': 'معرّف إنشاء الحساب',
    'splio.useCasualTone': 'تفعيل نبرة المخاطبة غير الرسمية',
    'splio.authenticationMethods': 'طرق المصادقة المسموح بها للولاء',
    'splio.registerMethods': 'طرق التسجيل المسموح بها للولاء',
    'splio.methods.email': 'البريد الإلكتروني',
    'splio.methods.phone': 'الهاتف',
    'splio.methods.externalId': 'معرّف الولاء',
    'splio.update.success': 'تم تحديث تكامل Splio بنجاح',
    'splio.subscriptionToMarketingNewsletter': 'الاشتراك في النشرة الإخبارية التسويقية',
    'splio.subscriptionToLoyaltyNewsletter': 'الاشتراك في النشرة الإخبارية للولاء',
    'splio.deleteModal.title': 'حذف تكامل Splio',
    'splio.deleteModal.text': 'هل أنت متأكد من رغبتك في حذف تكامل Splio؟',
    'splio.error.formLinkInvalid': 'رابط النموذج غير صالح',
    'splio.error.changeProvider': 'تكامل ولاء مُهيَّأ بالفعل لهذا المطعم، يُرجى حذفه أولًا',
    'pickupPoint.page.title': 'نقاط الاستلام',
    'pickupPoint.page.description': 'أنشئ وأدِر نقاط الاستلام الخاصة بك',
    'pickupPoint.action.create': 'إنشاء نقطة استلام',
    'pickupPoint.modal.createPickupPoint': 'إنشاء نقطة استلام',
    'pickupPoint.modal.editPickupPoint': 'تعديل نقطة استلام',
    'pickupPoint.modal.deletePickupPoint': 'حذف نقطة استلام',
    'pickupPoint.modal.delete.title': 'حذف نقطة استلام',
    'pickupPoint.modal.delete.description': 'هل أنت متأكد من رغبتك في حذف نقطة الاستلام "{name}"؟',
    'pickupPoint.modal.pickupPoint.name': 'الاسم',
    'pickupPoint.modal.pickupPoint.address': 'العنوان',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo': 'معلومات العنوان الإضافية',
    'pickupPoint.modal.pickupPoint.name.placeholder': 'اسم نقطة الاستلام',
    'pickupPoint.modal.pickupPoint.address.placeholder': 'عنوان نقطة الاستلام',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo.placeholder': 'معلومات العنوان الإضافية لنقطة الاستلام',
    'pickupPoint.modal.warn.shift.title': 'تحذير',
    'pickupPoint.modal.warn.shift.text':
        'تأكد من عدم وجود طلبات جارية قبل حذف نقطة الاستلام. بعد الحذف، لن تكون مرئية للعملاء وستُفقد الطلبات الجارية.',
    'pickupPoint.modal.warn.shift.button': 'مفهوم',
    'como.title': 'تكامل - ولاء Como',
    'como.description':
        'أدخل مفتاح API في الحقل التالي لربط برنامج Como بمطعمك ومنتجات Innovorder.\nيمكن استرداد مفتاح API هذا من واجهة Como الخاصة بك.',
    'como.apiKey': 'مفتاح API لـ Como',
    'como.integrationEnabled': 'التكامل مفعّل منذ {date}',
    'como.apiKey.placeholder': 'أدخل مفتاح API الخاص بـ Como',
    'como.formLink': 'روابط نموذج التسجيل',
    'como.useCasualTone': 'تفعيل نبرة المخاطبة غير الرسمية',
    'como.authenticationMethods': 'طرق المصادقة المسموح بها للولاء',
    'como.registerMethods': 'طرق التسجيل المسموح بها للولاء',
    'como.methods.email': 'البريد الإلكتروني',
    'como.methods.phone': 'الهاتف',
    'como.methods.externalId': 'معرّف الولاء',
    'como.error.formLinkInvalid': 'رابط النموذج غير صالح',
    'como.update.success': 'تم تحديث تكامل Como بنجاح',
    'como.deleteModal.title': 'حذف تكامل Como',
    'como.deleteModal.text': 'هل أنت متأكد من رغبتك في حذف تكامل Como؟',
    'como.error.changeProvider': 'تكامل ولاء مُهيَّأ بالفعل لهذا المطعم، يُرجى حذفه أولًا',
    'como.error.invalidApiKey': 'مفتاح API المُدخَل غير صالح.',
    'zerosix.title': 'تكامل - ولاء Zerosix',
    'zerosix.description':
        'أدخل مفتاح API في الحقل التالي لربط برنامج Zerosix بمطعمك ومنتجات Innovorder.\nيمكن استرداد مفتاح API هذا من واجهة Zerosix الخاصة بك.',
    'zerosix.apiKey': 'مفتاح API لـ Zerosix',
    'zerosix.integrationEnabled': 'التكامل مفعّل منذ {date}',
    'zerosix.apiKey.placeholder': 'أدخل مفتاح API الخاص بـ Zerosix',
    'zerosix.formLink': 'روابط نموذج التسجيل',
    'zerosix.useCasualTone': 'تفعيل نبرة المخاطبة غير الرسمية',
    'zerosix.authenticationMethods': 'طرق المصادقة المسموح بها للولاء',
    'zerosix.registerMethods': 'طرق التسجيل المسموح بها للولاء',
    'zerosix.methods.email': 'البريد الإلكتروني',
    'zerosix.methods.phone': 'الهاتف',
    'zerosix.methods.externalId': 'معرّف الولاء',
    'zerosix.error.formLinkInvalid': 'رابط النموذج غير صالح',
    'zerosix.update.success': 'تم تحديث تكامل Zerosix بنجاح',
    'zerosix.deleteModal.title': 'حذف تكامل Zerosix',
    'zerosix.deleteModal.text': 'هل أنت متأكد من رغبتك في حذف تكامل Zerosix؟',
    'zerosix.error.changeProvider': 'تكامل ولاء مُهيَّأ بالفعل لهذا المطعم، يُرجى حذفه أولًا',
    'zerosix.error.invalidApiKey': 'مفتاح API المُدخَل غير صالح.',
    'restaurantInfo.title': 'معلومات المطعم',
    'restaurantInfo.information.title': 'حول المطعم',
    'restaurantInfo.name': 'اسم المطعم',
    'restaurantInfo.address': 'عنوان المطعم',
    'restaurantInfo.contactName': 'اسم جهة الاتصال',
    'restaurantInfo.contactEmail': 'عنوان البريد الإلكتروني',
    'restaurantInfo.contactPhone': 'رقم الهاتف',
    'restaurantInfo.externalId': 'المعرّف الخارجي',
    'restaurantInfo.tag': 'وسم المطعم',
    'restaurantInfo.families': 'فئات المطعم',
    'restaurantInfo.searchFamilies': 'البحث عن فئة',
    'restaurantInfo.image': 'صورة المطعم',
    'restaurantInfo.legal.title': 'المعلومات القانونية',
    'restaurantInfo.legal.description':
        'تُستخدم هذه المعلومات لإنشاء الشروط العامة للبيع والإشعارات القانونية لقنوات الطلبات',
    'restaurantInfo.legal.socialReason': 'الاسم القانوني للشركة',
    'restaurantInfo.legal.organizationType': 'نوع المنظمة',
    'restaurantInfo.legal.capital': 'رأس المال الاجتماعي',
    'restaurantInfo.legal.commerceRegistryCity': 'مدينة التسجيل التجاري',
    'restaurantInfo.legal.siren': 'رقم Siren',
    'restaurantInfo.legal.taxNumber': 'رقم ضريبة القيمة المضافة',
    'restaurantInfo.legal.industryClassificationCode': 'كود NAF',
    'restaurantInfo.legal.publicationDirectorName': 'اسم مدير النشر',
    'restaurantInfo.legal.publicationDirectorFunction': 'وظيفة مدير النشر',
    'restaurantInfo.legal.webmasterName': 'اسم مشرف الويب',
    'restaurantInfo.legal.webmasterEmail': 'بريد إلكتروني مشرف الويب',
    'restaurantInfo.ewalletMinimum.title': 'إعداد الحد الأدنى لرصيد المحفظة الإلكترونية المسموح به في فحص الصينية',
    'restaurantInfo.ewalletMinimum.inputTitle': 'الحد الأدنى للمبلغ',
    'restaurantInfo.ewalletMinimum.caseZero': 'لعدم تعيين حد أدنى للشارة، أدخل 0 في الحقل ثم احفظ.',
    'restaurantInfo.delete.title': 'حذف المطعم',
    'restaurantInfo.delete.description': 'يوجد هذا المطعم منذ',
    'restaurantInfo.delete.button': 'حذف هذا المطعم',
    'restaurantInfo.save.error': 'حدث خطأ أثناء الحفظ، يُرجى المحاولة مجددًا.',
    'restaurantInfo.delete.error': 'حدث خطأ، يُرجى إعادة تهيئة الإعدادات.',
    'restaurantInfo.delete.confirmTitle': 'حذف المطعم',
    'restaurantInfo.delete.confirmDescription':
        'هل أنت متأكد من رغبتك في حذف هذا المطعم؟ هذا الإجراء لا يمكن التراجع عنه.',
    'restaurantInfo.schedule.title': 'أوقات الاستلام المسموح بها',
    'restaurantInfo.schedule.manualEdit': 'تعديل يدوي',
    'restaurantInfo.schedule.autoEdit': 'تعديل تلقائي',
    'restaurantInfo.schedule.autoEditDescription': 'يسمح بإنشاء فترات زمنية بسرعة.',
    'restaurantInfo.schedule.description':
        'يمكنك تهيئة أوقات استلام مختلفة لمطعمك. تتوافق هذه الفترات مع ساعات عمل مطعمك، وخلالها يمكن للعملاء استلام طلباتهم المنجزة عبر الإنترنت.',
    'restaurantInfo.schedule.open': 'مفتوح',
    'restaurantInfo.schedule.closed': 'مغلق',
    'restaurantInfo.schedule.day.mon': 'الإثنين',
    'restaurantInfo.schedule.day.tue': 'الثلاثاء',
    'restaurantInfo.schedule.day.wed': 'الأربعاء',
    'restaurantInfo.schedule.day.thu': 'الخميس',
    'restaurantInfo.schedule.day.fri': 'الجمعة',
    'restaurantInfo.schedule.day.sat': 'السبت',
    'restaurantInfo.schedule.day.sun': 'الأحد',
    'restaurantInfo.schedule.mass.startHour': 'وقت البداية',
    'restaurantInfo.schedule.mass.endHour': 'وقت النهاية',
    'restaurantInfo.schedule.mass.granularity': 'الفاصل الزمني',
    'restaurantInfo.schedule.mass.15min': '15 دقيقة',
    'restaurantInfo.schedule.mass.30min': '30 دقيقة',
    'restaurantInfo.schedule.mass.1h': 'ساعة واحدة',
    'restaurantInfo.schedule.mass.overwrite': 'استبدال الأوقات الحالية',
    'restaurantInfo.schedule.mass.apply': 'تطبيق',
    'restaurantInfo.schedule.mass.noDays': 'اختر يومًا واحدًا على الأقل.',
    'restaurantInfo.schedule.mass.midnight': 'منتصف الليل',
    'order.customer.loyalty.anonymous': 'مجهول {email}',
    'route.vatRatesMatrix': 'مرجعية ضريبة القيمة المضافة',
    'vatRatesMatrix.title': 'مرجعية ضريبة القيمة المضافة العالمية',
    'vatRatesMatrix.subtitle':
        'المصدر الموحّد للضريبة على جميع منتجات Innovorder. يتم تطبيق التعديلات تلقائيًا على المنتجات الجديدة.',
    'vatRatesMatrix.vatGroup': 'فئة ضريبة القيمة المضافة',
    'vatRatesMatrix.codeLabel': 'الكود',
    'vatRatesMatrix.eatIn': 'في المكان',
    'vatRatesMatrix.takeAway': 'للاصطحاب',
    'vatRatesMatrix.delivery': 'توصيل',
    'vatRatesMatrix.exportCsv': 'تصدير CSV',
    'vatRatesMatrix.exportError': 'حدث خطأ أثناء تصدير CSV. يُرجى المحاولة مجددًا.',
    'vatRatesMatrix.filterByZone': 'تصفية حسب المنطقة',
    'vatRatesMatrix.filterByGroup': 'تصفية حسب الفئة',
    'vatRatesMatrix.filterByMode': 'تصفية حسب الوضع',
    'vatRatesMatrix.loading': 'جارٍ التحميل...',
    'vatRatesMatrix.error': 'خطأ أثناء تحميل البيانات.',
    'vatRatesMatrix.family.FOOD': 'الغذاء',
    'vatRatesMatrix.family.NON_ALCOHOL': 'بدون كحول',
    'vatRatesMatrix.family.ALCOHOL': 'كحول',
    'vatRatesMatrix.family.NORMAL': 'عادي',
    'vatRatesMatrix.family.NONE': 'لا شيء',
    'route.promotionalBanners': 'اللافتات الترويجية',
    'promotionalBanner.page.title': 'إدارة اللافتات',
    'promotionalBanner.page.subtitle': 'أنشئ وأدِر لافتاتك الترويجية لعرضها على الكشك.',
    'promotionalBanner.page.emptyState': 'أنشئ لافتة ترويجية للترويج لمنتجاتك وفئاتك على الكشك.',
    'promotionalBanner.page.emptyStateCta': 'إنشاء لافتة',
    'promotionalBanner.page.noActiveMenu.title': 'لا توجد قائمة كشك نشطة',
    'promotionalBanner.page.noActiveMenu.desc': '👉 فعّل قائمة الكشك للوصول إلى إعدادات اللافتات.',
    'promotionalBanner.page.noActiveMenu.cta': 'إدارة قوائمي',
    'promotionalBanner.action.create': 'إنشاء لافتة',
    'promotionalBanner.action.edit': 'تعديل',
    'promotionalBanner.action.view': 'عرض',
    'promotionalBanner.action.delete': 'حذف',
    'promotionalBanner.action.activate': 'تفعيل',
    'promotionalBanner.action.deactivate': 'تعطيل',
    'promotionalBanner.table.listTitle': 'قائمة اللافتات الترويجية',
    'promotionalBanner.modal.createTitle': 'إنشاء لافتة',
    'promotionalBanner.modal.editTitle': 'تعديل اللافتة',
    'promotionalBanner.modal.viewTitle': 'عرض اللافتة',
    'promotionalBanner.modal.close': 'إغلاق',
    'promotionalBanner.modal.name': 'الاسم',
    'promotionalBanner.modal.channel': 'القناة',
    'promotionalBanner.modal.image': 'الصورة',
    'promotionalBanner.modal.linkType': 'نوع الرابط',
    'promotionalBanner.modal.linkTarget': 'الهدف',
    'promotionalBanner.modal.activateAndSave': 'تفعيل وحفظ',
    'promotionalBanner.modal.saveAsDraft': 'حفظ كمسودة',
    'promotionalBanner.modal.updateBanner': 'تحديث اللافتة',
    'promotionalBanner.modal.deactivateBanner': 'تعطيل اللافتة',
    'promotionalBanner.modal.imageSizeError': 'يجب ألا يتجاوز حجم الصورة 5 ميغابايت',
    'promotionalBanner.modal.nameHelper': 'هذا الاسم مرئي فقط في لوحة التحكم.',
    'promotionalBanner.modal.nameLabel': 'اسم اللافتة',
    'promotionalBanner.modal.channelLabel': 'القناة المستهدفة',
    'promotionalBanner.modal.channelKiosk': 'الكشك',
    'promotionalBanner.modal.channelKioskDesc': 'عرض اللافتة في بداية مسار الطلب على الكشك.',
    'promotionalBanner.modal.channelWeb': 'CEL',
    'promotionalBanner.modal.channelWebDesc': 'العرض في مسار الطلب عبر الإنترنت.',
    'promotionalBanner.modal.channelWebDisabled': 'قريبًا.',
    'promotionalBanner.modal.imageLabel': 'صورة اللافتة',
    'promotionalBanner.modal.imageSpecs': 'JPG, PNG, WebP · الحد الأقصى 5 ميغابايت · تنسيق 3:1',
    'promotionalBanner.modal.image.error.ratio': 'يجب أن يكون التنسيق 3:1',
    'promotionalBanner.modal.imageFileDescription': '{name} · 1920×500px',
    'promotionalBanner.modal.linkTypeLabel': 'نوع الرابط',
    'promotionalBanner.modal.linkNone': 'بدون رابط',
    'promotionalBanner.modal.linkNoneDesc': 'إعلامية وغير قابلة للنقر.',
    'promotionalBanner.modal.linkProduct': 'منتج',
    'promotionalBanner.modal.linkProductDesc': 'تعيد التوجيه إلى بطاقة المنتج عند النقر عليها.',
    'promotionalBanner.modal.linkCategory': 'فئة',
    'promotionalBanner.modal.linkCategoryDesc': 'تعيد التوجيه إلى الفئة عند النقر عليها.',
    'promotionalBanner.modal.activateBanner': 'تفعيل اللافتة',
    'promotionalBanner.modal.replace': 'استبدال',
    'promotionalBanner.modal.searchCategory': 'البحث عن فئة...',
    'promotionalBanner.modal.searchProduct': 'البحث عن منتج بالاسم أو SKU...',
    'promotionalBanner.table.name': 'الاسم',
    'promotionalBanner.table.status': 'الحالة',
    'promotionalBanner.table.source': 'المصدر',
    'promotionalBanner.table.linkType': 'نوع الرابط',
    'promotionalBanner.table.actions': 'الإجراءات',
    'promotionalBanner.table.sourceRestaurant': 'المطعم',
    'promotionalBanner.table.sourceBrand': 'العلامة التجارية',
    'promotionalBanner.table.linkNone': 'بدون رابط',
    'promotionalBanner.table.linkCategory': 'فئة',
    'promotionalBanner.table.linkProduct': 'منتج',
    'promotionalBanner.table.statusActive': 'نشط',
    'promotionalBanner.table.statusInactive': 'غير نشط',
    'promotionalBanner.table.linkDeleted': 'محذوف',
    'promotionalBanner.confirm.title': 'خدمة جارية حاليًا',
    'promotionalBanner.confirm.message': 'سيُعيد هذا الإجراء تحميل جميع الكشكيات ويقطع الطلبات الجارية.',
    'promotionalBanner.confirm.confirm': 'تأكيد',
    'promotionalBanner.confirm.cancel': 'إلغاء',
    'promotionalBanner.delete.title': 'حذف اللافتة',
    'promotionalBanner.delete.description': 'هل أنت متأكد من رغبتك في حذف هذه اللافتة؟',
    'promotionalBanner.confirm.message.bulk': 'سيُعيد هذا الإجراء تحميل كشكيات {count} مطاعم ويقطع الطلبات الجارية.',
    'promotionalBanner.action.duplicate': 'نسخ',
    'promotionalBanner.duplicate.fallback.title': 'تم نسخ اللافتة بدون رابط',
    'promotionalBanner.duplicate.fallback.product':
        'تم إنشاء نسخة من «{sourceName}» بدون رابط: لم يُعثر على SKU في قائمة الكشك النشطة.',
    'promotionalBanner.duplicate.fallback.category':
        'تم إنشاء نسخة من «{sourceName}» بدون رابط: لم يُعثر على الفئة في قائمة الكشك النشطة.',
    'promotionalBanner.duplicate.fallback.dismiss': 'مفهوم',
    'route.brand.promotionalBanners': 'اللافتات الترويجية',
    'brandPromotionalBanner.page.title': 'اللافتات الترويجية للعلامة التجارية',
    'brandPromotionalBanner.page.subtitle': 'هيّئ اللافتات وانشرها على مطاعم العلامة التجارية.',
    'brandPromotionalBanner.page.empty': 'لا توجد لافتات حتى الآن.',
    'brandPromotionalBanner.action.create': 'إنشاء لافتة',
    'brandPromotionalBanner.table.name': 'الاسم',
    'brandPromotionalBanner.table.status': 'الحالة',
    'brandPromotionalBanner.table.source': 'المصدر',
    'brandPromotionalBanner.table.link': 'SKU أو الفئة',
    'brandPromotionalBanner.table.activeRestaurants': '{count} مطاعم نشطة',
    'brandPromotionalBanner.table.actions': 'الإجراءات',
    'brandPromotionalBanner.modal.createTitle': 'إنشاء لافتة للعلامة التجارية',
    'brandPromotionalBanner.modal.editTitle': 'تعديل اللافتة',
    'brandPromotionalBanner.modal.name.label': 'اسم اللافتة',
    'brandPromotionalBanner.modal.image.label': 'الصورة',
    'brandPromotionalBanner.modal.image.hint': 'تنسيق 3:1، الحد الأقصى 5 ميغابايت',
    'brandPromotionalBanner.modal.image.error.ratio': 'يجب أن يكون التنسيق 3:1',
    'brandPromotionalBanner.modal.image.error.size': 'حجم الصورة يتجاوز 5 ميغابايت',
    'brandPromotionalBanner.modal.channel.label': 'القناة',
    'brandPromotionalBanner.modal.channel.comingSoon': 'قريبًا',
    'brandPromotionalBanner.modal.link.label': 'نوع الرابط',
    'brandPromotionalBanner.modal.link.none': 'بدون رابط',
    'brandPromotionalBanner.modal.link.product': 'منتج (SKU)',
    'brandPromotionalBanner.modal.link.category': 'فئة',
    'brandPromotionalBanner.modal.link.product.hint':
        'إذا لم يُعثر على SKU في قائمة الكشك النشطة لمطعم ما، ستُعرض اللافتة بدون رابط في ذلك المطعم.',
    'brandPromotionalBanner.modal.link.category.hint':
        'إذا لم يُعثر على الفئة في قائمة الكشك النشطة لمطعم ما، ستُعرض اللافتة بدون رابط في ذلك المطعم.',
    'brandPromotionalBanner.modal.restaurants.label': 'المطاعم المستهدفة',
    'brandPromotionalBanner.modal.restaurants.empty': 'اختر مطعمًا واحدًا على الأقل',
    'brandPromotionalBanner.modal.button.cancel': 'إلغاء',
    'brandPromotionalBanner.modal.button.saveDraft': 'حفظ كمسودة',
    'brandPromotionalBanner.modal.button.activate': 'تفعيل اللافتة',
    'brandPromotionalBanner.modal.button.deactivate': 'تعطيل اللافتة',
    'brandPromotionalBanner.modal.button.update': 'تحديث اللافتة',
    'brandPromotionalBanner.delete.title': 'حذف اللافتة؟',
    'brandPromotionalBanner.delete.message': 'ستُزال اللافتة من جميع المطاعم المرتبطة بها.',
    'brandPromotionalBanner.carousel.title': 'مدة العرض بين لافتتين',
    'brandPromotionalBanner.carousel.description': 'حدد وقت العرض بين لافتتين نشطتين.',
    'brandPromotionalBanner.carousel.helper': 'وقت الانتظار بين عرض لافتتين نشطتين.',
    'brandPromotionalBanner.carousel.seconds': 'ثواني',
    'brandPromotionalBanner.carousel.save': 'حفظ',
    'brandPromotionalBanner.carousel.saved': 'تم تحديث المدة',
    'brandPromotionalBanner.carousel.help':
        'ستُطبَّق هذه المدة على جميع مطاعم العلامة التجارية عند إعادة تحميل الكشكيات.',
    'brandPromotionalBanner.modal.restaurants.ineligible.noChannel': 'هذا المطعم لا يملك كشكًا مفعّلًا.',
    'brandPromotionalBanner.modal.restaurants.ineligible.noMenu': 'هذا المطعم لا يملك قائمة كشك نشطة.',
};

export default translationAr;
